import { getAgent } from "@/api/index";
import sha1 from "sha1";
// 下载文件
export function downloadFile(url, name) {
  var a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.style.display = "none";
  a.click();
  document.body.removeChild(a);
}
export function getNewDate() {
  // 获取当前日期
  var today = new Date();

  // 计算往前推30天后的日期
  var prevDate = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
  let preDate = `${prevDate.getFullYear()}-${prevDate.getMonth() +
    1}-${prevDate.getDate()} 00:00:00`;
  let nowDate = `${today.getFullYear()}-${today.getMonth() +
    1}-${today.getDate()} 23:59:59`;
  return [preDate, nowDate];
  // 输出往前推30天的日期
  console.log(
    prevDate.getFullYear() +
    "-" +
    (prevDate.getMonth() + 1) +
    "-" +
    prevDate.getDate()
  );
}
export function downloadFileByHttp(url, name) {
  var request = new XMLHttpRequest();
  request.responseType = "blob";
  let fileUrl = url; // 文件路径
  request.open("GET", fileUrl);
  request.onload = function () {
    var url = window.URL.createObjectURL(this.response);
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
  };
  request.send();
}
export const birthData = [
  {
    value: "01",
    label: "1月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "02",
    label: "2月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
    ],
  },
  {
    value: "03",
    label: "3月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "04",
    label: "4月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
    ],
  },
  {
    value: "05",
    label: "5月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "06",
    label: "6月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
    ],
  },
  {
    value: "07",
    label: "7月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "08",
    label: "8月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "09",
    label: "9月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
    ],
  },
  {
    value: "10",
    label: "10月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
  {
    value: "11",
    label: "11月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
    ],
  },
  {
    value: "12",
    label: "12月",
    children: [
      {
        value: "01",
        label: "1号",
      },
      {
        value: "02",
        label: "2号",
      },
      {
        value: "03",
        label: "3号",
      },
      {
        value: "04",
        label: "4号",
      },
      {
        value: "05",
        label: "5号",
      },
      {
        value: "06",
        label: "6号",
      },
      {
        value: "07",
        label: "7号",
      },
      {
        value: "08",
        label: "8号",
      },
      {
        value: "09",
        label: "9号",
      },
      {
        value: "10",
        label: "10号",
      },
      {
        value: "11",
        label: "11号",
      },
      {
        value: "12",
        label: "12号",
      },
      {
        value: "13",
        label: "13号",
      },
      {
        value: "14",
        label: "14号",
      },
      {
        value: "15",
        label: "15号",
      },
      {
        value: "16",
        label: "16号",
      },
      {
        value: "17",
        label: "17号",
      },
      {
        value: "18",
        label: "18号",
      },
      {
        value: "19",
        label: "19号",
      },
      {
        value: "20",
        label: "20号",
      },
      {
        value: "21",
        label: "21号",
      },
      {
        value: "22",
        label: "22号",
      },
      {
        value: "23",
        label: "23号",
      },
      {
        value: "24",
        label: "24号",
      },
      {
        value: "25",
        label: "25号",
      },
      {
        value: "26",
        label: "26号",
      },
      {
        value: "27",
        label: "27号",
      },
      {
        value: "28",
        label: "28号",
      },
      {
        value: "29",
        label: "29号",
      },
      {
        value: "30",
        label: "30号",
      },
      {
        value: "31",
        label: "31号",
      },
    ],
  },
];
export const areaOptions = [
  {
    text: "北京市",
    value: "1EE0E22D-F5F7-4312-B22F-564BB51822F8",
    children: [
      {
        value: "4FEF2D76-1D27-4497-93B2-52B8D1179721",
        text: "北京市",
        children: [
          {
            value: "35536CF0-A111-481B-95AF-8972D4CB351F",
            text: "宣武区",
          },
          {
            value: "40456687-A170-4380-98EB-D3E89B16A8DA",
            text: "大兴区",
          },
          {
            value: "47ED56B5-E90A-4E13-9221-8C95D3E130E4",
            text: "密云县",
          },
          {
            value: "5940949A-0458-419A-B998-320B3B174B1B",
            text: "朝阳区",
          },
          {
            value: "71892820-FE78-48F5-88F1-2FF0C61E1CBE",
            text: "延庆县",
          },
          {
            value: "94754C08-8270-4D1F-B77C-371645776AEB",
            text: "西城区",
          },
          {
            value: "954CA4B4-8921-4295-8754-86708FDD09EE",
            text: "东城区",
          },
          {
            value: "B6EDBCFB-FE23-4EF5-A194-004DCD5D3A12",
            text: "房山区",
          },
          {
            value: "BA2C53A1-6D39-4EB8-BAFE-4024387D7041",
            text: "昌平区",
          },
          {
            value: "BC715D62-8AF0-4180-9CAF-A60D231AC712",
            text: "门头沟区",
          },
          {
            value: "BD325AD9-3C25-4623-BD9E-65AE2A378DD8",
            text: "崇文区",
          },
          {
            value: "CAD776BF-8289-4B7E-86EB-B906D98492CE",
            text: "通州区",
          },
          {
            value: "CAFD5D6C-5F98-4686-A86F-2A1BBF8EFE45",
            text: "石景山区",
          },
          {
            value: "E168AB1C-2D8E-4C7C-9C8A-3CE06659ED6E",
            text: "平谷区",
          },
          {
            value: "EC4A013D-D009-4EE6-9EA2-7B19F9D2A9B2",
            text: "顺义区",
          },
          {
            value: "F535D72D-D0DD-4334-A471-A0D5A5E14D0D",
            text: "怀柔区",
          },
          {
            value: "F71EC1E2-FB5A-4D0B-A64E-8C1FE314235E",
            text: "丰台区",
          },
          {
            value: "F751D9C4-812B-48E0-9797-5E377854ADD2",
            text: "海淀区",
          },
        ],
      },
    ],
  },
  {
    text: "天津市",
    value: "C348D5E7-521A-4989-A15C-87354C4506E3",
    children: [
      {
        value: "1923E60B-045C-4145-ACC0-CED796B2DD94",
        text: "天津市",
        children: [
          {
            value: "2B2F9738-F123-4B92-801A-1B5CF259717A",
            text: "宁河县",
          },
          {
            value: "2CCFC136-D1E3-4A11-AC5C-2EFF2783286D",
            text: "宝坻区",
          },
          {
            value: "36096FE4-221A-4598-BB21-43A7F7F27D3B",
            text: "北辰区",
          },
          {
            value: "43638A4C-4786-49D6-B952-0A17426B38E8",
            text: "河东区",
          },
          {
            value: "4E50A325-E905-4841-9C3B-D7D40FE54170",
            text: "静海县",
          },
          {
            value: "605EA9BF-F2C7-4D2A-875B-139A608A047C",
            text: "武清区",
          },
          {
            value: "827F5E5F-02B9-4D77-BB0E-529499FBA1DB",
            text: "汉沽区",
          },
          {
            value: "89C876E7-E15F-4437-B855-D81FB0E47731",
            text: "西青区",
          },
          {
            value: "8E4E70B3-2DB3-4CE6-A4E3-B22D7E7A07F2",
            text: "蓟县",
          },
          {
            value: "99568893-C15F-47ED-9226-161EA97E823C",
            text: "塘沽区",
          },
          {
            value: "A3498E70-95F5-478A-8AF5-D3C7029C4FB3",
            text: "东丽区",
          },
          {
            value: "B5434614-4C67-4C4B-A372-ED1D4B54360C",
            text: "南开区",
          },
          {
            value: "BA0B6C2D-49D6-41AC-AF51-B9E674710FE6",
            text: "大港区",
          },
          {
            value: "C228C955-275E-4181-9AD2-DB7373FBD18E",
            text: "红桥区",
          },
          {
            value: "E6A96372-3886-41DA-85E8-D4F265797167",
            text: "和平区",
          },
          {
            value: "EA948C7F-4DCE-47FA-B3CF-8B1C85388358",
            text: "河西区",
          },
          {
            value: "F24EB0E4-4780-4BC9-8A55-C22E181CDC0A",
            text: "津南区",
          },
          {
            value: "F28ECB21-D167-4A94-8BB6-F589BAB176E8",
            text: "河北区",
          },
        ],
      },
    ],
  },
  {
    text: "河北省",
    value: "DB260897-9ABB-4F67-9A20-669AAA2BD1BD",
    children: [
      {
        value: "01536D91-677F-4E23-A568-A096CFF56C12",
        text: "廊坊市",
        children: [
          {
            value: "1AD1FA70-D00E-4447-A5D3-D1CDBC8D7D89",
            text: "三河市",
          },
          {
            value: "398D2EF0-E4F2-4210-A1C2-390E235B5306",
            text: "永清县",
          },
          {
            value: "3CE46AA9-C1A2-432E-98A4-0B4C3B094087",
            text: "固安县",
          },
          {
            value: "4BBAE042-9123-4ADD-B70D-4781FF5C01EB",
            text: "安次区",
          },
          {
            value: "4E014EF9-9E51-4C95-8ABC-6761477843B3",
            text: "大厂回族自治县",
          },
          {
            value: "6D7D9EA5-42F8-429D-A9CB-F1354E51C7E3",
            text: "广阳区",
          },
          {
            value: "8B5AB9FA-558E-4593-911A-833B44F49D0C",
            text: "大城县",
          },
          {
            value: "91E86484-5101-43A8-A998-B8E970A9F824",
            text: "香河县",
          },
          {
            value: "98AC760D-B24C-470D-8D42-176F2B644C60",
            text: "文安县",
          },
          {
            value: "DCEFB208-A5F4-4A61-B6E6-382A29676C34",
            text: "霸州市",
          },
        ],
      },
      {
        value: "021AABE1-FDF8-44DD-AB42-F4C2A8A0BAF1",
        text: "秦皇岛市",
        children: [
          {
            value: "08489C6B-7E09-4D01-87E1-984D578F0A6A",
            text: "山海关区",
          },
          {
            value: "1BD27AA9-C925-4AB0-BEFB-15DFB9AF7A35",
            text: "抚宁县",
          },
          {
            value: "28E65508-C6C5-449F-B517-CF47E4345AF8",
            text: "经济技术开发区",
          },
          {
            value: "388FC3BD-AC18-4C2F-AFEB-E55EF5DA375D",
            text: "青龙满族自治县",
          },
          {
            value: "57358E08-449F-45B1-8CE9-2236E1FEB6C9",
            text: "卢龙县",
          },
          {
            value: "74ECB2FE-5C34-48A3-BF0F-FB871C301039",
            text: "昌黎县",
          },
          {
            value: "81FF381A-2850-49AE-920A-A1D1D3008A74",
            text: "海港区",
          },
          {
            value: "A5BBB42B-F8D0-4CD9-B5BA-CEDFEE55953A",
            text: "北戴河区",
          },
        ],
      },
      {
        value: "0A5690EB-6055-4452-B32A-495B1FBB2EDF",
        text: "张家口市",
        children: [
          {
            value: "009503B0-0E7F-40CA-9CB0-60BF6CF0281B",
            text: "尚义县",
          },
          {
            value: "068EBA35-0DC6-4F53-A28B-D8A0DCEF19FF",
            text: "怀来县",
          },
          {
            value: "101C2068-A0C5-4CFC-9D2D-8E4C47899815",
            text: "万全县",
          },
          {
            value: "25CE664B-F418-429D-86F8-501B2ECD84F3",
            text: "崇礼县",
          },
          {
            value: "3ACD158B-11FC-4BC3-9835-E6E0F0E1CEFC",
            text: "桥西区",
          },
          {
            value: "4C0CDEE0-EF2B-4DFA-9AEF-2B8AFEF79E56",
            text: "桥东区",
          },
          {
            value: "59EEF4C6-C1C7-4A3C-9164-9B8E5E4BBB1E",
            text: "涿鹿县",
          },
          {
            value: "77F9A7E2-BD6C-48B8-860A-677C70324BBA",
            text: "下花园区",
          },
          {
            value: "8818F3D9-B97D-4483-8A68-C1C31B72C408",
            text: "康保县",
          },
          {
            value: "90BF9D8F-2854-4EC7-8223-11A2B3B36D74",
            text: "张北县",
          },
          {
            value: "D4D8E26A-4A46-4195-93E6-27E6B0A26B79",
            text: "蔚县",
          },
          {
            value: "D617304F-C1FD-4723-99BB-4B2894B52E18",
            text: "阳原县",
          },
          {
            value: "E5D126CE-3B1C-4BC2-81F9-8895359F1E9D",
            text: "宣化区",
          },
          {
            value: "F09283FC-1EE5-46B8-8896-86FB688322E2",
            text: "宣化县",
          },
          {
            value: "F6F315AE-0270-44EF-AC06-0D1260FFB4B4",
            text: "赤城县",
          },
          {
            value: "FF408D23-305F-418D-BEC7-4DFBE50AE089",
            text: "沽源县",
          },
          {
            value: "FF858556-5800-4188-8D50-AB7243916524",
            text: "怀安县",
          },
        ],
      },
      {
        value: "2804E2B9-1262-4326-95D2-6537468EE583",
        text: "沧州市",
        children: [
          {
            value: "14FB86D9-2122-437C-AE34-C3A0263B8142",
            text: "东光县",
          },
          {
            value: "28CE28AA-3AC1-4C1E-9557-20CDAC7B9BB4",
            text: "海兴县",
          },
          {
            value: "2B8697EE-5358-483C-A4B9-51FA83DBACA3",
            text: "黄骅市",
          },
          {
            value: "38A1A37F-9CDA-445F-BE68-13A5774C735F",
            text: "运河区",
          },
          {
            value: "418DDE9C-90F0-4647-9330-F09A57445B05",
            text: "沧县",
          },
          {
            value: "6809FD22-CFFC-4B59-8A74-F96AC1324B16",
            text: "泊头市",
          },
          {
            value: "695E4431-CD23-4180-A5F5-55844EF2AD68",
            text: "河间市",
          },
          {
            value: "69D0E35D-0731-47CC-A799-E17194A4EF9A",
            text: "新华区",
          },
          {
            value: "704D90FC-E80F-4333-82E9-80F78B0DA88E",
            text: "吴桥县",
          },
          {
            value: "7BB8995D-1AAB-4200-8E6F-C2B59A54CA3C",
            text: "盐山县",
          },
          {
            value: "AD45F1EE-C708-4062-83C7-0EF681BD5A91",
            text: "肃宁县",
          },
          {
            value: "D0003AC3-3F61-4CD9-B137-9228219A5C42",
            text: "孟村回族自治县",
          },
          {
            value: "D6D9B255-9A3A-46FD-B378-B8124BE2E4ED",
            text: "南皮县",
          },
          {
            value: "DCC8BBD7-08B2-4D3F-935D-AF66D6E4A2F0",
            text: "青县",
          },
          {
            value: "E86C7108-C10A-42E4-A1C0-8A13ACD3DD4D",
            text: "献县",
          },
          {
            value: "EFE2F070-436C-4729-81B6-13C85CEFAA49",
            text: "任丘市",
          },
        ],
      },
      {
        value: "97B6E5D1-34C9-4910-BA1E-690E6DA2762A",
        text: "承德市",
        children: [
          {
            value: "00E651C7-96B0-428F-BA56-E500289424A1",
            text: "滦平县",
          },
          {
            value: "02A991B3-1E85-4C2B-A92F-CECACA5C0128",
            text: "双滦区",
          },
          {
            value: "0930CFD5-6E22-4049-A856-4ECB578D49E5",
            text: "宽城满族自治县",
          },
          {
            value: "3B867075-FBFD-411E-94A0-6050F51E743A",
            text: "鹰手营子矿区",
          },
          {
            value: "6E7154C1-1D64-4D18-8C88-BCE86872CC96",
            text: "围场满族蒙古族自治县",
          },
          {
            value: "7B3D4CDB-D86E-4445-8B70-2005BA56081F",
            text: "丰宁满族自治县",
          },
          {
            value: "95BBE565-9D34-4BD9-B70A-0EDB31CF7839",
            text: "隆化县",
          },
          {
            value: "CFB0D878-855C-465A-812F-C3A12FB3C582",
            text: "平泉县",
          },
          {
            value: "D4A09F7A-26BF-42E9-899E-D03C7EF03E3D",
            text: "承德县",
          },
          {
            value: "D4C6E928-5FC1-4CD8-AF9A-E4BE8B123552",
            text: "兴隆县",
          },
          {
            value: "D79F2CAA-2D91-48B1-84CE-5BD25513215F",
            text: "双桥区",
          },
        ],
      },
      {
        value: "9F2F1711-0C51-4C65-BE2C-F2811A2005F5",
        text: "石家庄市",
        children: [
          {
            value: "00EC1D70-90BB-44A1-B10C-CD101F049D36",
            text: "辛集市",
          },
          {
            value: "1789DD49-198C-4AA4-8203-550616AB7FF2",
            text: "桥西区",
          },
          {
            value: "196AB498-ED79-40BF-A48D-5D661A6D0DD9",
            text: "灵寿县",
          },
          {
            value: "377F04C1-69BC-46A0-A7B8-F4CEFB1D0E5C",
            text: "新乐市",
          },
          {
            value: "37DB38A4-E018-473E-A5D7-CC653EC6546F",
            text: "井陉矿区",
          },
          {
            value: "68241FF7-D97D-4180-A944-73D5EC8E48EC",
            text: "高邑县",
          },
          {
            value: "6A48A860-27E6-4FE4-A54C-30749D69A378",
            text: "晋州市",
          },
          {
            value: "6D6F6835-8F73-410B-8872-BCBD22E9C5F3",
            text: "赵县",
          },
          {
            value: "6E98DDFE-7365-44AF-9C1C-9BA46DDCF2F1",
            text: "元氏县",
          },
          {
            value: "784D91EB-D8C8-4A1E-9386-19737D9C1D60",
            text: "栾城县",
          },
          {
            value: "7AA85BB3-6D97-45C6-A6A8-CA9190280AA2",
            text: "平山县",
          },
          {
            value: "857A9DE1-F9F8-4E5D-9AEF-2C78D681F65F",
            text: "井陉县",
          },
          {
            value: "87FFCFD1-F4A0-4D64-9DE9-2BDF9B675654",
            text: "鹿泉市",
          },
          {
            value: "8EADC44F-D777-4F9A-B4FA-8F009D43713C",
            text: "深泽县",
          },
          {
            value: "900012F5-7610-4515-9020-6C122CD332CF",
            text: "长安区",
          },
          {
            value: "AF992E9D-6EE6-4B54-A81B-40F959048FBB",
            text: "赞皇县",
          },
          {
            value: "BFC9E7B3-C5F7-4FE8-8BF3-4A29136397EB",
            text: "正定县",
          },
          {
            value: "E5ED665B-F3FD-44FA-9E91-F0F29A05B13F",
            text: "新华区",
          },
          {
            value: "E81C0859-919E-4D5A-A3FF-812F1F46E696",
            text: "行唐县",
          },
          {
            value: "EFDF634A-5BC5-409D-A753-10DC915AF43A",
            text: "藁城市",
          },
          {
            value: "F45B4064-1358-4DDE-9113-C8830C2FD535",
            text: "桥东区",
          },
          {
            value: "FA4EF4AB-908D-4369-B1DC-6FC40C2B02A9",
            text: "无极县",
          },
          {
            value: "FEA33237-3819-448D-B7E4-F9E03BD85EC1",
            text: "裕华区",
          },
        ],
      },
      {
        value: "C68D57AA-BAB8-4B1A-8829-FAAAC3076B93",
        text: "衡水市",
        children: [
          {
            value: "01ED1A0B-F23C-48BD-A8DC-2B95B693D424",
            text: "武强县",
          },
          {
            value: "0879D9DC-2551-4778-AE71-BF48A9DB4246",
            text: "安平县",
          },
          {
            value: "7EC62129-7922-4EB9-8266-0C37657BB162",
            text: "冀州市",
          },
          {
            value: "9E824EE9-5899-4D74-8E43-25D541F03423",
            text: "故城县",
          },
          {
            value: "AA1BE122-2FB6-4405-9155-237DE84CA431",
            text: "景县",
          },
          {
            value: "ABEEE686-B46F-4538-8D13-7F4A3792691E",
            text: "武邑县",
          },
          {
            value: "AD2483F3-7E8F-44CC-8009-04DA79A83876",
            text: "深州市",
          },
          {
            value: "C82EF4E1-4BB2-4F89-87B2-8B16309EC92C",
            text: "桃城区",
          },
          {
            value: "D30E4C5C-E0F6-445C-B450-D5C435E00B5D",
            text: "饶阳县",
          },
          {
            value: "E8DB5B43-7D1E-470E-824B-0690BBDB4E8D",
            text: "阜城县",
          },
          {
            value: "F68B614F-E069-44D2-AEB0-1DD7DA80553E",
            text: "枣强县",
          },
        ],
      },
      {
        value: "CDF8F449-A1A3-498B-BDB4-38FFEE2DCF29",
        text: "唐山市",
        children: [
          {
            value: "14F15893-1D88-4D2A-A40C-41E6619E5A11",
            text: "唐海县",
          },
          {
            value: "1FDE532D-87EE-4191-9464-E5E3C0977571",
            text: "路南区",
          },
          {
            value: "23F7B4E7-A2E4-4FCD-85AB-82C326D3DAC9",
            text: "路北区",
          },
          {
            value: "2B8D91E8-DAAE-4963-92A4-EC8F1969E5A4",
            text: "迁安市",
          },
          {
            value: "392845DA-C4F5-4367-B2EA-AC73FF976121",
            text: "滦南县",
          },
          {
            value: "5A3BB745-ACFC-4A87-BA65-0C07395F578A",
            text: "丰润区",
          },
          {
            value: "684207AB-E07F-4667-B37A-80574A8F97C8",
            text: "玉田县",
          },
          {
            value: "6A69D840-564E-4DBE-AA4D-F0377DD18FC7",
            text: "迁西县",
          },
          {
            value: "6CCA0BB3-B21C-426E-9C34-DFDC5AA36C25",
            text: "古冶区",
          },
          {
            value: "A52DDB7A-D8E9-4F6F-A616-095596C39AE7",
            text: "遵化市",
          },
          {
            value: "B634046E-2967-4D85-926D-21E834CE6142",
            text: "乐亭县",
          },
          {
            value: "BF432AF3-C22F-4B3E-8719-92C9210545A6",
            text: "丰南区",
          },
          {
            value: "F282B779-B5B7-4637-AD7A-E98D97F64F07",
            text: "开平区",
          },
          {
            value: "F47506EB-0381-4913-8A00-56EC17D38780",
            text: "滦县",
          },
        ],
      },
      {
        value: "D05461AE-D936-4500-B726-CB4A73FE15E7",
        text: "保定市",
        children: [
          {
            value: "07DA4DD2-B2F7-41D5-B533-ADEB1FB31D8D",
            text: "高碑店市",
          },
          {
            value: "0F03B363-6EBC-4F4E-871F-B5C15DF029FA",
            text: "易县",
          },
          {
            value: "11F88A10-DC5B-468C-BE7A-A0B8BFB51653",
            text: "唐县",
          },
          {
            value: "17906E28-DB45-4456-BB28-75F6F7455E10",
            text: "徐水县",
          },
          {
            value: "17C9EC52-8ED9-49F4-8C30-B00AC1FA48C9",
            text: "博野县",
          },
          {
            value: "1CEF3C70-7AF7-4277-A278-B438A8881C68",
            text: "曲阳县",
          },
          {
            value: "2574A579-3F72-46F5-9160-C7F3F7B8D9D8",
            text: "蠡县",
          },
          {
            value: "271C280E-427F-44D4-9187-F4C8F9DD70D4",
            text: "阜平县",
          },
          {
            value: "3A8917CE-CEE5-4048-8932-9EA9A47E591B",
            text: "望都县",
          },
          {
            value: "419564CB-1BF4-4200-A9C1-9E77BD5064D4",
            text: "涞水县",
          },
          {
            value: "501A4BF4-34B3-4501-B8B0-C1CED49EB551",
            text: "高阳县",
          },
          {
            value: "619764FF-877F-4817-92DC-0AE0B86E5BBB",
            text: "安国市",
          },
          {
            value: "62865E6B-F70D-4CA1-B8F9-CE7C32A02B0A",
            text: "满城县",
          },
          {
            value: "66C3F9B9-977A-42AA-A005-E8E22778A8EC",
            text: "容城县",
          },
          {
            value: "7F82A883-53F6-45B4-89E3-6189292BADEF",
            text: "清苑县",
          },
          {
            value: "818F1064-CFFD-42EC-B4DC-7F0F9F124534",
            text: "安新县",
          },
          {
            value: "82091090-BAEC-4E1F-92EA-111D5DC78D57",
            text: "涿州市",
          },
          {
            value: "9B943193-7F3C-4923-925D-837003B6F41F",
            text: "顺平县",
          },
          {
            value: "A10BFAA6-F535-498A-A2C8-A0E9B2C1CD72",
            text: "定兴县",
          },
          {
            value: "AA1D2E41-DA42-457A-B91E-FA215607618F",
            text: "北市区",
          },
          {
            value: "BFAF3CC5-D442-4DB8-9865-EE81438C72EF",
            text: "涞源县",
          },
          {
            value: "CB86D367-A04B-45C3-B231-001D30AAE517",
            text: "南市区",
          },
          {
            value: "D38D9BAD-F69E-48E9-B0FC-8E3104BB2CE7",
            text: "雄县",
          },
          {
            value: "DC7824F7-924B-4FFB-8837-7B896256A76D",
            text: "新市区",
          },
          {
            value: "EE2A1210-26EE-4E51-8810-7B661D68C380",
            text: "定州市",
          },
        ],
      },
      {
        value: "DAD82495-8303-4773-9878-3CB7BFDECE78",
        text: "邢台市",
        children: [
          {
            value: "005FE89B-5228-4746-9D32-228A0315B017",
            text: "平乡县",
          },
          {
            value: "0176143B-AC6A-4CE9-B06D-B5DD3FC6483A",
            text: "桥西区",
          },
          {
            value: "01CC1C36-79B5-44FA-B64B-6951EBCB5260",
            text: "威县",
          },
          {
            value: "0C8B5FF2-48CD-47FF-A383-AE53C7CD0582",
            text: "南和县",
          },
          {
            value: "1B6E9D47-FFD1-41CC-8972-AA8B48DC4824",
            text: "隆尧县",
          },
          {
            value: "272E7FDF-8DA3-4C18-A6F6-8A44AA84CB7A",
            text: "任县",
          },
          {
            value: "4068DE1C-ADA4-4812-9362-15A6795E9D9A",
            text: "新河县",
          },
          {
            value: "5AF0B224-DCC5-4E40-89C8-89AADB9004CF",
            text: "邢台县",
          },
          {
            value: "64DDFAEC-2581-4A20-AB2E-DD0508259EFE",
            text: "宁晋县",
          },
          {
            value: "70C9F8E5-E535-4AF3-8317-54D91D2CA078",
            text: "广宗县",
          },
          {
            value: "71B0BF6E-8365-4D15-9B7D-288C757B7EFB",
            text: "柏乡县",
          },
          {
            value: "76254D45-2218-48E8-9E3E-B7DFE3ED25F5",
            text: "内丘县",
          },
          {
            value: "7EA504C7-3776-41FB-B410-9BB58D64800F",
            text: "南宫市",
          },
          {
            value: "8C787FFD-0D28-4783-A759-F2CFE9614365",
            text: "临城县",
          },
          {
            value: "95BDB283-F388-4F44-8813-8385B4D15F0D",
            text: "清河县",
          },
          {
            value: "B8472032-B4AB-49E4-9ADF-D04788702F27",
            text: "桥东区",
          },
          {
            value: "BAB4375D-0AA2-43AC-BF5E-BF43FBFA2623",
            text: "临西县",
          },
          {
            value: "C1431162-E6DA-4A9F-AB45-9BD614EF1F2E",
            text: "沙河市",
          },
          {
            value: "C9CF0032-BF7A-4142-B7B9-DD0BE682F711",
            text: "巨鹿县",
          },
        ],
      },
      {
        value: "F6DE0814-5844-4EB9-B872-73C15FDA56E0",
        text: "邯郸市",
        children: [
          {
            value: "0E535D0A-9869-4FC2-85E3-20BC8421EF87",
            text: "丛台区",
          },
          {
            value: "1FC43198-916E-4AA0-A0E0-FA0C8CC501DE",
            text: "永年县",
          },
          {
            value: "476CAF42-1F44-4DBC-A16E-A096578D942C",
            text: "广平县",
          },
          {
            value: "4950B414-E3B1-436D-8123-E6AE9086E1CF",
            text: "邯郸县",
          },
          {
            value: "49DD355B-3DA1-461C-AC38-EA2168947B8B",
            text: "魏县",
          },
          {
            value: "575B2153-CFC2-4B9D-ACC3-41334BD7EB0B",
            text: "涉县",
          },
          {
            value: "5ADA5107-55B7-4E1C-AD09-A942C3CA0D6E",
            text: "曲周县",
          },
          {
            value: "6A8A1CF0-F3A5-4058-9C5B-6F11DB8DF1DB",
            text: "鸡泽县",
          },
          {
            value: "723ED1EA-5EEF-43D0-B6C4-CE5955D129C9",
            text: "磁县",
          },
          {
            value: "78E1F227-65D2-404E-B785-7F6CBF3005F0",
            text: "武安市",
          },
          {
            value: "84690DEF-E5F1-4EA0-BE21-5DDE4523B273",
            text: "肥乡县",
          },
          {
            value: "988DC0F3-D4C9-4FB5-8B2C-26A055314540",
            text: "峰峰矿区",
          },
          {
            value: "A9228CA5-D62C-4F54-AF19-A12EC88A9F6E",
            text: "馆陶县",
          },
          {
            value: "ACAB02DF-7C95-4643-ADC9-2DD6BBEB5884",
            text: "临漳县",
          },
          {
            value: "B99FADC0-C628-4E45-BFB5-7C4CE1922F90",
            text: "大名县",
          },
          {
            value: "C0AEA1D5-EEF1-41B4-85C5-64AABFCCA23B",
            text: "复兴区",
          },
          {
            value: "DBFD442D-1061-4AC9-BB03-FC2783C78BC0",
            text: "邱县",
          },
          {
            value: "DDDDCB12-C2E8-4E9A-B5C7-910FAB012A66",
            text: "邯山区",
          },
          {
            value: "F9A033EA-A545-4AEC-8B18-7D61525FFC99",
            text: "成安县",
          },
        ],
      },
    ],
  },
  {
    text: "山西省",
    value: "04589167-015A-43D1-935A-2975AEBA3468",
    children: [
      {
        value: "04A3F28A-6220-461D-8ACD-D64FC09604C9",
        text: "太原市",
        children: [
          {
            value: "00BAA918-C944-450C-87BA-C8F3533BFDF7",
            text: "杏花岭区",
          },
          {
            value: "156CF4F5-590B-47CB-A56C-C1EEB0B20EFF",
            text: "万柏林区",
          },
          {
            value: "2AB851FC-0A02-4131-A1C4-AD72D4465E9D",
            text: "尖草坪区",
          },
          {
            value: "8B18E591-0B93-46C3-8497-B038FEDE586D",
            text: "晋源区",
          },
          {
            value: "900B4DB6-27E6-47A5-9A86-6CB55C0DEB14",
            text: "阳曲县",
          },
          {
            value: "C79B581D-E715-4549-B834-1F3EC80CB51D",
            text: "小店区",
          },
          {
            value: "E2D6E999-9FAE-458E-B309-BE91506897E1",
            text: "娄烦县",
          },
          {
            value: "E952F350-DC99-480B-9D20-CC1C0EEE90F4",
            text: "清徐县",
          },
          {
            value: "EABA1078-9B95-4756-9644-9C81336FB6E7",
            text: "古交市",
          },
          {
            value: "F35EADDA-2340-4B41-9479-8612AB802288",
            text: "迎泽区",
          },
        ],
      },
      {
        value: "1C6B2729-2712-43D6-A1D6-942C5CC1DB07",
        text: "临汾市",
        children: [
          {
            value: "15EA2B50-BDB9-4CC4-B47F-51DFE7F4A99F",
            text: "翼城县",
          },
          {
            value: "31FE7859-9066-4817-8048-1BE8973CAFD8",
            text: "霍州市",
          },
          {
            value: "36CD3201-9D8D-42E7-A50C-B37BEB7B128A",
            text: "吉县",
          },
          {
            value: "375F9CE4-9EE8-4C57-B696-133AC803F048",
            text: "汾西县",
          },
          {
            value: "48C3E498-0599-4706-AE1D-A0A36AE556DE",
            text: "浮山县",
          },
          {
            value: "4DC4D51F-BBF0-456B-B8FF-046F6DFD9A1C",
            text: "襄汾县",
          },
          {
            value: "4FDF2B8F-9B0A-4DFE-8ADD-66B6B444C10D",
            text: "古县",
          },
          {
            value: "57FBD298-365A-4852-8F59-33BD7084F660",
            text: "蒲县",
          },
          {
            value: "5A80DC4F-6F46-4D51-A651-095511D679F5",
            text: "尧都区",
          },
          {
            value: "7D78C64E-8BDD-4AB7-97F8-6F8BF0AFFE78",
            text: "安泽县",
          },
          {
            value: "9BE3B7DB-802E-4B13-8FB2-249CE2FDB23A",
            text: "乡宁县",
          },
          {
            value: "ACB5699C-34D4-4875-BED5-ABBC9D66BBAB",
            text: "洪洞县",
          },
          {
            value: "B5EC0799-5F1C-4BBA-A620-1EE2892C3495",
            text: "大宁县",
          },
          {
            value: "B689D974-1C5A-4918-BF78-9F3013B5C82B",
            text: "曲沃县",
          },
          {
            value: "BA92B7E8-47A4-4B44-986E-79137B098C08",
            text: "永和县",
          },
          {
            value: "ED9697E2-BB68-4640-93E5-5D806DEA5FD8",
            text: "隰县",
          },
          {
            value: "F7956DAD-5934-4591-9595-A3B07A16D7D4",
            text: "侯马市",
          },
        ],
      },
      {
        value: "3126F68D-10E1-41A0-B446-9E4FBBF023E5",
        text: "晋中市",
        children: [
          {
            value: "0A4952D0-8668-45A4-90BF-F37C76C3FFA4",
            text: "寿阳县",
          },
          {
            value: "1369F470-9A93-45BC-8756-D1B9F12AD922",
            text: "太谷县",
          },
          {
            value: "76229795-B57C-45E7-91AC-C1EC69CCB694",
            text: "昔阳县",
          },
          {
            value: "838EF0E9-F349-4BC2-9FFC-E294D6914F70",
            text: "左权县",
          },
          {
            value: "9B41753F-E589-4649-AC96-B5C59C937EC0",
            text: "灵石县",
          },
          {
            value: "B4418974-0786-4AD2-968C-665C85AC9EFA",
            text: "介休市",
          },
          {
            value: "C6DC186B-851D-4E53-99AE-E958AE839DB8",
            text: "榆社县",
          },
          {
            value: "D302F090-AEB5-4522-ADA2-1BE25AE242B2",
            text: "榆次区",
          },
          {
            value: "D7285018-650B-4E0C-957F-1AAB5063247C",
            text: "平遥县",
          },
          {
            value: "DFDDFFD7-22A6-408D-999C-930B8A2FD10C",
            text: "祁县",
          },
          {
            value: "E41AD774-F98D-4BEA-887C-6D0850DAE143",
            text: "和顺县",
          },
        ],
      },
      {
        value: "3E81FE3E-09DE-47A2-BFDC-13126F346602",
        text: "忻州市",
        children: [
          {
            value: "0E07A992-3AB3-4E5C-9372-BDA9EE5179A8",
            text: "代县",
          },
          {
            value: "19EA6414-9132-4A4E-8229-EFABD5E1418C",
            text: "河曲县",
          },
          {
            value: "4CEBACDA-F7F6-4F86-B668-15F89B8ABA8F",
            text: "五寨县",
          },
          {
            value: "8A2EF5D7-5C12-46E2-BC8F-BB8CD85E9BE5",
            text: "宁武县",
          },
          {
            value: "8A69C66B-4ABE-4566-B61B-DBD9072722DD",
            text: "繁峙县",
          },
          {
            value: "93704DFA-E840-488A-98B0-280E821D5874",
            text: "神池县",
          },
          {
            value: "93999D85-33F0-4F50-95A3-A5A6269A24D3",
            text: "岢岚县",
          },
          {
            value: "AEA5AC3A-33F6-4ECD-B8C3-F33FDEC99F26",
            text: "原平市",
          },
          {
            value: "C23BAB12-B983-4F4F-997E-F14971469DF4",
            text: "忻府区",
          },
          {
            value: "C2AC6B0C-5D12-4481-878F-97B8F9619AD1",
            text: "保德县",
          },
          {
            value: "C98C2F71-C96F-436C-BB5B-1DB4AB59B36D",
            text: "定襄县",
          },
          {
            value: "CC5C3C93-D4BB-404E-B670-B2CA26FA8D6E",
            text: "偏关县",
          },
          {
            value: "EDE6EF74-BC83-4105-9031-192740920303",
            text: "五台县",
          },
          {
            value: "F52DB80E-DFC7-4C3B-B6AF-446153400463",
            text: "静乐县",
          },
        ],
      },
      {
        value: "478A2316-A877-438F-BB90-3ECF7A959CCD",
        text: "晋城市",
        children: [
          {
            value: "22FC2B16-A313-4340-BEFF-C0AD0C6B190C",
            text: "沁水县",
          },
          {
            value: "25A27AF2-53E4-48BB-A681-13C3CCF3B4DC",
            text: "城区",
          },
          {
            value: "A0FFD924-BC70-49A1-AD1D-66B3534B1701",
            text: "阳城县",
          },
          {
            value: "A303B584-9B79-4642-8F13-0BFD3B5065E6",
            text: "高平市",
          },
          {
            value: "C1E3113E-A769-416A-98A0-0E9BAE288E65",
            text: "陵川县",
          },
          {
            value: "E863A045-64F5-4299-A733-46A4E9727291",
            text: "泽州县",
          },
        ],
      },
      {
        value: "84D06CB5-CC1B-4D2C-BA35-05779C032CFD",
        text: "吕梁市",
        children: [
          {
            value: "073C648A-6BEE-44D8-9F2F-4CEF2B538C0A",
            text: "文水县",
          },
          {
            value: "1735AFA7-74A6-429E-A325-E14B475FEBE3",
            text: "孝义市",
          },
          {
            value: "23AC4DC3-5073-44BA-8963-7148B20250AC",
            text: "中阳县",
          },
          {
            value: "4CE13399-3558-4375-8875-FDFD17FF15AA",
            text: "汾阳市",
          },
          {
            value: "9096DF80-0A22-463C-BC2B-8BB6EF38C9D2",
            text: "临县",
          },
          {
            value: "921A679D-C766-4821-91A1-062A47F4E8AB",
            text: "交城县",
          },
          {
            value: "9BD86805-A1D5-4513-B87C-67EBBA18B262",
            text: "交口县",
          },
          {
            value: "B3F78B92-4777-4AF2-95FC-31CE0E376362",
            text: "方山县",
          },
          {
            value: "C590CE01-A19A-4DBC-938E-BD516B2B2269",
            text: "离石区",
          },
          {
            value: "CC9296F9-6328-40BB-81DC-DF835759745E",
            text: "柳林县",
          },
          {
            value: "D2714B83-7588-4E19-B965-F4902A7FC436",
            text: "岚县",
          },
          {
            value: "F8599D5A-03D6-478F-A6DC-C1348E0EB5AC",
            text: "兴县",
          },
          {
            value: "FF1DAEA6-ECD0-48FE-B48F-75CE88758665",
            text: "石楼县",
          },
        ],
      },
      {
        value: "8ABD8E58-D922-42DB-BE75-F3B92A260B15",
        text: "朔州市",
        children: [
          {
            value: "3EC857F1-DA29-4346-98A4-2C1456984A5D",
            text: "右玉县",
          },
          {
            value: "46CD4F25-EE87-4273-934D-F8885EFA94C0",
            text: "怀仁县",
          },
          {
            value: "568E6C61-BF89-4260-A1BD-0EE39DA334D9",
            text: "应县",
          },
          {
            value: "5FC4F320-707B-4CEA-9EB5-2B4A9727D24C",
            text: "山阴县",
          },
          {
            value: "7ECFE1BD-1EB5-4939-8B50-21E6E5858B23",
            text: "朔城区",
          },
          {
            value: "C934A8F4-E59A-441D-A0B5-96B71F6787F3",
            text: "平鲁区",
          },
        ],
      },
      {
        value: "9C2D43F3-D348-4B4F-8583-3C66524C8D10",
        text: "长治市",
        children: [
          {
            value: "1BF03BDB-EC2C-434A-B185-93C1E23EA4A5",
            text: "沁县",
          },
          {
            value: "3DE6017B-39BF-4F4A-97FB-8F57B3EB25C7",
            text: "沁源县",
          },
          {
            value: "4A50020B-0840-41AD-8238-965AF31CD66B",
            text: "长子县",
          },
          {
            value: "52BF2B93-6AFD-4916-803F-A3D64D4DC71D",
            text: "城区",
          },
          {
            value: "6D2B73E6-7D5C-448F-8BE5-669515E56184",
            text: "武乡县",
          },
          {
            value: "8008E1DB-C571-47A4-A957-AB846905610A",
            text: "黎城县",
          },
          {
            value: "99C48362-39D1-4446-BE3A-68408C3B4363",
            text: "屯留县",
          },
          {
            value: "A6E65570-607D-4C77-B3E5-708189F5538F",
            text: "潞城市",
          },
          {
            value: "C1097244-8AEB-40A0-9AA4-8D1F6266AE12",
            text: "长治县",
          },
          {
            value: "EB953DDE-EDBB-4893-B962-33568A244561",
            text: "平顺县",
          },
          {
            value: "EF4B5A0E-2DC4-4C1E-A1B5-4F6B0EA1EAFB",
            text: "郊区",
          },
          {
            value: "F34DDF7B-3314-468A-BA2F-583050E4E35D",
            text: "壶关县",
          },
          {
            value: "F8777397-F1B5-4FA8-BAC5-5AD79DF4E97C",
            text: "襄垣县",
          },
        ],
      },
      {
        value: "B9FBE544-7FDE-4ECC-9EBC-08A8581CDE7A",
        text: "阳泉市",
        children: [
          {
            value: "086D339D-7620-4D5B-A29A-3DE892217AE9",
            text: "郊区",
          },
          {
            value: "509277C9-4C5D-4553-900C-8494ECBD5AAB",
            text: "城区",
          },
          {
            value: "54571A80-2A36-4290-897B-27DF2A6A7363",
            text: "矿区",
          },
          {
            value: "6BA40C8E-39F4-4658-83DC-A545772855E4",
            text: "平定县",
          },
          {
            value: "B1DD82F2-1FA7-480F-9CFB-80266137BCAD",
            text: "盂县",
          },
        ],
      },
      {
        value: "D4DB25B1-57BB-4FA5-B4BE-62BCEB962909",
        text: "运城市",
        children: [
          {
            value: "1E961C76-9348-4CFE-BA7C-C9244EAB37BF",
            text: "闻喜县",
          },
          {
            value: "1F33058C-D19F-4AE1-9A24-33A70A898508",
            text: "新绛县",
          },
          {
            value: "214F49DA-107F-4825-A1BD-02415AC4B835",
            text: "稷山县",
          },
          {
            value: "312138AB-FA35-4288-9C9C-8FA110936F06",
            text: "芮城县",
          },
          {
            value: "3BA176B4-5F30-444E-A4CF-771E65D388F7",
            text: "平陆县",
          },
          {
            value: "53BA9D04-BFF1-4CBF-BCAB-60C790E19D4A",
            text: "垣曲县",
          },
          {
            value: "84A29E58-0F08-4F78-AA46-8AA3E1AF09D6",
            text: "永济市",
          },
          {
            value: "8A92C04F-9244-439E-AE1A-0D61BC5F7716",
            text: "河津市",
          },
          {
            value: "9841689E-283C-4985-9217-F142775A92D0",
            text: "万荣县",
          },
          {
            value: "A280D06F-3F20-4D01-A41B-87B7E62D4429",
            text: "盐湖区",
          },
          {
            value: "A5DEC2DF-531F-40C4-83E5-D0FFD1906BC0",
            text: "绛县",
          },
          {
            value: "CEEF93D4-5C98-463F-9C4D-9211AAD583AD",
            text: "临猗县",
          },
          {
            value: "D169F124-BD51-41F7-B993-64AAE6758393",
            text: "夏县",
          },
        ],
      },
      {
        value: "E34EFE00-4B42-4904-9F9E-D55F6E656447",
        text: "大同市",
        children: [
          {
            value: "05F47845-3BD4-4640-962C-AB11C74B14CE",
            text: "浑源县",
          },
          {
            value: "4775DE97-869D-4B4C-9DD3-606862093D3D",
            text: "广灵县",
          },
          {
            value: "6FB2D47E-7BBE-4AD7-B04B-CBE8B0A1B8DC",
            text: "矿区",
          },
          {
            value: "78916452-FF22-4C25-9164-0AE7E8B69DBA",
            text: "南郊区",
          },
          {
            value: "866B9BDB-6A3C-4EAB-B581-1EFAD210A891",
            text: "城区",
          },
          {
            value: "98633958-6E2A-42D9-B9DC-04093F760311",
            text: "阳高县",
          },
          {
            value: "A05B7683-83F6-4D73-8F53-33115351861F",
            text: "天镇县",
          },
          {
            value: "B0327676-18AB-45FA-B745-5C992EC4E221",
            text: "新荣区",
          },
          {
            value: "BDA59D86-8308-4694-A6FA-ECB378AA1FB8",
            text: "灵丘县",
          },
          {
            value: "DCC660C0-A5DF-47CA-A528-FF286B4AC036",
            text: "大同县",
          },
          {
            value: "FC3ADA67-1669-42E2-BF04-75D612F01E03",
            text: "左云县",
          },
        ],
      },
    ],
  },
  {
    text: "内蒙古自治区",
    value: "19D0A0A7-1BA0-43EF-A412-7CAA74EB3111",
    children: [
      {
        value: "20A8A64A-7103-471A-9A82-9E4621577AA5",
        text: "兴安盟",
        children: [
          {
            value: "0A63F854-2E84-4A5F-9E4D-8D6C01C4C3CB",
            text: "科尔沁右翼中旗",
          },
          {
            value: "44CF3A0E-EE55-4341-84E2-ECA483AEDEB2",
            text: "乌兰浩特市",
          },
          {
            value: "869A2BE3-2369-4080-B5E8-F25A822555D2",
            text: "突泉县",
          },
          {
            value: "8DD65432-B710-4C76-8F92-D6E965F50BAE",
            text: "阿尔山市",
          },
          {
            value: "DE3DE738-AD0A-483A-9861-3C7FFD66A54F",
            text: "科尔沁右翼前旗",
          },
          {
            value: "EB75D2F5-EC6C-43D3-823D-5142CBD71DF4",
            text: "扎赉特旗",
          },
        ],
      },
      {
        value: "22808A32-946C-4587-A4E6-7C657E8D391E",
        text: "呼伦贝尔市",
        children: [
          {
            value: "1C20D0BF-B56B-42D0-A51A-180FE5F11499",
            text: "鄂伦春自治旗",
          },
          {
            value: "21B4C977-A734-4CF7-8614-29321302A514",
            text: "新巴尔虎右旗",
          },
          {
            value: "2F8CCBBD-BCEE-435F-9E0A-82543B6AD6AC",
            text: "新巴尔虎左旗",
          },
          {
            value: "327C3A56-DDF1-48D0-99EC-5EC1BCFA1AA2",
            text: "额尔古纳市",
          },
          {
            value: "455C6867-E8C7-4491-9DA4-5B3B803B100B",
            text: "陈巴尔虎旗",
          },
          {
            value: "5232FDA0-A101-46FD-B18F-F104CA3B8F37",
            text: "牙克石市",
          },
          {
            value: "660F25E3-4C23-4938-A9AE-AFDC2EFDBB34",
            text: "根河市",
          },
          {
            value: "66AF6217-D797-4000-9862-6B6915EC6252",
            text: "莫力达瓦达斡尔族自治旗",
          },
          {
            value: "86ADDEC3-B7BA-4677-868E-5C7A6214297F",
            text: "鄂温克族自治旗",
          },
          {
            value: "95EDF3B8-F491-4DB9-ACF8-82985178D0DB",
            text: "满洲里市",
          },
          {
            value: "97320D09-B80D-43C9-A637-306C6B2D01CD",
            text: "扎兰屯市",
          },
          {
            value: "D59C7FCF-8D9F-4979-BBC9-30ED1373821B",
            text: "阿荣旗",
          },
          {
            value: "EDD3CF56-8CE8-4E8B-B845-71799E4710DE",
            text: "海拉尔区",
          },
        ],
      },
      {
        value: "2469FC1F-BEC0-4865-902E-C425F12BB690",
        text: "乌海市",
        children: [
          {
            value: "B3EEE664-428B-4E96-AA22-95741E57C02F",
            text: "海勃湾区",
          },
          {
            value: "F77477B4-61EC-487E-BF27-317C976DB08D",
            text: "乌达区",
          },
          {
            value: "FB1C933E-575A-4D6F-8BDF-B0F83978FF9D",
            text: "海南区",
          },
        ],
      },
      {
        value: "3E49B073-199F-4467-BA60-F34501B0DF25",
        text: "锡林郭勒盟",
        children: [
          {
            value: "0CC70C44-D62F-4237-8F1C-EDF2B0445157",
            text: "西乌珠穆沁旗",
          },
          {
            value: "1496DA22-65C2-4743-B0B4-1B458F4EBBCC",
            text: "苏尼特左旗",
          },
          {
            value: "20D7DD43-9E98-4616-884A-1951A074B182",
            text: "阿巴嘎旗",
          },
          {
            value: "3D1488A7-7E6F-4255-800B-90B88586AE91",
            text: "锡林浩特市",
          },
          {
            value: "3EBACA5A-8C5F-416A-8FCA-578B8CF6284F",
            text: "太仆寺旗",
          },
          {
            value: "5DE84248-51E7-45CB-9240-1AE75BC57926",
            text: "苏尼特右旗",
          },
          {
            value: "707FFBE3-37E6-458C-8208-BE34A2F4AB91",
            text: "正镶白旗",
          },
          {
            value: "A974DBAD-6C9F-4E37-A1B4-1907D78EADEB",
            text: "东乌珠穆沁旗",
          },
          {
            value: "B9181963-8463-4A51-8ABD-6FEA070E4C40",
            text: "多伦县",
          },
          {
            value: "CF1D925B-9CFD-40E9-A19D-F96C802B74B1",
            text: "镶黄旗",
          },
          {
            value: "EAC06750-1FCD-4F6B-8C58-01FD2B981990",
            text: "正蓝旗",
          },
          {
            value: "EC5C89C3-E336-43C3-BA61-EFCA828C8CAA",
            text: "二连浩特市",
          },
        ],
      },
      {
        value: "54B275D5-9C07-45D3-8F71-9EB71DA62057",
        text: "阿拉善盟",
        children: [
          {
            value: "12B5DD9E-A43A-4FA0-9AA2-375EA3AC799F",
            text: "额济纳旗",
          },
          {
            value: "B549E83B-6D25-4BC9-9260-8C58D092239E",
            text: "阿拉善右旗",
          },
          {
            value: "CECC3FAF-7647-4593-A69A-0FE50DF3333F",
            text: "阿拉善左旗",
          },
        ],
      },
      {
        value: "54E1B3D4-7D7D-4D38-9A08-0922808038D5",
        text: "通辽市",
        children: [
          {
            value: "01452566-FD96-4F09-B71C-E5807D32204A",
            text: "库伦旗",
          },
          {
            value: "1F610EA2-CE64-49A8-BE26-9AC5764EAC9F",
            text: "科尔沁区",
          },
          {
            value: "38A9DAB6-5B32-4823-AE8D-8B2B3A980049",
            text: "开鲁县",
          },
          {
            value: "44BF430A-1D90-4F50-881D-5F4AAC593F08",
            text: "扎鲁特旗",
          },
          {
            value: "4CB2A4D6-CF71-4023-B2C2-162709EF3ABB",
            text: "科尔沁左翼中旗",
          },
          {
            value: "BF24B94B-AECC-418E-A9C3-3F11779D4A3D",
            text: "科尔沁左翼后旗",
          },
          {
            value: "D1808A2B-2CFF-4045-8C3E-4CA740EB2F3A",
            text: "奈曼旗",
          },
          {
            value: "FDD8BFB4-B847-4F7A-8A7F-5BBC43D4885C",
            text: "霍林郭勒市",
          },
        ],
      },
      {
        value: "70985A96-BA8A-4FBA-8AB3-7B472BF8F159",
        text: "呼和浩特市",
        children: [
          {
            value: "01EAB426-6394-459F-B939-84E7B818039C",
            text: "土默特左旗",
          },
          {
            value: "22FDB291-2BFB-4DE8-B3B3-B4B813D2C356",
            text: "赛罕区",
          },
          {
            value: "2E371718-40D9-4117-BEE9-970A268088C1",
            text: "托克托县",
          },
          {
            value: "3F9B4711-294A-418C-88A7-7E9EE7C579B8",
            text: "武川县",
          },
          {
            value: "49EC1D63-2423-4148-8059-DD8B9D051A88",
            text: "回民区",
          },
          {
            value: "526C4C56-C57E-4E2D-AD14-8318119BA7E0",
            text: "清水河县",
          },
          {
            value: "5966F013-AE95-40F3-9B61-D994A5BF67FF",
            text: "玉泉区",
          },
          {
            value: "6892270D-84D7-4F1B-A3E6-F6B7BAC40951",
            text: "新城区",
          },
          {
            value: "7CB62B1F-1A14-4E59-A5CB-E76CA0F81C2F",
            text: "和林格尔县",
          },
        ],
      },
      {
        value: "743CF18F-1FEF-4283-8742-07CC7CA4BA18",
        text: "赤峰市",
        children: [
          {
            value: "09980E33-4BE5-4196-8CAA-CD0E62CD3BDD",
            text: "宁城县",
          },
          {
            value: "1ACF9ED0-9E7A-4557-8F17-49AB11CD9D06",
            text: "巴林左旗",
          },
          {
            value: "218A9D8A-399E-4801-994B-BF7ABFD65722",
            text: "克什克腾旗",
          },
          {
            value: "38BEA78D-1BE6-48A4-AAB3-3FDB8636CF97",
            text: "红山区",
          },
          {
            value: "48FA1030-FB41-4979-9FB3-83C0D6758309",
            text: "林西县",
          },
          {
            value: "49D419A8-7373-40D6-8C78-5DD086DC9306",
            text: "元宝山区",
          },
          {
            value: "4BC24E45-F915-48AA-AE2F-A802F00CD635",
            text: "敖汉旗",
          },
          {
            value: "599A5CB2-0252-406E-BE81-313E6AF6EAA1",
            text: "喀喇沁旗",
          },
          {
            value: "92B31BCF-5DD9-483F-AE1F-0786B316B27F",
            text: "翁牛特旗",
          },
          {
            value: "C45EE421-7F1F-4BDB-984E-8F7E10DB7B0B",
            text: "巴林右旗",
          },
          {
            value: "DAA430B0-EE5D-4464-A81E-81C9B9FA8B5E",
            text: "阿鲁科尔沁旗",
          },
          {
            value: "FE013F56-488E-4B09-8009-AB199264A54F",
            text: "松山区",
          },
        ],
      },
      {
        value: "886AC9BD-03B1-4B62-89DE-77D0E6382F30",
        text: "乌兰察布市",
        children: [
          {
            value: "4490F057-914D-4BE2-91BC-D48DC99EAE89",
            text: "丰镇市",
          },
          {
            value: "5D5EBC0B-C555-4295-9BE7-6FA7C4EF246C",
            text: "察哈尔右翼中旗",
          },
          {
            value: "69407CEB-0337-4AC0-BF81-1AF2B921D50E",
            text: "集宁区",
          },
          {
            value: "77EE5BE8-3E95-4FFD-A9E8-DFA1D2CA935D",
            text: "商都县",
          },
          {
            value: "8ED59677-B90B-4ECE-AC4E-D200141F5E4D",
            text: "察哈尔右翼后旗",
          },
          {
            value: "9622BA58-1686-4F76-B07E-7902DFE5CC22",
            text: "四子王旗",
          },
          {
            value: "966F03A4-F378-4447-9878-C51A634698F0",
            text: "卓资县",
          },
          {
            value: "9A9F7D82-C851-4E2E-937C-8EE0D5C059C5",
            text: "化德县",
          },
          {
            value: "A0CE3873-5CA8-46D8-8230-02C3C547E0B7",
            text: "察哈尔右翼前旗",
          },
          {
            value: "CD36B792-924E-485B-8CDB-2F2959F2CC54",
            text: "兴和县",
          },
          {
            value: "FE476791-E5F4-4279-88ED-CD8CC1BD1889",
            text: "凉城县",
          },
        ],
      },
      {
        value: "CA35F007-8D6F-49D3-B944-7FB0511A332F",
        text: "包头市",
        children: [
          {
            value: "02705CB4-B1F3-4C26-9485-02E470AB5568",
            text: "东河区",
          },
          {
            value: "34684205-DC24-4E26-9123-8B05B04AD839",
            text: "昆都仑区",
          },
          {
            value: "54EB9FD7-D6B2-4AE8-BFF7-94E02CBD3559",
            text: "九原区",
          },
          {
            value: "6C42DF4E-C550-4CDC-81F1-926FF8BD5F35",
            text: "石拐区",
          },
          {
            value: "81395038-9FA7-46A0-A1DF-29CA71921D93",
            text: "固阳县",
          },
          {
            value: "873FCF17-B50F-4FD5-B92D-2D1B2722ECC8",
            text: "土默特右旗",
          },
          {
            value: "93E3E919-6555-4F93-A950-12D6B682D8D2",
            text: "达尔罕茂明安联合旗",
          },
          {
            value: "C53F8364-B583-4229-A882-B0B723DA222F",
            text: "白云鄂博矿区",
          },
          {
            value: "D33A5271-D146-4CAD-A2B4-67ACA2B0D3FD",
            text: "青山区",
          },
        ],
      },
      {
        value: "E7CD63EC-3C33-43AA-8FC2-700960D81FF7",
        text: "巴彦淖尔市",
        children: [
          {
            value: "19231638-49A3-4219-8423-BF7833C7A29F",
            text: "杭锦后旗",
          },
          {
            value: "3BB0C1E1-59E1-4A55-8CD8-2622E2B5EDE5",
            text: "临河区",
          },
          {
            value: "5C73DC42-83F9-4BEB-855F-39B00C187349",
            text: "乌拉特前旗",
          },
          {
            value: "6736536C-E939-4622-A4DA-C68541DD1350",
            text: "乌拉特后旗",
          },
          {
            value: "C92D50AE-54D8-4C93-B939-497BE171A2D8",
            text: "乌拉特中旗",
          },
          {
            value: "F08BF7B6-A6A4-461A-B949-AC3202528149",
            text: "五原县",
          },
          {
            value: "F986E0BE-589A-4BA1-BCEA-C4DC713E0F75",
            text: "磴口县",
          },
        ],
      },
      {
        value: "ED4E6CEA-9E70-482C-8513-79222DEF7134",
        text: "鄂尔多斯市",
        children: [
          {
            value: "157B71C0-B450-4C34-A430-406D431D5AC8",
            text: "鄂托克前旗",
          },
          {
            value: "2AD70439-3753-4448-8721-403027EC2474",
            text: "达拉特旗",
          },
          {
            value: "375CDB4E-3391-48FF-8847-409EF4C51A70",
            text: "东胜区",
          },
          {
            value: "6D91AB66-14EC-4DB1-A3D4-948DACAEAE67",
            text: "伊金霍洛旗",
          },
          {
            value: "6FA3B04E-FF27-4557-A04F-511ECAE82E12",
            text: "鄂托克旗",
          },
          {
            value: "82AA25FA-FFCF-48C6-AC0D-1C077D2D3353",
            text: "准格尔旗",
          },
          {
            value: "B7FD590C-4179-4032-83D4-0A4AD650782E",
            text: "乌审旗",
          },
          {
            value: "FFC39BE0-1A27-4D1C-9FE5-886EDC302EAA",
            text: "杭锦旗",
          },
        ],
      },
    ],
  },
  {
    text: "辽宁省",
    value: "B1D4E961-BC0F-4ACF-9396-1C7BBCAFED5F",
    children: [
      {
        value: "02892C26-6F47-4E55-A23A-E35ECF1D2710",
        text: "盘锦市",
        children: [
          {
            value: "1DCCA1E7-3BD3-4DF5-97A1-CF2F28A22790",
            text: "兴隆台区",
          },
          {
            value: "4392A8F9-238A-4CDD-B75D-77699915FAE5",
            text: "大洼县",
          },
          {
            value: "CE79E40D-BE3F-4AFD-AF19-C4786D94D42E",
            text: "盘山县",
          },
          {
            value: "D150DDD9-1109-4C09-9094-93F5CE5F14E4",
            text: "双台子区",
          },
        ],
      },
      {
        value: "14543BF5-0614-46C1-BB93-F854608450AA",
        text: "营口市",
        children: [
          {
            value: "5EC845D8-1EF4-49C7-9998-8685A07614DC",
            text: "西市区",
          },
          {
            value: "68776119-053A-47F4-8617-D142EF43B05D",
            text: "老边区",
          },
          {
            value: "922A2A7B-A8CA-4E10-8D10-FBE39FF490E6",
            text: "大石桥市",
          },
          {
            value: "A38B56A9-1964-4FBC-BCF9-DFFDE982BCEF",
            text: "盖州市",
          },
          {
            value: "A97EE7D1-C78A-41C6-9696-396E7206ED7E",
            text: "鲅鱼圈区",
          },
          {
            value: "ACBE6700-0C54-4CA7-B74A-B2F508EE4C20",
            text: "站前区",
          },
        ],
      },
      {
        value: "3B2B36C4-7B3B-432B-B8A8-8FF7B54FE021",
        text: "辽阳市",
        children: [
          {
            value: "2841FF35-8804-4A3A-B60F-C8E531F6D334",
            text: "灯塔市",
          },
          {
            value: "602FF41B-8FCA-4CA7-90FD-90F0A36DFECC",
            text: "太子河区",
          },
          {
            value: "634D403F-1DD1-464A-B68C-3E5ABD598503",
            text: "辽阳县",
          },
          {
            value: "74ED380A-0605-4B78-946F-4EE860C053FC",
            text: "弓长岭区",
          },
          {
            value: "B889BDB5-4673-4639-A5AD-6F3767B6B27A",
            text: "文圣区",
          },
          {
            value: "C7E4DD3B-5A62-4C5C-BBAA-AE4DB17AF1FB",
            text: "白塔区",
          },
          {
            value: "E14CB205-D3A5-465A-9C1D-639AA8F28829",
            text: "宏伟区",
          },
        ],
      },
      {
        value: "3C06836B-36EC-4040-8CE3-4A42A73C8642",
        text: "大连市",
        children: [
          {
            value: "0336F28B-E8AC-4B02-B2AB-1004AA7DDF17",
            text: "庄河市",
          },
          {
            value: "23271332-62CE-42B2-9570-ED5D5DCFB30A",
            text: "瓦房店市",
          },
          {
            value: "2E96B1DD-7408-4B24-BB40-7E84FAB8FE5B",
            text: "金州区",
          },
          {
            value: "561F4F5A-343A-438D-B035-15CC3A450360",
            text: "普兰店市",
          },
          {
            value: "72A435F5-B018-4A2A-AAB4-6F041DBCF26A",
            text: "西岗区",
          },
          {
            value: "9C16F86C-1425-4683-8706-6F51AF8B363C",
            text: "旅顺口区",
          },
          {
            value: "AA162D35-5C62-439D-B393-20409C95B4D7",
            text: "沙河口区",
          },
          {
            value: "B4B9C865-F763-4997-AD94-7F692470D5F3",
            text: "中山区",
          },
          {
            value: "BD0C9A3F-4878-4A92-8813-B81E9EA5BD28",
            text: "长海县",
          },
          {
            value: "CCA9023E-8D23-40D2-979A-C5E3999B4D94",
            text: "甘井子区",
          },
        ],
      },
      {
        value: "6BEDA748-CFB0-4BAB-8715-9B6906374638",
        text: "朝阳市",
        children: [
          {
            value: "434FEA9E-ED1B-4A4E-8B60-3A165412E065",
            text: "龙城区",
          },
          {
            value: "46DD86DA-64A2-496E-872E-59C29F3E7389",
            text: "建平县",
          },
          {
            value: "6A083B1F-132D-4276-B854-FC8B72BB7304",
            text: "喀喇沁左翼蒙古族自治县",
          },
          {
            value: "6AF6A804-8D4E-4010-96BF-B58D5BBAEF17",
            text: "双塔区",
          },
          {
            value: "8AFF74F1-E95E-411F-811F-BBA7323B6964",
            text: "凌源市",
          },
          {
            value: "8B2DC479-CF5F-444F-AE4E-FF2FA44B3C7F",
            text: "北票市",
          },
          {
            value: "DB13BEEC-0296-497A-BD14-23C23DACF0CF",
            text: "朝阳县",
          },
        ],
      },
      {
        value: "7A3D0170-141E-4675-A724-1F6F5FD864AE",
        text: "铁岭市",
        children: [
          {
            value: "00CD3A5E-41D2-4BE3-951F-C90E28A4D5A0",
            text: "调兵山市",
          },
          {
            value: "04C9683F-A9E2-4F72-8826-44C20F46FFA0",
            text: "清河区",
          },
          {
            value: "0573ADBE-BA57-4BB6-905E-177569BE55BF",
            text: "西丰县",
          },
          {
            value: "16C8597B-8F67-46BA-B259-1AD820C8E9F5",
            text: "开原市",
          },
          {
            value: "37CB2F41-B4E9-42CF-9542-6785EDBAB6AE",
            text: "昌图县",
          },
          {
            value: "BF5DE0CA-A935-42E3-8732-ED55CFEB9A04",
            text: "银州区",
          },
          {
            value: "FA7C52E1-59CC-4FFA-8051-E1B7AB76D18C",
            text: "铁岭县",
          },
        ],
      },
      {
        value: "8E3A4386-F760-4E5D-A010-5D44BFDB74C4",
        text: "锦州市",
        children: [
          {
            value: "0C896B61-75E7-46F0-8607-0E15BB6A64C4",
            text: "黑山县",
          },
          {
            value: "114A0E91-CF1B-4AF7-B8D4-155F3184DF3D",
            text: "凌河区",
          },
          {
            value: "3D8360F3-4517-4111-8755-DA8FF948549C",
            text: "太和区",
          },
          {
            value: "6AAD9F0A-4724-4826-AA85-A48EBC3B12BC",
            text: "古塔区",
          },
          {
            value: "79D0389B-834A-4A62-B5BA-DC14704E4291",
            text: "凌海市",
          },
          {
            value: "803A4CE4-4A2F-4E51-A601-16ADC0E949B7",
            text: "义县",
          },
          {
            value: "F0A46971-DF8B-4850-A680-9B1FCFEEAF51",
            text: "北镇市",
          },
        ],
      },
      {
        value: "BEC776D4-95C5-44C6-84CB-338071E9F200",
        text: "本溪市",
        children: [
          {
            value: "116E7B9B-4300-4093-99BE-9948761EDD0E",
            text: "溪湖区",
          },
          {
            value: "17B64C16-78F9-45FF-91D6-543E28096874",
            text: "本溪满族自治县",
          },
          {
            value: "28F6353B-9A69-44CE-BF0A-9864AEF4CA92",
            text: "明山区",
          },
          {
            value: "53238ADE-4C3C-4C11-9176-B58CCF19E9F2",
            text: "平山区",
          },
          {
            value: "906ADEF9-C42B-4234-A610-D72478C38FA8",
            text: "南芬区",
          },
          {
            value: "EF1F1A24-7A2C-45B1-99FF-F9EA2EB4CA56",
            text: "桓仁满族自治县",
          },
        ],
      },
      {
        value: "C07E8C71-FAE0-4944-B9F7-0021365DA1AD",
        text: "丹东市",
        children: [
          {
            value: "3C7C7153-0067-4BCA-9D42-CBAD860DB35F",
            text: "凤城市",
          },
          {
            value: "45D719A4-D1F8-4355-A525-73E6AB3F7466",
            text: "东港市",
          },
          {
            value: "75E1B99A-0C15-4151-AB0A-AF4A233603E1",
            text: "宽甸满族自治县",
          },
          {
            value: "8CF16A6E-3721-4433-A40F-A49A3407E4F4",
            text: "振安区",
          },
          {
            value: "AEFE1332-F1EB-42BA-96C4-287242B76EAB",
            text: "振兴区",
          },
          {
            value: "CBDF3814-F8AA-4F92-A29B-654A70E012FF",
            text: "元宝区",
          },
        ],
      },
      {
        value: "CE2BE9E0-1D12-4BAF-B4DB-EEAEEF7D0260",
        text: "阜新市",
        children: [
          {
            value: "0AB8673A-0362-4FD5-A2E7-C2E7F960A455",
            text: "细河区",
          },
          {
            value: "55A7282B-A28F-46C4-906C-DFC26CB0B9FD",
            text: "阜新蒙古族自治县",
          },
          {
            value: "B660CA8D-1114-43A3-98BD-6CB06E693672",
            text: "彰武县",
          },
          {
            value: "BDEDD1F9-8F37-4F88-B591-13FE785BF7B6",
            text: "海州区",
          },
          {
            value: "C3863E09-FDB4-4705-8A2B-F279A5710593",
            text: "新邱区",
          },
          {
            value: "CB318898-0B94-491B-A331-6E66FFC94851",
            text: "清河门区",
          },
          {
            value: "E07DDA7B-E3B4-4CE6-B2D3-75C74C0FD94F",
            text: "太平区",
          },
        ],
      },
      {
        value: "D450835C-17E3-4E15-8319-89DEEA529CED",
        text: "抚顺市",
        children: [
          {
            value: "1D6FF29F-CC56-4CB1-A4BD-B8FF50ED8BE7",
            text: "东洲区",
          },
          {
            value: "34B4556A-4E55-45DA-B7B3-C1CE00EE5B3B",
            text: "抚顺县",
          },
          {
            value: "4AF80407-0A4E-4CE1-8A7C-52853E350E86",
            text: "望花区",
          },
          {
            value: "55471EF6-2F4A-4DCB-9086-3ABE0C839E1D",
            text: "顺城区",
          },
          {
            value: "AD5982C0-913E-44D5-9582-688470459324",
            text: "清原满族自治县",
          },
          {
            value: "DBFEF484-1A2F-4401-9D6B-B6B11AE732C9",
            text: "新宾满族自治县",
          },
          {
            value: "F4346198-16EC-45DC-9E50-F1B47BE9C0A8",
            text: "新抚区",
          },
        ],
      },
      {
        value: "D9631E68-399C-4764-B66C-B5036279C57F",
        text: "沈阳市",
        children: [
          {
            value: "07A0497A-72AF-4BE8-B06F-53047623F61F",
            text: "东陵区",
          },
          {
            value: "0EFE8E88-9E42-4CC4-AE9B-A60FDD4B48AF",
            text: "法库县",
          },
          {
            value: "2C96A98C-C220-43CA-B00E-76E9E1D396E8",
            text: "苏家屯区",
          },
          {
            value: "46CEC9D9-2628-4C96-90FA-3DCBD0A8203C",
            text: "辽中县",
          },
          {
            value: "494A4DB0-12DB-4A15-8DA6-0665F9496EDB",
            text: "和平区",
          },
          {
            value: "5E3A9A6D-57AF-4FF5-BCBE-402043006B1B",
            text: "沈北新区",
          },
          {
            value: "87FA4FF0-9A83-41A3-BFD4-FAF2B75E500F",
            text: "沈河区",
          },
          {
            value: "8AAD774E-07CC-4D1B-B2FE-706CEB30F94A",
            text: "大东区",
          },
          {
            value: "8F6A93C8-9DA1-4CAF-A51C-555FD0F70009",
            text: "新民市",
          },
          {
            value: "9821C509-52CD-4FAC-A25E-27BAF7882D40",
            text: "皇姑区",
          },
          {
            value: "E6A2146B-7F3D-448C-B935-0EE6A1EA6A7E",
            text: "康平县",
          },
          {
            value: "F01E90F5-4ADD-4DD8-9731-1FDD7D3F2A38",
            text: "于洪区",
          },
          {
            value: "F283D96B-8512-40B5-960A-B054CDE1DF0D",
            text: "铁西区",
          },
        ],
      },
      {
        value: "E24BC374-6061-407C-AE9E-46FFE63CE723",
        text: "葫芦岛市",
        children: [
          {
            value: "0F0C8C90-DD81-4CD2-B665-280751DA550F",
            text: "绥中县",
          },
          {
            value: "5376BA3B-CE0D-4302-90A2-AABBE5893C76",
            text: "建昌县",
          },
          {
            value: "5853AB58-DE78-41B7-9710-808A2281E9C4",
            text: "龙港区",
          },
          {
            value: "7AC4A2A3-0B75-4DEE-A227-406FBB897D36",
            text: "连山区",
          },
          {
            value: "AC886B4B-C262-415B-BBFA-5EED35C79F77",
            text: "兴城市",
          },
          {
            value: "D1BEE0F5-FC52-48E1-9C35-BB61E3CD5C89",
            text: "南票区",
          },
        ],
      },
      {
        value: "F02C25F4-CC50-4DBE-B2B2-81DBC482D9A2",
        text: "鞍山市",
        children: [
          {
            value: "178B6310-2DCA-4A80-9DEF-0C7EBFC65505",
            text: "台安县",
          },
          {
            value: "200B642A-CC86-4B6B-BD6C-0E60A65A1F38",
            text: "铁西区",
          },
          {
            value: "4382210C-2102-4188-8F96-D2E146229076",
            text: "铁东区",
          },
          {
            value: "A0992760-E778-40B0-AA06-E7DD6FFE970D",
            text: "立山区",
          },
          {
            value: "BA6AB02A-8287-4AC4-AD18-5FEA73B974D2",
            text: "海城市",
          },
          {
            value: "ECD4DB35-59B1-4C77-A341-BABB44E381C1",
            text: "千山区",
          },
          {
            value: "FD56AE91-150A-48B7-AEF4-F5176A6D0AAF",
            text: "岫岩满族自治县",
          },
        ],
      },
    ],
  },
  {
    text: "吉林省",
    value: "366F3A30-E71B-458E-9F34-65DB49DFECB4",
    children: [
      {
        value: "3251A597-A710-4CA0-894E-77D37EC66973",
        text: "吉林市",
        children: [
          {
            value: "106E4671-0F97-4416-A864-B386EE02C786",
            text: "丰满区",
          },
          {
            value: "49B0F5E4-3853-403A-B697-6640015EA457",
            text: "永吉县",
          },
          {
            value: "5A740B30-2258-4F0F-A813-31BD471B00DE",
            text: "昌邑区",
          },
          {
            value: "70D306C4-F1C2-4823-B0BB-586B6C42ECB3",
            text: "桦甸市",
          },
          {
            value: "917D98D7-3048-4CD8-BD74-5BA0D4EF463B",
            text: "船营区",
          },
          {
            value: "9540F90B-A214-45F6-8E7D-815E9B6D311C",
            text: "磐石市",
          },
          {
            value: "EEC6A4FC-5300-41E0-BA3D-58014A1845C6",
            text: "龙潭区",
          },
          {
            value: "F3A3C71A-390C-40E9-BFBB-03F9A1D3B881",
            text: "蛟河市",
          },
          {
            value: "FE2F8683-BE6B-4AB2-B834-05EA7D446E8F",
            text: "舒兰市",
          },
        ],
      },
      {
        value: "50E6DCD8-F872-43EF-BAE1-6DECF4AE8373",
        text: "白山市",
        children: [
          {
            value: "36D13CCE-E19E-412E-8FE0-E4F7FD8E934C",
            text: "江源区",
          },
          {
            value: "70BB9169-D503-4D4E-BDCB-71B2363A22E7",
            text: "八道江区",
          },
          {
            value: "924EB842-81C8-4916-8C4B-D38C87F4D601",
            text: "临江市",
          },
          {
            value: "A10EFEF8-555E-4D30-9C21-DBBA8D98B100",
            text: "抚松县",
          },
          {
            value: "C3CF1517-A7E5-4290-8096-875B5123F268",
            text: "长白朝鲜族自治县",
          },
          {
            value: "E152DFD9-EDF1-4069-B2AA-429352D1435A",
            text: "靖宇县",
          },
        ],
      },
      {
        value: "51047DF4-DAEF-4C3A-9310-CC6D79492BDC",
        text: "松原市",
        children: [
          {
            value: "008A012D-F24B-492D-91DE-78660C16F4AA",
            text: "宁江区",
          },
          {
            value: "4E4AE109-206F-4D12-A96B-C191B050D1A4",
            text: "前郭尔罗斯蒙古族自治县",
          },
          {
            value: "A6C43792-395C-4995-B429-94FB226EB742",
            text: "长岭县",
          },
          {
            value: "D149FA33-8E61-4538-9F89-3F4D111CDF4A",
            text: "乾安县",
          },
          {
            value: "FE911C54-C04F-4E68-92BF-C52FE6B733D4",
            text: "扶余县",
          },
        ],
      },
      {
        value: "7518BF29-149C-4C29-9050-AB8A2BE80C22",
        text: "辽源市",
        children: [
          {
            value: "02CFE7E2-6E73-4DC1-A05B-3EBED67683E2",
            text: "西安区",
          },
          {
            value: "09255DC3-9E3E-4742-8984-11BB8A1C7C7A",
            text: "东丰县",
          },
          {
            value: "50255512-5C40-4AA7-8EE3-C036D3B3AF51",
            text: "龙山区",
          },
          {
            value: "F1C19D7B-09A5-4836-8E6A-7F0205449F0C",
            text: "东辽县",
          },
        ],
      },
      {
        value: "80CC7B4A-D3DB-42E1-AA24-3F1C3D30A1E7",
        text: "白城市",
        children: [
          {
            value: "0EF1D115-4034-478D-9E2A-6E5230C17877",
            text: "镇赉县",
          },
          {
            value: "60C629D8-7FE0-418A-80F8-B64063206151",
            text: "洮北区",
          },
          {
            value: "786CB251-F0AC-450F-9610-BE15CCDCAC97",
            text: "通榆县",
          },
          {
            value: "B5B0A38C-8EB8-42F3-A701-1CEBEB54C8EF",
            text: "大安市",
          },
          {
            value: "D4EFF8CA-AE3B-4249-9BC5-E3028269F4EF",
            text: "洮南市",
          },
        ],
      },
      {
        value: "864BC51D-21C9-4AEB-AF4B-6866474B9682",
        text: "延边朝鲜族自治州",
        children: [
          {
            value: "1DBFCB81-93A5-4A0D-A521-DD66AA5E1971",
            text: "延吉市",
          },
          {
            value: "28F8752E-C632-4133-977D-EC145189D963",
            text: "和龙市",
          },
          {
            value: "77B2D741-37C3-45AF-A7E5-DA9727B83293",
            text: "汪清县",
          },
          {
            value: "8C76D305-46E3-4D9E-830E-8A2AAC66B99F",
            text: "敦化市",
          },
          {
            value: "942C0E5B-2F98-4D94-9A6E-08485110F1B1",
            text: "图们市",
          },
          {
            value: "94D48FFD-AEDF-4EC3-BF68-1B7B5C1F7FEF",
            text: "龙井市",
          },
          {
            value: "B1F9867F-F8B2-4747-B597-27614AC0D233",
            text: "珲春市",
          },
          {
            value: "DA52142A-0346-4396-8D3C-713A242F6B81",
            text: "安图县",
          },
        ],
      },
      {
        value: "983F92C9-DCD5-48A0-BFE2-B903B907AFA2",
        text: "长春市",
        children: [
          {
            value: "01D74480-60B2-46B7-A945-A1D2AEB6DF8F",
            text: "朝阳区",
          },
          {
            value: "069DA863-9399-40AC-A134-7D0194FF319B",
            text: "农安县",
          },
          {
            value: "0BF80177-615D-4987-AA53-6B9A36071A78",
            text: "双阳区",
          },
          {
            value: "45062161-13C7-4187-8903-9362ECECEAA8",
            text: "绿园区",
          },
          {
            value: "54D89888-55F5-4F22-8B07-4AEBA1F76E91",
            text: "九台市",
          },
          {
            value: "5BAF53EF-3E68-4CA0-89D4-84731A7862AB",
            text: "宽城区",
          },
          {
            value: "883C58ED-9AA9-447A-BCD5-02B26E502360",
            text: "二道区",
          },
          {
            value: "A27D4CAD-B3A8-4696-8588-C6DB94CBAC0F",
            text: "南关区",
          },
          {
            value: "ACAF84B8-25E6-40CD-BB23-5F7CBED5FB95",
            text: "榆树市",
          },
          {
            value: "B76C9900-12A0-41D0-8649-52DF72DE307F",
            text: "德惠市",
          },
        ],
      },
      {
        value: "BE5AFCDF-83BB-4D4C-8014-A1A8FE7FE0D8",
        text: "通化市",
        children: [
          {
            value: "0B21457E-FBCC-46A1-9116-8C83A7878E96",
            text: "辉南县",
          },
          {
            value: "424658CE-8C27-409C-982C-59DF422EA7E9",
            text: "通化县",
          },
          {
            value: "56D897BD-C42F-45BC-9B75-538ECAB25D88",
            text: "柳河县",
          },
          {
            value: "5820AD35-775F-4592-B8AB-889CA3EAAC40",
            text: "梅河口市",
          },
          {
            value: "6FA6C498-EC42-465B-9F0D-CC77B57F64F0",
            text: "集安市",
          },
          {
            value: "DAF5234C-FF10-41B7-9906-B2BC9F3D6D57",
            text: "二道江区",
          },
          {
            value: "FBCA850A-72D6-403A-AE73-C94F1E4A6D80",
            text: "东昌区",
          },
        ],
      },
      {
        value: "C7B1C43A-79D1-4047-9E1E-B5CCACAC7430",
        text: "四平市",
        children: [
          {
            value: "0D2AB832-AD54-45D5-8D6D-F32919E3DCAC",
            text: "伊通满族自治县",
          },
          {
            value: "627C8B78-28EB-4089-93A7-DAF3164990A6",
            text: "铁西区",
          },
          {
            value: "6322E05C-89AB-43B2-9F86-5B724E14CC43",
            text: "梨树县",
          },
          {
            value: "7A23002B-FE84-4502-AA2D-0079F0EB89A0",
            text: "铁东区",
          },
          {
            value: "D475BF4F-ABE4-4795-B302-3707A697A1BA",
            text: "公主岭市",
          },
          {
            value: "E7A19E3B-BD72-4E4B-B027-672DED047DA5",
            text: "双辽市",
          },
        ],
      },
    ],
  },
  {
    text: "黑龙江省",
    value: "4A036B77-5870-405D-A5B0-A3A0B8C169A1",
    children: [
      {
        value: "18F7144E-9E26-4F63-8BCD-3F190B3367CE",
        text: "大兴安岭地区",
        children: [
          {
            value: "02639591-536D-430D-96FC-FE4DE788CE86",
            text: "漠河县",
          },
          {
            value: "72DD5CEE-5FD5-4FFD-91F7-8CBADFE6500E",
            text: "呼中区",
          },
          {
            value: "756AFCEA-C685-4613-88CE-66E5D6B1EE88",
            text: "塔河县",
          },
          {
            value: "7CC86B69-63F8-48D6-AFEF-EE56D1A6E937",
            text: "加格达奇区",
          },
          {
            value: "8010670B-B480-49C0-9453-EBBDB80025AE",
            text: "呼玛县",
          },
          {
            value: "A3ED420D-4ABA-44C9-86A7-5D5E78DC797E",
            text: "新林区",
          },
          {
            value: "B525AD5A-FE45-43C5-BBB9-01BEF8EADFA9",
            text: "松岭区",
          },
        ],
      },
      {
        value: "2165ACB1-E93B-4716-9FB5-A9802C14EE4A",
        text: "齐齐哈尔市",
        children: [
          {
            value: "0FF34FA4-5C9E-4822-B7A3-C8883285A265",
            text: "甘南县",
          },
          {
            value: "46959521-3C63-43E8-844A-6D6529EEFBA4",
            text: "碾子山区",
          },
          {
            value: "50426CAE-AB51-4FA7-AFD4-64B40238DC6C",
            text: "富拉尔基区",
          },
          {
            value: "66E270F7-E10A-4018-A6B0-4AF7996AB2DD",
            text: "拜泉县",
          },
          {
            value: "843C9F1E-AD9C-4DF5-812B-9C8B8F608935",
            text: "梅里斯达斡尔族区",
          },
          {
            value: "894468D1-D3DC-4B87-9373-8AE6890B56E4",
            text: "建华区",
          },
          {
            value: "8FD5BF2E-061B-4906-A605-72993DBA7F19",
            text: "铁锋区",
          },
          {
            value: "96A453B6-2165-44D5-A17A-0D096C1A62C1",
            text: "龙沙区",
          },
          {
            value: "B1ED133F-A8D1-4DB7-9207-B3491AA3ECE7",
            text: "昂昂溪区",
          },
          {
            value: "CFD35351-A858-48D2-9BEC-E12BF069AB3D",
            text: "克山县",
          },
          {
            value: "E2B95F60-65B8-4F86-85FD-7A6194198901",
            text: "克东县",
          },
          {
            value: "E57E4052-CD7B-4809-B032-5B52E8BA41EA",
            text: "龙江县",
          },
          {
            value: "E853DCD6-AF26-4330-9078-F506A61C54C6",
            text: "讷河市",
          },
          {
            value: "F14B555C-5011-46D9-87F7-D7145C83BEFA",
            text: "泰来县",
          },
          {
            value: "F23CA8E6-BC08-4EA1-98C8-B73B616EDFDB",
            text: "富裕县",
          },
          {
            value: "F5D9EF9E-6C0A-44B7-A97A-DC79113ED327",
            text: "依安县",
          },
        ],
      },
      {
        value: "5ACD156D-44AF-4B41-8399-EECE7A93CEBE",
        text: "佳木斯市",
        children: [
          {
            value: "1431D981-7AF4-4AD3-95D1-5DFC9861188A",
            text: "东风区",
          },
          {
            value: "2492CBFC-9E3D-45A5-90EA-5C3C4F64D14A",
            text: "汤原县",
          },
          {
            value: "3B43AFB9-5558-4A07-ADD4-ECFFE0597C43",
            text: "桦南县",
          },
          {
            value: "3BC6AF79-5DBF-4ABB-B410-0B8876DFB9F3",
            text: "向阳区",
          },
          {
            value: "87DEB937-30A1-476E-AE13-DEA12E957CF1",
            text: "富锦市",
          },
          {
            value: "A9D43A36-C501-4621-B278-A979A9021E6B",
            text: "桦川县",
          },
          {
            value: "AC7462A1-5643-4394-8542-6E632D996737",
            text: "抚远县",
          },
          {
            value: "AFCD38C8-61A0-4FD5-9939-6E50F559E071",
            text: "同江市",
          },
          {
            value: "CAE40916-24F7-4DAB-82CF-99B767EDB00B",
            text: "郊区",
          },
          {
            value: "F12C5239-8B85-4F8B-AB20-EA0DD6D9F1E6",
            text: "前进区",
          },
        ],
      },
      {
        value: "5C379C12-2037-4AFE-8D0F-38D5D4876155",
        text: "伊春市",
        children: [
          {
            value: "1825F75E-2F07-4FE0-BBA2-8423D32AF82F",
            text: "嘉荫县",
          },
          {
            value: "1866566F-9B74-44EE-88A8-C6038BDCF9F7",
            text: "友好区",
          },
          {
            value: "2000EE45-88CF-47C1-A888-87AF18D9861E",
            text: "五营区",
          },
          {
            value: "2B6A1BC8-58D0-47C8-B48F-E7E874DAE396",
            text: "上甘岭区",
          },
          {
            value: "666695F4-E4DD-45C6-B0AF-5FB336BB456F",
            text: "翠峦区",
          },
          {
            value: "6916D397-0A91-4A71-AB1E-08DCDB24098F",
            text: "红星区",
          },
          {
            value: "6AD9556D-8EE9-4A74-A848-63BF0A5811F8",
            text: "美溪区",
          },
          {
            value: "712D82A0-723E-4178-B14E-C48D49159D58",
            text: "带岭区",
          },
          {
            value: "87A9B8B1-D1CE-443E-8CBA-62E894819AA3",
            text: "新青区",
          },
          {
            value: "896C6A20-AC19-4236-A8FF-5410667E7ABF",
            text: "铁力市",
          },
          {
            value: "94CE6FF4-DB61-4F6A-8F16-7F918F427991",
            text: "乌伊岭区",
          },
          {
            value: "95037A4B-A88F-42A1-9B9A-2313FF43ED5A",
            text: "伊春区",
          },
          {
            value: "9E570A8E-A517-4A72-9DCA-A68407596675",
            text: "乌马河区",
          },
          {
            value: "9EA6EB83-8967-48E7-A92B-82664ED4CE37",
            text: "西林区",
          },
          {
            value: "B39F43BF-5A4A-4645-8A86-8903C6063BA9",
            text: "汤旺河区",
          },
          {
            value: "B7ABD1DE-B666-4CD6-9410-F22F4A9949E0",
            text: "南岔区",
          },
          {
            value: "D01BB669-DE2A-4940-A141-2FF12D101034",
            text: "金山屯区",
          },
        ],
      },
      {
        value: "5CFEA6B7-2D0C-4BA6-B1AE-40DC4CA72DD1",
        text: "黑河市",
        children: [
          {
            value: "0CEB4BC5-B7BB-4A2B-96DB-E4466AB3AC05",
            text: "爱辉区",
          },
          {
            value: "1A6C41B6-049E-4119-B5F9-1D892E8AABB6",
            text: "五大连池市",
          },
          {
            value: "2F030AA8-0F31-4729-99EB-01D8C17E458D",
            text: "北安市",
          },
          {
            value: "6DB51494-554F-4EC5-BC80-1F68776BB993",
            text: "逊克县",
          },
          {
            value: "732C6906-09F4-464D-869D-24C3D4D0D63B",
            text: "嫩江县",
          },
          {
            value: "F8A9715E-601E-4EC1-957B-76F6F7B580B5",
            text: "孙吴县",
          },
        ],
      },
      {
        value: "940B29EE-4FB3-4580-B219-B7455495F268",
        text: "双鸭山市",
        children: [
          {
            value: "180D8DB8-E4BF-4A4F-A31C-B20FCA09DA8F",
            text: "岭东区",
          },
          {
            value: "508D07D2-4E43-4850-AC1A-09572E0A935C",
            text: "宝清县",
          },
          {
            value: "5CBE001B-788D-4FD2-9B0E-18C072E30040",
            text: "饶河县",
          },
          {
            value: "66C990CA-0935-47FF-B56F-A71A30E9EDD5",
            text: "四方台区",
          },
          {
            value: "7F8DE66E-996B-4641-B786-B44BC206CA62",
            text: "友谊县",
          },
          {
            value: "9DDE96C4-66D4-4541-A75D-5FCFE9E2F742",
            text: "尖山区",
          },
          {
            value: "9F277425-0537-4ECD-A5BE-B34EBC9DA88F",
            text: "集贤县",
          },
          {
            value: "EE93DBD5-C967-43C7-B7B3-B166DC887AC9",
            text: "宝山区",
          },
        ],
      },
      {
        value: "95BFEA08-1743-4C35-BEB4-9BA3DD2205FA",
        text: "七台河市",
        children: [
          {
            value: "00B22010-C756-40F6-90F2-24A81B9D35A4",
            text: "茄子河区",
          },
          {
            value: "9FE3DCFA-8691-46C7-B4B0-E37E000CB92B",
            text: "新兴区",
          },
          {
            value: "A4442E7A-8A02-437A-A37D-01CBB314127E",
            text: "勃利县",
          },
          {
            value: "B3568064-5998-4771-8602-440A431905E1",
            text: "桃山区",
          },
        ],
      },
      {
        value: "9D883A35-B939-4F44-BC88-29814BB5755F",
        text: "绥化市",
        children: [
          {
            value: "009023BF-2177-482C-9117-B48215582F7C",
            text: "北林区",
          },
          {
            value: "105DC393-91E7-4749-BBDD-3FCF313AE5E0",
            text: "青冈县",
          },
          {
            value: "1EB76D83-4725-499F-AEC1-A263AFAC5805",
            text: "绥棱县",
          },
          {
            value: "4CD40EB8-B10C-478A-804A-5DA46092EBCF",
            text: "庆安县",
          },
          {
            value: "941061C9-036D-450F-8282-378BBA97E71F",
            text: "肇东市",
          },
          {
            value: "9B47B6F3-8AA0-4A1E-9EAA-67F499940D6C",
            text: "兰西县",
          },
          {
            value: "B0D6C1AE-5D30-42D0-9F2C-0D87CC52DAA1",
            text: "安达市",
          },
          {
            value: "C18978BD-9FFD-4863-B706-B6B87A128511",
            text: "海伦市",
          },
          {
            value: "DE911E0C-C221-43D8-9C89-91070040574A",
            text: "明水县",
          },
          {
            value: "F95836A4-C608-47F6-A3B6-3C65E42CD790",
            text: "望奎县",
          },
        ],
      },
      {
        value: "A6ABE86F-198E-4A5E-ADE8-8C18AE0CF04A",
        text: "鸡西市",
        children: [
          {
            value: "12046A29-62EE-4866-8A3C-34DAFA090C86",
            text: "恒山区",
          },
          {
            value: "2BE8F984-19C9-49DF-B5F3-A6324C7EEDAE",
            text: "密山市",
          },
          {
            value: "6DEFBD9D-5169-42B0-BCAA-8B24C93BADCF",
            text: "鸡东县",
          },
          {
            value: "7F07D6DE-65DD-43E0-B39E-2CC28E0E9995",
            text: "城子河区",
          },
          {
            value: "A9D19967-DD6F-445E-820D-8F8158383F4F",
            text: "麻山区",
          },
          {
            value: "C80E244B-364A-4E09-89E7-92F287902EAC",
            text: "虎林市",
          },
          {
            value: "DA09CDD9-3602-48CA-ADA7-D7BB31101D1C",
            text: "梨树区",
          },
          {
            value: "DAC984D5-AA6B-4B16-9549-839E3E3C2C3F",
            text: "鸡冠区",
          },
          {
            value: "DD1B57C9-A906-4212-9B17-F8C5796E4B77",
            text: "滴道区",
          },
        ],
      },
      {
        value: "B8E5F11F-1DF7-40FD-95FE-A7B14F94D249",
        text: "牡丹江市",
        children: [
          {
            value: "1B783DBE-676A-46D2-9D87-F31D914EFD67",
            text: "海林市",
          },
          {
            value: "36C26F00-A1DC-4D30-9B0C-1E48B0CC374B",
            text: "林口县",
          },
          {
            value: "3AC4DCF3-29C9-4CA2-9B3F-A3B2AFC00C0F",
            text: "东安区",
          },
          {
            value: "3B503304-9200-47B5-A24D-15A5DAF6E67C",
            text: "绥芬河市",
          },
          {
            value: "3D95F9D7-5CA8-4132-A492-C232E742336C",
            text: "东宁县",
          },
          {
            value: "40D55298-82DE-4F0D-A3DC-5ED055452C26",
            text: "西安区",
          },
          {
            value: "C00A92BF-3D28-4C5C-810C-CAAFADF117F6",
            text: "宁安市",
          },
          {
            value: "D7FBA0C7-6796-4045-9591-3993F5C010DD",
            text: "爱民区",
          },
          {
            value: "EA36993D-60E3-4D91-8907-A6E33DDEA42D",
            text: "穆棱市",
          },
          {
            value: "FC8030A3-1120-42F4-A2BA-72DAD6F7A24D",
            text: "阳明区",
          },
        ],
      },
      {
        value: "C240A8AB-E6D2-4378-8BAB-68DC7851BA59",
        text: "大庆市",
        children: [
          {
            value: "2B3E034D-3CD0-45ED-96C2-308C7B8A01E9",
            text: "萨尔图区",
          },
          {
            value: "37A67196-F741-4B77-AB10-DCCDC2451F34",
            text: "肇州县",
          },
          {
            value: "809F8A99-3934-4FD1-B9A2-790D2B1A394D",
            text: "让胡路区",
          },
          {
            value: "A9B795AA-79DA-47FB-9738-22A75E7CB30F",
            text: "林甸县",
          },
          {
            value: "B453A5C5-EEDF-474C-AC14-58F309C45DE5",
            text: "杜尔伯特蒙古族自治县",
          },
          {
            value: "B701CAAD-E104-40A9-88D3-941FD1818028",
            text: "肇源县",
          },
          {
            value: "CDB64E8A-CB76-457F-BBDB-DF5E03D4EE1B",
            text: "红岗区",
          },
          {
            value: "DD611B1E-240E-4B44-A2F5-678A6B3B366F",
            text: "大同区",
          },
          {
            value: "FF2E3A20-9E9C-4463-A2C4-6627C9D2E1DD",
            text: "龙凤区",
          },
        ],
      },
      {
        value: "DA83584D-D00B-4A0B-941B-CD3980635B80",
        text: "哈尔滨市",
        children: [
          {
            value: "165717AC-343B-43F9-87FB-F57C8B3A1394",
            text: "呼兰区",
          },
          {
            value: "207256F8-96C8-4F67-B7F6-F2596EC5D8A6",
            text: "道里区",
          },
          {
            value: "2B4DEC4E-1D06-412A-85F5-C54F4AC864A7",
            text: "香坊区",
          },
          {
            value: "2F2FC25C-6CBD-41E7-B848-455CA5BC1770",
            text: "木兰县",
          },
          {
            value: "31B1D4C0-3B07-4E35-8F2C-DA5F58E0B66C",
            text: "尚志市",
          },
          {
            value: "378C6FF0-AA66-4AC6-B690-61E5F19216F1",
            text: "道外区",
          },
          {
            value: "37A55035-8630-4860-ABB2-89E753541FCB",
            text: "通河县",
          },
          {
            value: "3E4815D9-B2E9-44CB-A62C-B329650742F2",
            text: "松北区",
          },
          {
            value: "3F1FA4F9-9FFC-4C5B-A58D-7EFED096439A",
            text: "延寿县",
          },
          {
            value: "58BD1F79-286E-41AD-89F2-59B3C6814253",
            text: "五常市",
          },
          {
            value: "6D5BAC2D-B0D6-4E2D-9E56-FB0ED6FAD859",
            text: "双城市",
          },
          {
            value: "7D7FAAA8-1AAC-42A3-A10B-769FF7376F8C",
            text: "依兰县",
          },
          {
            value: "C4494DCF-BE39-430D-8020-604CFE989B59",
            text: "南岗区",
          },
          {
            value: "C9222134-6DBB-4B61-AAFD-EFA45777FD95",
            text: "平房区",
          },
          {
            value: "CA91EF0A-99DF-4B89-ACFF-51DB3C2533D8",
            text: "方正县",
          },
          {
            value: "CE0A67A7-4208-49D8-8CFD-C26D3C3E6571",
            text: "巴彦县",
          },
          {
            value: "CE32D9FB-CB6B-4A41-9039-71902C85EAAF",
            text: "阿城区",
          },
          {
            value: "D87E9F88-DA16-4B92-80D2-217754EFA20E",
            text: "宾县",
          },
        ],
      },
      {
        value: "EF0B2303-0AF3-463F-9555-89937B1FC3AD",
        text: "鹤岗市",
        children: [
          {
            value: "1D2DF44C-4086-498B-B566-94D43C023A41",
            text: "东山区",
          },
          {
            value: "52D01A7F-56DF-4F6F-A3AE-A12653F0BA8C",
            text: "兴山区",
          },
          {
            value: "84F05C1C-3833-489C-B822-3326E5C953ED",
            text: "工农区",
          },
          {
            value: "A3298CD9-9881-4792-AD28-F00D3C14A826",
            text: "南山区",
          },
          {
            value: "A3D6A4C6-8B68-4FC8-A2DF-B37E99D2AD93",
            text: "萝北县",
          },
          {
            value: "BAEB826A-194B-4921-AC14-EFCA695EBB09",
            text: "绥滨县",
          },
          {
            value: "CD4C7E5E-FAD8-4B89-85FA-96DDA6B8FD04",
            text: "兴安区",
          },
          {
            value: "DF017965-DA19-454C-9629-B3497F888CF1",
            text: "向阳区",
          },
        ],
      },
    ],
  },
  {
    text: "上海市",
    value: "1CF8993F-432D-4FAC-9E91-5C329DDE0658",
    children: [
      {
        value: "90E76324-276B-4E02-940F-AFD76CB450E0",
        text: "上海市",
        children: [
          {
            value: "1D78BA99-0CF7-4F69-A0C3-3D6D03779034",
            text: "杨浦区",
          },
          {
            value: "242D9EB9-118B-435E-B48B-26DC21425494",
            text: "嘉定区",
          },
          {
            value: "257DD71B-8528-413C-80BA-D843BEDEECDF",
            text: "黄浦区",
          },
          {
            value: "2D11F44F-2681-4EB7-9A3D-3BD7D0E38F74",
            text: "徐汇区",
          },
          {
            value: "39C9DE93-94D4-4E7F-A6E4-CC4DD02ADC27",
            text: "静安区",
          },
          {
            value: "3F9A9552-7285-44F3-B464-7DF8A3584367",
            text: "青浦区",
          },
          {
            value: "55D5A622-0CD4-468A-8003-BC90B22EF46B",
            text: "闸北区",
          },
          {
            value: "5B81CB40-1E82-4177-ADE1-834520BC6947",
            text: "奉贤区",
          },
          {
            value: "7092EE6B-11C9-4A96-AF7F-17D83DC5EC70",
            text: "崇明县",
          },
          {
            value: "722CADB5-54DE-4318-AEE1-4D216AC579C2",
            text: "虹口区",
          },
          {
            value: "843ED6FA-4EE5-4D53-8CE7-CC3E20D92514",
            text: "南汇区",
          },
          {
            value: "85B0C500-2FF7-4291-B165-04C73CE6782D",
            text: "长宁区",
          },
          {
            value: "9093DF7E-B2A6-4D08-85CB-3F5C8AD03E4D",
            text: "松江区",
          },
          {
            value: "9EB849DF-2E41-4CBC-BF6F-2F51442C27F8",
            text: "宝山区",
          },
          {
            value: "9EE74DCC-BB00-4859-8936-ED08AF213E75",
            text: "普陀区",
          },
          {
            value: "A7D46BDA-A7E3-4BFC-AD59-25C7FC70644A",
            text: "卢湾区",
          },
          {
            value: "B8815AB3-68C8-4181-AFA8-37488368AE99",
            text: "浦东新区",
          },
          {
            value: "EC0FAC12-6C7E-485F-874F-1E1E35F7D250",
            text: "闵行区",
          },
          {
            value: "F44D7E90-8E4A-4455-AD09-3B24728FC94C",
            text: "金山区",
          },
        ],
      },
    ],
  },
  {
    text: "江苏省",
    value: "BF324567-2CB2-41E6-BACD-9540A3C3D23C",
    children: [
      {
        value: "1196A9FA-11EB-4357-9356-A5243F4911DE",
        text: "泰州市",
        children: [
          {
            value: "1AE77846-6742-4F13-9623-E21F5CED2BE2",
            text: "海陵区",
          },
          {
            value: "71AFF7E8-E292-46EB-B75D-17AAE9B14A0E",
            text: "兴化市",
          },
          {
            value: "750F7835-1B4A-49A0-BA41-F26086C20891",
            text: "靖江市",
          },
          {
            value: "8DB899E9-49DC-4875-93D0-AB1974C35FD8",
            text: "姜堰市",
          },
          {
            value: "CEDDCAA0-404D-4EAC-BA13-C7CD102C265A",
            text: "泰兴市",
          },
          {
            value: "ECC26F70-DE47-4E66-B518-0313D6882132",
            text: "高港区",
          },
        ],
      },
      {
        value: "13151E7D-12DC-4331-A9AB-541965B2137C",
        text: "连云港市",
        children: [
          {
            value: "0CCF7949-FFD3-4029-BE23-0462B3EB0850",
            text: "灌云县",
          },
          {
            value: "0DBE17CF-41D9-4022-A8E9-ED7F638D3091",
            text: "灌南县",
          },
          {
            value: "625E12B4-9A35-4D41-80BD-8D6EDDD9D13A",
            text: "新浦区",
          },
          {
            value: "8D73B8C6-59CD-4F5E-B899-125F43D0D61A",
            text: "东海县",
          },
          {
            value: "95371E6F-3ECF-4188-8A2C-D460496CB6F4",
            text: "连云区",
          },
          {
            value: "DCF1A4F3-E0B7-4979-A203-00B66914D31A",
            text: "赣榆县",
          },
          {
            value: "E87AD6C0-1A36-4945-B154-7651D1D7885A",
            text: "海州区",
          },
        ],
      },
      {
        value: "227CA145-BC1A-4DC0-BF1A-99349F0B25F0",
        text: "南通市",
        children: [
          {
            value: "10A03BBA-5B47-43D4-844E-983E7164A3C0",
            text: "海门市",
          },
          {
            value: "110C15F0-491F-4DD5-A8AA-5B22DD953137",
            text: "如皋市",
          },
          {
            value: "164F6FFD-AE72-47D3-897B-3D3875621869",
            text: "如东县",
          },
          {
            value: "79DBC7D8-FD14-491D-B3AF-802D5B489457",
            text: "崇川区",
          },
          {
            value: "79E0535E-98CF-45E8-B508-C8CDC0EACE57",
            text: "港闸区",
          },
          {
            value: "7DF32019-5FB5-4784-9215-CC8E47BA0786",
            text: "启东市",
          },
          {
            value: "8D7F6451-B95E-43E6-8791-CB9A34B7C6FC",
            text: "海安县",
          },
          {
            value: "B3D14952-7A72-41E9-899A-8039024A1AC8",
            text: "通州市",
          },
        ],
      },
      {
        value: "30FFB22D-ACB8-4F1B-9125-8F6828B81CB3",
        text: "无锡市",
        children: [
          {
            value: "10FBA519-F0CD-4EE7-8D9A-E7BC2B54B560",
            text: "惠山区",
          },
          {
            value: "2A39AECD-7506-429E-82CC-5A6E3DB6DC3D",
            text: "滨湖区",
          },
          {
            value: "80A18E8A-36B3-4121-AA61-03DC94C3915B",
            text: "北塘区",
          },
          {
            value: "95E19F22-4D36-470D-84A1-1E2CFD7D67BB",
            text: "宜兴市",
          },
          {
            value: "A862F78B-7FB3-4F6A-A592-C33D26701C17",
            text: "崇安区",
          },
          {
            value: "AAEC6DB0-02BB-4509-940C-7E35AFEDD882",
            text: "锡山区",
          },
          {
            value: "C663B93C-C5C6-4A56-91F0-6F7DCE4E101A",
            text: "南长区",
          },
          {
            value: "F4605B10-F68F-476B-A416-497284990AB3",
            text: "江阴市",
          },
        ],
      },
      {
        value: "36B2B9E4-FEEC-42EF-BC20-49DD523A2EE4",
        text: "徐州市",
        children: [
          {
            value: "200DBFCF-AF73-4F3E-BEC5-12B2AE3AD4F3",
            text: "贾汪区",
          },
          {
            value: "527C7294-94A9-42EF-AB39-D6D1D3CCFF9D",
            text: "鼓楼区",
          },
          {
            value: "6D2C3633-AA33-47ED-8EC0-CC192F64F3DA",
            text: "铜山县",
          },
          {
            value: "81B55C21-2856-4ADA-8C09-D9DD3F01DFA4",
            text: "九里区",
          },
          {
            value: "87C45549-D118-4E9A-8096-D5B57F877388",
            text: "泉山区",
          },
          {
            value: "961AE032-2556-48A9-91CC-9EEDB5B1F736",
            text: "新沂市",
          },
          {
            value: "97F0B448-9971-414A-89ED-CEC8B6732CFB",
            text: "睢宁县",
          },
          {
            value: "B59F6D60-A333-4B01-AD82-C38B13BB7938",
            text: "沛县",
          },
          {
            value: "BD9B476D-4269-4E45-909C-CE64BC17F6E3",
            text: "丰县",
          },
          {
            value: "E457804D-4DDF-48DB-8F82-38923BA71B4B",
            text: "邳州市",
          },
          {
            value: "E8B3007C-0795-4CAF-B577-885175A6E1DD",
            text: "云龙区",
          },
        ],
      },
      {
        value: "4FDDA62E-B19C-450B-BCEB-B00843EA949D",
        text: "宿迁市",
        children: [
          {
            value: "3D8CA39C-C3D2-4516-AB36-F1CD9859B0EE",
            text: "泗阳县",
          },
          {
            value: "8413D3FF-1540-437E-A15A-81E12C3ADBA1",
            text: "泗洪县",
          },
          {
            value: "B11527A4-7A80-4081-B770-40050AFA0206",
            text: "沭阳县",
          },
          {
            value: "DD523EA6-4BCC-4296-AE09-B1B29326BBE1",
            text: "宿城区",
          },
          {
            value: "E99ECE95-742C-44A3-B21B-7B4C49745D00",
            text: "宿豫区",
          },
        ],
      },
      {
        value: "7D8AFB98-7C56-4879-8F2B-BE3A3C3B3645",
        text: "盐城市",
        children: [
          {
            value: "1E47E560-C8EA-4F71-9E19-225A2A7C986B",
            text: "盐都区",
          },
          {
            value: "1F5CAD54-C345-42A4-B5B2-A4D7D05D5B5C",
            text: "建湖县",
          },
          {
            value: "414CA0F9-EB9A-455F-8531-F39CCF69AC37",
            text: "阜宁县",
          },
          {
            value: "60816FBD-9AC0-4CBA-A477-750BCE77C081",
            text: "滨海县",
          },
          {
            value: "86F18E9A-D95E-4CF5-B4BC-7A424F0E8102",
            text: "射阳县",
          },
          {
            value: "9292F6E7-0A9F-4E2B-9A52-9CA1DDB0A0B1",
            text: "大丰市",
          },
          {
            value: "AECBCDB4-88B9-44FC-851F-39D669D1B60F",
            text: "亭湖区",
          },
          {
            value: "BAD657CA-92BF-4D61-B9FC-DF94D00A6BDB",
            text: "东台市",
          },
          {
            value: "E5BADD7E-3A6F-40E5-80AF-89F62426E8DF",
            text: "响水县",
          },
        ],
      },
      {
        value: "84847DE9-F962-4B7F-ADEA-0DEA7774AA22",
        text: "淮安市",
        children: [
          {
            value: "1C8B9108-D93B-44BF-9FE6-7B5CDB9B57BE",
            text: "洪泽县",
          },
          {
            value: "3AB5C4AE-C410-4F3B-A017-EEA8D91D8C31",
            text: "盱眙县",
          },
          {
            value: "3D5891BC-D096-4F9A-8DF9-921C119334E7",
            text: "楚州区",
          },
          {
            value: "53E6B50B-2FBF-4B53-9C1C-7C50516E6228",
            text: "清浦区",
          },
          {
            value: "6C42E52D-AE6E-4E9D-9C76-890CC4F9C323",
            text: "涟水县",
          },
          {
            value: "6F400397-94FD-4925-92A5-CB0279DD5064",
            text: "清河区",
          },
          {
            value: "76A0AAB1-6EA1-4C38-8648-C29392A58310",
            text: "淮阴区",
          },
          {
            value: "C6CDF8E0-746C-4046-9561-153C19D9809D",
            text: "金湖县",
          },
        ],
      },
      {
        value: "86EC2B53-BA24-48EC-8960-184E0FBD0269",
        text: "常州市",
        children: [
          {
            value: "4770BB18-994F-4CCB-8FAF-C1E5F27AB50F",
            text: "新北区",
          },
          {
            value: "5B212A1A-4D0F-40DC-847C-F01F659378CA",
            text: "天宁区",
          },
          {
            value: "7A4654C9-48D8-4131-B89B-B4CD904E3E6D",
            text: "钟楼区",
          },
          {
            value: "8521006B-B1FA-46C4-94DF-8F573B17A75C",
            text: "戚墅堰区",
          },
          {
            value: "93432810-594B-4A53-B186-00273BBC7E9D",
            text: "武进区",
          },
          {
            value: "C20AF13D-3B39-413A-BA81-4D347CA21921",
            text: "溧阳市",
          },
          {
            value: "E5711175-C3B5-410B-A07F-C672EA355873",
            text: "金坛市",
          },
        ],
      },
      {
        value: "9218203C-3CF2-44E6-973A-D5D336B33BBF",
        text: "扬州市",
        children: [
          {
            value: "1D81315E-A5F1-4833-8E03-31329D111E6C",
            text: "仪征市",
          },
          {
            value: "29C009E3-129B-4FA1-83DE-5511C430E5F6",
            text: "广陵区",
          },
          {
            value: "77256FF3-FE6C-471B-95E0-131E688BA5AD",
            text: "维扬区",
          },
          {
            value: "8C5FD602-AC19-4E14-942B-B321B9AD12F5",
            text: "宝应县",
          },
          {
            value: "8F6F8FA1-E501-4189-9FFE-73DC89BAC996",
            text: "高邮市",
          },
          {
            value: "D5536873-498F-4207-9F7F-783DA78EB711",
            text: "江都市",
          },
          {
            value: "E3C587CD-6FCB-4B03-BC7E-D2A8DE4B1E5B",
            text: "邗江区",
          },
        ],
      },
      {
        value: "95137211-5BF1-4DA5-BAD9-6133ED8F3AF4",
        text: "镇江市",
        children: [
          {
            value: "16007E1D-D593-4EAE-8D4E-D62257EAD7F8",
            text: "京口区",
          },
          {
            value: "264A7151-8E6C-47E3-AA40-13FEF1CB519B",
            text: "扬中市",
          },
          {
            value: "3A53DB3B-5944-4D59-8EE2-2353319FBB7E",
            text: "润州区",
          },
          {
            value: "A76112ED-69FF-4E20-87AF-84084767077A",
            text: "句容市",
          },
          {
            value: "E2AE9E71-04F9-46BC-9348-3074ED6E6115",
            text: "丹阳市",
          },
          {
            value: "ED1B3B01-07D0-4C6B-A650-D0A7BAAC50B0",
            text: "丹徒区",
          },
        ],
      },
      {
        value: "9ADD6CA8-DB17-48B4-A6E3-668B861F062A",
        text: "南京市",
        children: [
          {
            value: "4C71C2F8-E743-436C-A9EE-61BCE7BB4110",
            text: "浦口区",
          },
          {
            value: "706A5423-459A-49DC-B5A0-51957C1076FD",
            text: "雨花台区",
          },
          {
            value: "71EB5DDA-C117-422B-BE08-61059DA814AA",
            text: "溧水县",
          },
          {
            value: "80B9E849-033C-43D2-A3D6-99338625F8FD",
            text: "玄武区",
          },
          {
            value: "992E95E8-673C-428F-B9F6-5519B1604199",
            text: "高淳县",
          },
          {
            value: "A6F4D67C-D78D-439D-9747-347A6A7ABBEF",
            text: "六合区",
          },
          {
            value: "C11F6223-6E94-409F-829A-BF267E3EA1C2",
            text: "建邺区",
          },
          {
            value: "D1ED279E-D837-4FC8-8054-5181B22C76EB",
            text: "栖霞区",
          },
          {
            value: "D4ECF1D3-BCB4-427F-A057-27BDA94ACE3F",
            text: "江宁区",
          },
          {
            value: "D5335359-AEB8-474E-887E-2188F666E7A1",
            text: "秦淮区",
          },
          {
            value: "D5D78E72-D761-4AB4-A053-3FEA495349F1",
            text: "下关区",
          },
          {
            value: "EA83FA81-36DE-447C-BD75-526723F263D3",
            text: "白下区",
          },
          {
            value: "F4F46F78-9E0F-4C9C-87D8-E93D37C91EA8",
            text: "鼓楼区",
          },
        ],
      },
      {
        value: "B0384D09-9CD8-47E6-AE86-32C054850DC3",
        text: "苏州市",
        children: [
          {
            value: "0BEBC56D-32F6-473C-8B4A-C8AE8EC31A65",
            text: "沧浪区",
          },
          {
            value: "284E8F95-F49D-4E21-92CD-73F8F007D504",
            text: "相城区",
          },
          {
            value: "3B6C30BA-56DB-4307-BECA-918046F78DA1",
            text: "吴江市",
          },
          {
            value: "50C78AF4-C01C-4FAD-B951-8898D45EA17D",
            text: "昆山市",
          },
          {
            value: "538EE424-3726-4524-A0F9-3055021294C7",
            text: "常熟市",
          },
          {
            value: "65B65147-B826-4FAB-AE29-B92C297B51E0",
            text: "金阊区",
          },
          {
            value: "8881DE19-B021-4CA0-8417-90E2390AF505",
            text: "虎丘区",
          },
          {
            value: "B0D9660C-B59D-45AB-BDAE-C5D84AE6D2B1",
            text: "吴中区",
          },
          {
            value: "BA87FFFF-60FB-4DFC-B252-1C3D5911867F",
            text: "太仓市",
          },
          {
            value: "C7BC4A03-09DC-4A2E-A7EB-D42B68EA83F1",
            text: "张家港市",
          },
          {
            value: "F44A1932-B729-4EA6-A7D2-7CEB5A30A948",
            text: "平江区",
          },
        ],
      },
    ],
  },
  {
    text: "浙江省",
    value: "4F70652C-77EF-453B-818B-93770BC221F0",
    children: [
      {
        value: "0ECDC618-C804-4252-B694-B6C703FA235A",
        text: "金华市",
        children: [
          {
            value: "00A9D995-7303-46E2-9810-DB80D20ADD8F",
            text: "永康市",
          },
          {
            value: "0E07FC2B-D3B6-4785-97E0-F779E85FF8A0",
            text: "武义县",
          },
          {
            value: "10B3DFCF-9DF7-4714-8D53-FAA9A7F40013",
            text: "婺城区",
          },
          {
            value: "11A6DD20-DE72-49DA-AE93-1E7CF78E1021",
            text: "兰溪市",
          },
          {
            value: "19A031A2-3040-465A-A7C0-E7C5C4C114BA",
            text: "东阳市",
          },
          {
            value: "5C2134EF-24C7-47D2-8783-2A3326B07CC7",
            text: "义乌市",
          },
          {
            value: "901C40E5-40B0-430F-B64D-084A22F18176",
            text: "浦江县",
          },
          {
            value: "9CEDA1F6-B87E-46CE-9FF5-DDAA2FACCBED",
            text: "磐安县",
          },
          {
            value: "F79A51D3-25BB-4163-9A5F-AE1BCCD4CEDE",
            text: "金东区",
          },
        ],
      },
      {
        value: "2458504C-4ADF-4D9A-B5AF-A83C6020B7B9",
        text: "宁波市",
        children: [
          {
            value: "1B032F0E-6370-4E63-B7D5-66565BDFD909",
            text: "江北区",
          },
          {
            value: "2A2CFB17-5393-46F6-A51F-7AE71B047BB3",
            text: "镇海区",
          },
          {
            value: "2F7C5D81-5D56-448E-8BC1-3874FEB8C487",
            text: "宁海县",
          },
          {
            value: "41A1ED8E-6C1E-4E02-AAF2-073E040E15FE",
            text: "鄞州区",
          },
          {
            value: "42D04534-E5FE-49DE-B531-44B77A5A56B3",
            text: "奉化市",
          },
          {
            value: "49EFC41E-1EA3-4E05-B30F-5CB6708B8A30",
            text: "江东区",
          },
          {
            value: "586649AF-1999-40CC-B223-A1451FC632B7",
            text: "慈溪市",
          },
          {
            value: "866B251E-951D-4377-BF7C-A18C47DE0570",
            text: "海曙区",
          },
          {
            value: "87569F56-B7D4-4A9B-B9F2-652701C37F06",
            text: "余姚市",
          },
          {
            value: "AC5039E5-E7B8-44C9-980B-B0EC72701929",
            text: "北仑区",
          },
          {
            value: "FD857217-432D-4C86-9294-994E53DA719D",
            text: "象山县",
          },
        ],
      },
      {
        value: "5F6A4601-7D11-488F-9C42-32EEE45BBBBA",
        text: "绍兴市",
        children: [
          {
            value: "0688F2C3-D6B3-4D7E-B724-0437443355C8",
            text: "上虞市",
          },
          {
            value: "097CC247-2E4A-4980-98AC-B6A71D38D325",
            text: "绍兴县",
          },
          {
            value: "41EC80F9-2745-4DE8-9153-889AF9DF2F68",
            text: "新昌县",
          },
          {
            value: "8AF1AEF6-6A0A-4CB7-A528-88EB46BF0A0F",
            text: "越城区",
          },
          {
            value: "968B8068-389A-40E8-BB61-6657A431EC7F",
            text: "诸暨市",
          },
          {
            value: "CE0254CE-A8BD-4D0D-963F-5391841A53D0",
            text: "嵊州市",
          },
        ],
      },
      {
        value: "6503661B-068B-457D-8262-1C8B76FC51D8",
        text: "湖州市",
        children: [
          {
            value: "07FCAD56-C1F4-41C9-B9B1-3C1CA0783128",
            text: "长兴县",
          },
          {
            value: "5AB636A1-ADAB-47FA-8159-66E787F4FC0B",
            text: "吴兴区",
          },
          {
            value: "61513884-7868-45DC-B1AE-591328C4CB55",
            text: "安吉县",
          },
          {
            value: "A2ADC020-9D75-4AE4-B8F0-758A649D1CB7",
            text: "南浔区",
          },
          {
            value: "E462D91C-445C-4061-A2B2-9E76558FF4BF",
            text: "德清县",
          },
        ],
      },
      {
        value: "AA507771-F82B-478A-AB79-3BB6EF3F32CC",
        text: "嘉兴市",
        children: [
          {
            value: "052E09B5-F8E3-4E98-9EBA-56B351CED0D8",
            text: "平湖市",
          },
          {
            value: "25253FEC-6180-4FD0-A676-BF1717405651",
            text: "秀洲区",
          },
          {
            value: "52EF8787-4363-4DF5-9446-0BAB9501759B",
            text: "海盐县",
          },
          {
            value: "888DA995-194C-419B-A58D-AD67DD8B48B7",
            text: "南湖区",
          },
          {
            value: "CACA43DF-495B-4474-B32C-80A772DB32D9",
            text: "嘉善县",
          },
          {
            value: "F8E425D6-DA0C-41F1-9643-8FC7A9C52F7A",
            text: "桐乡市",
          },
          {
            value: "FB8BF7D7-8C5A-4213-B3CC-812678006774",
            text: "海宁市",
          },
        ],
      },
      {
        value: "D023CF29-EFBE-4D48-A85A-3528BD62F0D7",
        text: "温州市",
        children: [
          {
            value: "1681610A-7287-45A2-9D1D-C12333B54A28",
            text: "瓯海区",
          },
          {
            value: "1A05A621-753C-4CB3-8F93-C245C3A14751",
            text: "永嘉县",
          },
          {
            value: "1CFBD58C-E4F7-4893-9642-A19E99F30757",
            text: "鹿城区",
          },
          {
            value: "3E1B8538-B0A8-40C1-977A-BFBA434DF966",
            text: "洞头县",
          },
          {
            value: "42B8B931-7B8B-4E51-87D8-0EA65B59D232",
            text: "泰顺县",
          },
          {
            value: "42C59D7C-DB18-4A7C-952C-4F2C3C61D5F0",
            text: "苍南县",
          },
          {
            value: "494D5D68-02AF-4AC2-841A-A3AF90DA2A66",
            text: "瑞安市",
          },
          {
            value: "5B9B8F71-A72D-4693-8CC4-45B3CA00E03D",
            text: "文成县",
          },
          {
            value: "72A8C4DF-3C2C-45F6-BF2E-74E0C3BF63ED",
            text: "平阳县",
          },
          {
            value: "7FA08DEC-B5D7-404C-BFEA-9FABFBE34307",
            text: "乐清市",
          },
          {
            value: "8E7C674C-68F4-49EE-9F77-64FF511AD42A",
            text: "龙湾区",
          },
        ],
      },
      {
        value: "E43BA058-5EFC-48D9-81FF-E30AC3103680",
        text: "丽水市",
        children: [
          {
            value: "06EB1441-AC47-4DCB-8ACB-C62FB96C582A",
            text: "青田县",
          },
          {
            value: "1EBFDEB5-EE3B-490F-BE6A-2C7D096224C2",
            text: "景宁畲族自治县",
          },
          {
            value: "4E4FA1D4-0092-4C9C-9314-DF38D4AE487C",
            text: "松阳县",
          },
          {
            value: "96A85573-C0E1-4B86-A7F8-4FDB7D4E2D17",
            text: "莲都区",
          },
          {
            value: "9E67A12B-C5F3-4CCC-B82F-4162B170C9C0",
            text: "缙云县",
          },
          {
            value: "BED52E4B-A8F7-4A8C-A4E8-0383157C514E",
            text: "龙泉市",
          },
          {
            value: "DC118862-CFEE-441D-B7BC-646251C9F644",
            text: "庆元县",
          },
          {
            value: "DCAED8B0-3446-4B52-BD56-0D137768688C",
            text: "云和县",
          },
          {
            value: "EA221712-32D9-4E1A-878C-5A16DD980F23",
            text: "遂昌县",
          },
        ],
      },
      {
        value: "E582E19B-3A9D-4F16-8145-0BE4E76A773E",
        text: "杭州市",
        children: [
          {
            value: "071E95AB-B2AF-4941-B7B6-8E4055B8389B",
            text: "桐庐县",
          },
          {
            value: "0961F53C-35D1-4BA7-8555-371243654249",
            text: "上城区",
          },
          {
            value: "0E44436F-D6E6-4D90-BE42-916D2C8B44C6",
            text: "临安市",
          },
          {
            value: "0F7F4261-D866-4E69-B40F-296C1126A7CC",
            text: "建德市",
          },
          {
            value: "25E81344-2AAF-48D2-A9BD-809D0B13CD84",
            text: "下城区",
          },
          {
            value: "314EE901-BC01-4AC0-A86A-220F9A6FD5A2",
            text: "滨江区",
          },
          {
            value: "3D257F72-D7C7-4B6F-A1B1-8213499E2EEC",
            text: "余杭区",
          },
          {
            value: "5B35F511-7414-4B0A-8572-86162824FE84",
            text: "富阳市",
          },
          {
            value: "71D69C08-E4CE-4DBB-86CD-21A69DB99DF7",
            text: "淳安县",
          },
          {
            value: "8308CD22-D27B-46E8-A675-B62CFA61F094",
            text: "江干区",
          },
          {
            value: "8F25A432-BACB-4508-A088-7F9601DBA419",
            text: "西湖区",
          },
          {
            value: "A77E6B2F-0319-4165-927D-9987E8C5DFA0",
            text: "萧山区",
          },
          {
            value: "DE3B1687-3967-4E71-93A6-DDADD26AFD11",
            text: "拱墅区",
          },
        ],
      },
      {
        value: "F4236104-A940-47C8-8809-9BCE4B410A19",
        text: "衢州市",
        children: [
          {
            value: "01317639-ED8A-4571-BC6D-FC5945A30D7C",
            text: "开化县",
          },
          {
            value: "44E1C6A7-EA3D-4BFB-BC38-8A6EBBC57F00",
            text: "柯城区",
          },
          {
            value: "5E2AC1A4-AB7B-47B5-8D64-17B7F3082EFF",
            text: "衢江区",
          },
          {
            value: "8A830A04-7CAF-4BD9-A9D3-6493D83E1416",
            text: "江山市",
          },
          {
            value: "B342A66C-AAF4-4292-AFF9-1D960E73769A",
            text: "龙游县",
          },
          {
            value: "F3AA7EC2-2555-4FFF-A082-65DA61E07D19",
            text: "常山县",
          },
        ],
      },
      {
        value: "F67879E5-FF78-4567-A13E-F928F981A54E",
        text: "台州市",
        children: [
          {
            value: "48DE8616-1F04-474A-8A62-861E9427CFC3",
            text: "椒江区",
          },
          {
            value: "6FEA19FB-CF6D-4564-82C2-42C2D706D392",
            text: "玉环县",
          },
          {
            value: "79DBC25C-182F-4DFC-998F-365EA01FF465",
            text: "三门县",
          },
          {
            value: "7E8D936D-6394-4E75-BB2F-400EDC7797E8",
            text: "仙居县",
          },
          {
            value: "831C4A86-E5F3-4B30-9844-A1D6EAE3D050",
            text: "临海市",
          },
          {
            value: "AA323730-F857-4793-B796-554741B7EC30",
            text: "温岭市",
          },
          {
            value: "B3C6B31D-CB07-407C-9D7F-B47998EC79BF",
            text: "路桥区",
          },
          {
            value: "B9CF1611-64D2-4AB3-A63C-2C025D2C07D1",
            text: "黄岩区",
          },
          {
            value: "BF13CE45-FEF4-41A9-8124-F3689822B245",
            text: "天台县",
          },
        ],
      },
      {
        value: "FC28970D-71E4-4333-A388-BEEA658F072B",
        text: "舟山市",
        children: [
          {
            value: "3B646D9F-180A-4A71-B614-DE27337B0374",
            text: "普陀区",
          },
          {
            value: "6708827D-D776-42DC-91C9-DD74951BA2EF",
            text: "定海区",
          },
          {
            value: "98DC5B8E-0972-4327-A5A1-54FD6654D5AE",
            text: "嵊泗县",
          },
          {
            value: "C29A3F11-8396-43D7-A10E-521B9B5A09DD",
            text: "岱山县",
          },
        ],
      },
    ],
  },
  {
    text: "安徽省",
    value: "BE64F691-055E-4631-9BA0-B22B91F7CF8E",
    children: [
      {
        value: "2A163003-6DA6-473F-A1AF-759349837007",
        text: "巢湖市",
        children: [
          {
            value: "1D2D0867-1A0D-4E75-95BD-1C048F91E002",
            text: "居巢区",
          },
          {
            value: "4ADB3DEF-B88D-435D-96E2-06B6E6A035C7",
            text: "无为县",
          },
          {
            value: "89616A5B-7084-481F-88E0-C566FC6854E3",
            text: "含山县",
          },
          {
            value: "C28F6B43-B475-4883-AA3D-E6B48EF67D41",
            text: "庐江县",
          },
          {
            value: "F0C90B4E-E544-40D0-8FA0-1C4EA7B5C749",
            text: "和县",
          },
        ],
      },
      {
        value: "3542AD25-A372-4435-A56D-72F4AE73FE5E",
        text: "马鞍山市",
        children: [
          {
            value: "02C66C1F-8F76-482B-B560-32AB9EC5E4CA",
            text: "金家庄区",
          },
          {
            value: "A954D037-7FF6-4DFB-96E4-5E050B66C359",
            text: "当涂县",
          },
          {
            value: "CD17EE33-7F3B-4834-9ECE-F4DC4EDC0FA2",
            text: "雨山区",
          },
          {
            value: "F6FE7009-E107-4DA1-82B6-C033753B5976",
            text: "花山区",
          },
        ],
      },
      {
        value: "4E9C4D4F-A737-4AA4-8434-90AA39FA1A6C",
        text: "蚌埠市",
        children: [
          {
            value: "06CB8484-8149-49F0-A9DE-A9368BE76651",
            text: "五河县",
          },
          {
            value: "75258168-0126-4B80-B336-68F8DDE8C0A5",
            text: "固镇县",
          },
          {
            value: "801328E4-FA4F-4E8E-BF3C-CC58E7F7899B",
            text: "怀远县",
          },
          {
            value: "84038454-5AD4-477D-8370-958A645E7044",
            text: "蚌山区",
          },
          {
            value: "970B41E9-BE94-4CD7-8795-C69C1D1CAA1B",
            text: "淮上区",
          },
          {
            value: "C1C8D758-929F-4F3E-BE05-579F3DD8DD42",
            text: "龙子湖区",
          },
          {
            value: "EF335308-9129-432E-A262-189F46B9B994",
            text: "禹会区",
          },
        ],
      },
      {
        value: "55C72F3F-BA25-4ED6-B3A1-3CC6B07A837E",
        text: "芜湖市",
        children: [
          {
            value: "082601C7-953E-4A0A-B812-E2C998BE9AF6",
            text: "鸠江区",
          },
          {
            value: "17463366-8AEE-4A6A-84B8-2C6CE9B2D92B",
            text: "芜湖县",
          },
          {
            value: "75D325BE-DD37-41F7-A30B-DCD8A203A12B",
            text: "三山区",
          },
          {
            value: "8E06E787-0DBE-4A17-81DC-E1CBAF8F4E17",
            text: "弋江区",
          },
          {
            value: "9A02D2E7-E905-4B3E-950B-0A9EC7956F0C",
            text: "南陵县",
          },
          {
            value: "DC7B4D51-BE41-4C1D-8274-3FBCAA2B4984",
            text: "繁昌县",
          },
          {
            value: "F9693F4A-4624-4CB3-92FD-358DC348A411",
            text: "镜湖区",
          },
        ],
      },
      {
        value: "5710C65B-E2B2-44D6-BC3F-8655AD6A146C",
        text: "亳州市",
        children: [
          {
            value: "8C6CD47A-DAB8-43B7-8980-C2688D8B2513",
            text: "蒙城县",
          },
          {
            value: "979B2BAF-14C2-4027-ABD6-DAF79296BB73",
            text: "谯城区",
          },
          {
            value: "AED9A19E-5401-46FD-9F17-C2A44466D4C1",
            text: "涡阳县",
          },
          {
            value: "B8FE145A-F727-49C0-A330-863CAFAAF6BC",
            text: "利辛县",
          },
        ],
      },
      {
        value: "5CB30119-2009-46FE-A801-BD8B79D0F228",
        text: "淮北市",
        children: [
          {
            value: "27E09B1B-232A-4BEC-A1E5-9E47FD4A04D5",
            text: "杜集区",
          },
          {
            value: "3E40FE41-28A9-4E1D-9CA6-A5BB5EB6F8FD",
            text: "烈山区",
          },
          {
            value: "67033532-430C-42A0-AE9A-BE39A5EB6328",
            text: "濉溪县",
          },
          {
            value: "B010260C-8B59-4F42-9835-6F9BDD804F3D",
            text: "相山区",
          },
        ],
      },
      {
        value: "72D1F517-BD4C-4588-B10D-A2F05702C602",
        text: "黄山市",
        children: [
          {
            value: "027F0487-2502-49C9-A6B8-3B665AB0346A",
            text: "歙县",
          },
          {
            value: "0701D6D4-CEF8-49C8-AF0D-A15316F0CE9E",
            text: "黟县",
          },
          {
            value: "154B4AA0-5A08-4A4C-8DDA-256ED9CC9985",
            text: "祁门县",
          },
          {
            value: "BF2E51E0-E751-4D49-B7CD-730BB709F067",
            text: "屯溪区",
          },
          {
            value: "ED058BCC-BD48-4DB2-BB25-90754E10B01F",
            text: "黄山区",
          },
          {
            value: "ED808613-7BF7-4BB1-8539-205202B13D73",
            text: "徽州区",
          },
          {
            value: "F5BFE100-D914-4D1F-9A0C-8C623D8212E8",
            text: "休宁县",
          },
        ],
      },
      {
        value: "80EFDF62-90D9-4DD9-A47F-C2657C3925BC",
        text: "六安市",
        children: [
          {
            value: "40F50D58-4E40-4DB4-8CD6-41B8A9CDE391",
            text: "金寨县",
          },
          {
            value: "64C269B0-3163-4DBA-BECE-8BFC8CE900C5",
            text: "裕安区",
          },
          {
            value: "6919DB07-E494-4104-9BE3-02AB3EC61C79",
            text: "金安区",
          },
          {
            value: "B4AEF3E6-1DEE-47B3-8A72-EA9051070B3F",
            text: "霍山县",
          },
          {
            value: "B8F65807-C07F-40CB-914B-4E16C86215B6",
            text: "霍邱县",
          },
          {
            value: "D84AB2AF-13D3-4345-8A81-3A669FD9BA60",
            text: "舒城县",
          },
          {
            value: "F3D9ABFD-9FC6-4B68-9C90-F57E47DBCF6F",
            text: "寿县",
          },
        ],
      },
      {
        value: "86841D2D-F176-488F-A753-A156F70CD96D",
        text: "淮南市",
        children: [
          {
            value: "057C5189-1A7A-41B0-BB03-83AA8F84D2B3",
            text: "田家庵区",
          },
          {
            value: "06BD88D2-C5BF-47F7-8CBE-DD21C05C6AA4",
            text: "八公山区",
          },
          {
            value: "129B2937-D3AC-412C-926F-6C934C2C7F3B",
            text: "凤台县",
          },
          {
            value: "4ACF7A73-320C-41A1-92A3-AAC9E1778E44",
            text: "谢家集区",
          },
          {
            value: "68EE6747-E1DB-4B1C-ADE8-0F21E19EF2E6",
            text: "潘集区",
          },
          {
            value: "DE81CC5A-3633-4942-8B51-05A968BE8359",
            text: "大通区",
          },
        ],
      },
      {
        value: "926A46CE-2313-4359-A7AD-E64EB46ABE07",
        text: "池州市",
        children: [
          {
            value: "19F36D1D-6BCE-44DB-9F87-2602EB14BF02",
            text: "贵池区",
          },
          {
            value: "B7EBFB68-B4AD-4831-AF90-406C1B6AA97B",
            text: "石台县",
          },
          {
            value: "EC42DB4F-B8B3-4F52-B5B6-1FDBA5549230",
            text: "东至县",
          },
          {
            value: "EFE651A9-5C27-4BAC-B8F5-A800DC858728",
            text: "青阳县",
          },
        ],
      },
      {
        value: "A34EFF2C-56DD-4AF1-9EF4-90479F9FD7C1",
        text: "宣城市",
        children: [
          {
            value: "128DE7A0-F989-4527-AB63-C9F3FE2C61F2",
            text: "宣州区",
          },
          {
            value: "26B383C3-9526-4F4B-8C63-97BBEFFA1084",
            text: "郎溪县",
          },
          {
            value: "62233AB7-CEED-4D5B-A9B7-EF882017ACD9",
            text: "绩溪县",
          },
          {
            value: "9F65E347-896C-47A1-8869-923453BD7F91",
            text: "宁国市",
          },
          {
            value: "BAF32F79-3B6F-4988-8C48-2F97450DDD31",
            text: "广德县",
          },
          {
            value: "ED6BE306-6441-4EAC-9578-6C20BADCDA82",
            text: "泾县",
          },
          {
            value: "FBF7DCB5-44AD-4FB4-932A-76EBDBB3D599",
            text: "旌德县",
          },
        ],
      },
      {
        value: "AC26B494-35DE-4658-AD04-BDE67E006E86",
        text: "滁州市",
        children: [
          {
            value: "3617523D-0F14-4E73-887E-3B6CB9A4EE28",
            text: "琅琊区",
          },
          {
            value: "40A3386D-B848-41E3-9666-60731CF0359B",
            text: "全椒县",
          },
          {
            value: "48C0867C-B3ED-4E96-9EFE-9776F8451D0C",
            text: "定远县",
          },
          {
            value: "78BA25E6-217D-4565-8D89-B02A2E2FEDE7",
            text: "天长市",
          },
          {
            value: "889629F8-FD96-421E-B8B2-1BDE401CACE0",
            text: "南谯区",
          },
          {
            value: "C30D1BC6-BE97-4B7E-8F23-C9B4675EBFD1",
            text: "凤阳县",
          },
          {
            value: "E1EF64EB-0AA7-4048-A0C3-5C5CDCB73313",
            text: "来安县",
          },
          {
            value: "F3F31908-CFD3-4FE1-BE4F-0930E426649E",
            text: "明光市",
          },
        ],
      },
      {
        value: "C57FAF59-473F-4F43-A8C8-C479C16CA983",
        text: "安庆市",
        children: [
          {
            value: "2130B65A-4CB2-46D7-B199-2C69EBDA9A43",
            text: "迎江区",
          },
          {
            value: "5048CD61-516C-4A31-AA8B-BE0D9383BEA3",
            text: "宿松县",
          },
          {
            value: "571B7F30-D42D-4ADC-A4E3-895761BD85E7",
            text: "潜山县",
          },
          {
            value: "5C63D9A5-3F3E-4D75-9B92-0ADD217AD4A5",
            text: "怀宁县",
          },
          {
            value: "6494E11E-1F4D-415E-964E-539BD871A136",
            text: "太湖县",
          },
          {
            value: "6C831340-2BDF-4048-A117-22D51713139A",
            text: "大观区",
          },
          {
            value: "9902421A-AE68-4BA5-B704-F7F21661B1FE",
            text: "岳西县",
          },
          {
            value: "AE82C3B3-9A4C-4C95-9F5A-D3FDC85EF744",
            text: "宜秀区",
          },
          {
            value: "AED78449-6A29-4300-8B1E-F07DADB203DF",
            text: "枞阳县",
          },
          {
            value: "B2B866DB-8681-4304-9C1A-3D88DD27A670",
            text: "望江县",
          },
          {
            value: "EEBDCF0F-2727-4F1B-BC9C-279E7A1414FC",
            text: "桐城市",
          },
        ],
      },
      {
        value: "D4FCAE82-3CA9-41A5-B7E9-0784907C76CB",
        text: "合肥市",
        children: [
          {
            value: "6686B961-E4C5-4766-ABF0-7823B6C53598",
            text: "长丰县",
          },
          {
            value: "935D44ED-9652-452E-8B9C-B9B854A6FB32",
            text: "蜀山区",
          },
          {
            value: "A25922D2-BD99-4D82-BCEC-846A0195FCE6",
            text: "瑶海区",
          },
          {
            value: "D0B12214-11FD-4F55-922D-72C178ECBCDC",
            text: "肥东县",
          },
          {
            value: "DCEAC48E-5FDD-412A-8AFF-065E7CC84DB6",
            text: "庐阳区",
          },
          {
            value: "EEC52939-4168-4926-A5DA-84A313C23D88",
            text: "包河区",
          },
          {
            value: "FB151ED1-A74D-467F-ACE7-DBB3E9568DD4",
            text: "肥西县",
          },
        ],
      },
      {
        value: "E0FD1909-C039-4AC9-901C-DE172B024FC3",
        text: "阜阳市",
        children: [
          {
            value: "1067B9C1-7241-4C8B-AC86-98AC6DC1CCF7",
            text: "颍泉区",
          },
          {
            value: "15536ECC-33B3-47DA-AE8F-13BE0A2C6664",
            text: "临泉县",
          },
          {
            value: "2E83583E-E30B-4CB5-BD10-927E363825D1",
            text: "界首市",
          },
          {
            value: "3E3F6F78-750A-4BA1-8283-DAA5156FC766",
            text: "阜南县",
          },
          {
            value: "49FCB506-4736-4CB5-86A5-B02E0E239085",
            text: "太和县",
          },
          {
            value: "6A864354-57CC-42C9-B8B2-FD59937E5AC3",
            text: "颍东区",
          },
          {
            value: "B51D4021-250E-44BF-A967-CAAA192369EC",
            text: "颍上县",
          },
          {
            value: "CDF11FCA-C8EC-4043-8032-C183D7245105",
            text: "颍州区",
          },
        ],
      },
      {
        value: "E101C24B-85F4-4BFD-BFC8-4AD11E77FE80",
        text: "宿州市",
        children: [
          {
            value: "07C891A0-C1E7-4106-807A-9464D9FEC15B",
            text: "砀山县",
          },
          {
            value: "0F23B61E-BA15-44A2-BEC7-2C2406ACCD50",
            text: "萧县",
          },
          {
            value: "6E26B0DE-DECF-4A0D-9996-83FDB0F8D866",
            text: "灵璧县",
          },
          {
            value: "DEDA7325-BB49-4E9C-868E-6F2BD3D28313",
            text: "泗县",
          },
          {
            value: "DF47BBA3-CC3F-41A6-AEF8-B478A88AD7E7",
            text: "墉桥区",
          },
        ],
      },
      {
        value: "E52DA9F2-6541-4EC9-9123-B39700CBCC7B",
        text: "铜陵市",
        children: [
          {
            value: "41AFC0D7-BEC0-4D11-ADF7-3DD9C35D59D6",
            text: "狮子山区",
          },
          {
            value: "4819FA5B-CAC3-4C88-94B6-180BC77BD4B4",
            text: "铜陵县",
          },
          {
            value: "BDC17115-5A8F-47A2-8276-474C8F73EA94",
            text: "铜官山区",
          },
          {
            value: "DB681276-3C28-4C79-8B82-C54A95452942",
            text: "郊区",
          },
        ],
      },
    ],
  },
  {
    text: "福建省",
    value: "9C9CAD57-A174-40B3-9214-B976ACD6AC86",
    children: [
      {
        value: "13ECA997-24E2-4E8E-AAB9-414EDF566A58",
        text: "三明市",
        children: [
          {
            value: "2C04F018-4390-4C78-8708-23C4DEA9B672",
            text: "永安市",
          },
          {
            value: "45212C49-8C23-4C94-9D97-D9E66D8592BD",
            text: "宁化县",
          },
          {
            value: "456AAC3A-C411-4C98-9F03-97ECE89F4A62",
            text: "建宁县",
          },
          {
            value: "56066A26-70E1-44AA-96D0-6421CABECCC4",
            text: "尤溪县",
          },
          {
            value: "72BFFA0D-659E-4D8E-AA09-51B216FC3958",
            text: "三元区",
          },
          {
            value: "929DA818-49AE-4C80-8CB9-F060A9A68315",
            text: "泰宁县",
          },
          {
            value: "BC45B3A2-046A-49B8-A74D-610661BF4BAE",
            text: "清流县",
          },
          {
            value: "C3F3C978-4EA5-479E-8B85-ECED05EE65AC",
            text: "梅列区",
          },
          {
            value: "DE7B4F77-C397-4DD9-945A-0B68B2960682",
            text: "大田县",
          },
          {
            value: "E71EC5D7-C83B-4B45-81AC-00F8E9989459",
            text: "沙县",
          },
          {
            value: "FC252A19-AE8B-4990-841A-567D5790039F",
            text: "明溪县",
          },
          {
            value: "FE2FA326-281D-43E6-B029-350D8BE8ED05",
            text: "将乐县",
          },
        ],
      },
      {
        value: "5D9750BF-16ED-4755-9354-276193D952FC",
        text: "宁德市",
        children: [
          {
            value: "0D92EB5F-0ECE-4269-ABBF-0A25C968BCA9",
            text: "蕉城区",
          },
          {
            value: "20B621D0-C62B-47CE-A800-5321D4B76861",
            text: "霞浦县",
          },
          {
            value: "997BEE76-68D0-4F27-9545-2896886D3451",
            text: "柘荣县",
          },
          {
            value: "9D53D784-71E2-4BBD-BE1A-F5D92C87F12A",
            text: "屏南县",
          },
          {
            value: "B387DC97-76AA-4511-98D2-A4829CC79325",
            text: "福安市",
          },
          {
            value: "C55D63A8-17C4-4E31-BFB8-963CD534FED3",
            text: "周宁县",
          },
          {
            value: "DBC90ADF-CC30-438B-BAA1-213D55ADE5D5",
            text: "寿宁县",
          },
          {
            value: "F07899BA-658C-414B-A4C8-FB913EB7ACED",
            text: "古田县",
          },
          {
            value: "F4671FE1-4330-4F56-86F4-60F8E738D395",
            text: "福鼎市",
          },
        ],
      },
      {
        value: "73210CE1-C4A0-4A32-9A29-98FC8ED2BC70",
        text: "泉州市",
        children: [
          {
            value: "0A3A3AFB-259D-4BC8-ABD5-200F24A1668C",
            text: "鲤城区",
          },
          {
            value: "0C15036F-B41C-420E-AD7B-D10F837D12F3",
            text: "南安市",
          },
          {
            value: "1C5408C5-BE27-405D-BAA7-F3142470C885",
            text: "惠安县",
          },
          {
            value: "2EE277D9-53EF-468D-B22C-875FA96E69AD",
            text: "晋江市",
          },
          {
            value: "70A2E284-D877-43AD-8DDE-BA3A152FB627",
            text: "永春县",
          },
          {
            value: "7567E012-53C6-48A3-B080-D4CE7E4E05F6",
            text: "德化县",
          },
          {
            value: "781DCA90-7028-43F7-91BE-F6707CD419CD",
            text: "丰泽区",
          },
          {
            value: "88E878C0-A290-4446-81FA-9E3FDF70E934",
            text: "洛江区",
          },
          {
            value: "B39FBD5A-6CCD-4736-B792-81860D5D35EC",
            text: "安溪县",
          },
          {
            value: "D724F290-C160-49B5-BA2B-62DDCE20917C",
            text: "石狮市",
          },
          {
            value: "F0C0AD3A-08D8-4868-AABE-AB1748695E7A",
            text: "泉港区",
          },
        ],
      },
      {
        value: "79347B30-A899-456C-9285-34FE16825057",
        text: "莆田市",
        children: [
          {
            value: "68855FF9-3D49-419C-AC83-C0E3EA730E67",
            text: "荔城区",
          },
          {
            value: "BB4C30D7-D024-4A75-9DB8-775E42E77FC4",
            text: "城厢区",
          },
          {
            value: "C88835E4-319B-49A9-A51E-BEBB92480137",
            text: "仙游县",
          },
          {
            value: "D2AF5201-E671-4139-86BC-1C947CD31C02",
            text: "涵江区",
          },
          {
            value: "F486EB08-353D-4D93-BB9D-FBB89C6EE8DA",
            text: "秀屿区",
          },
        ],
      },
      {
        value: "88D66685-20FE-481A-ACCF-3DEDCC446FB5",
        text: "福州市",
        children: [
          {
            value: "0F91B84E-1E4D-4129-9871-586EB7579F19",
            text: "晋安区",
          },
          {
            value: "2D04CCD3-EEFB-4A9A-9741-D9354CC272DD",
            text: "连江县",
          },
          {
            value: "3C84DB51-BB2D-445F-8268-103BBC6487B6",
            text: "福清市",
          },
          {
            value: "536BF3FF-0015-4E68-A83C-7E3F2A21B6A0",
            text: "闽清县",
          },
          {
            value: "53FA87B1-5E1D-424B-9BC1-A285E0A90604",
            text: "平潭县",
          },
          {
            value: "5A73F99A-5B74-4628-A20C-D3390E111B78",
            text: "仓山区",
          },
          {
            value: "9F978229-608D-4992-9290-54D88E481C09",
            text: "长乐市",
          },
          {
            value: "A1806EC6-6C23-4221-98A6-21579603E4CD",
            text: "永泰县",
          },
          {
            value: "A3F3533B-9923-46A8-9524-B9CA73B51385",
            text: "罗源县",
          },
          {
            value: "CF4E40B8-A512-49F9-8C52-B6EBED53CE9C",
            text: "鼓楼区",
          },
          {
            value: "D98B498E-1789-4828-84F3-0C5B7F5C8DB6",
            text: "台江区",
          },
          {
            value: "EFB23896-9A60-4FB0-8242-57EFDBAD2712",
            text: "马尾区",
          },
          {
            value: "FAAE36E9-A700-4152-9AB2-158C9D98B62F",
            text: "闽侯县",
          },
        ],
      },
      {
        value: "D5369C01-C82E-40B5-8250-5EAC1F3AA000",
        text: "南平市",
        children: [
          {
            value: "0C580167-CEA9-4E55-AE78-153FAF02C554",
            text: "顺昌县",
          },
          {
            value: "0DABD44E-6966-4AFD-9714-C021307C14AB",
            text: "浦城县",
          },
          {
            value: "3308F8CC-2F4E-44B8-9383-4C3EEEE0261A",
            text: "建瓯市",
          },
          {
            value: "633C0745-EF94-4A55-9D2F-FA7C57FC22FB",
            text: "政和县",
          },
          {
            value: "781356F2-7BC1-4F3E-9FC5-BD02F8CB1626",
            text: "光泽县",
          },
          {
            value: "7B86C38D-64E8-4E36-8FAE-46FDF61B4D2D",
            text: "邵武市",
          },
          {
            value: "9E9EDCE9-7B50-44A7-9394-52C185CE874F",
            text: "建阳市",
          },
          {
            value: "B7849FD0-6950-4ED9-833D-D919AB420B52",
            text: "武夷山市",
          },
          {
            value: "BE7A0E32-08A2-443D-BA1D-84D8B074EE67",
            text: "延平区",
          },
          {
            value: "F8663806-9B36-4327-B877-54BB058170A3",
            text: "松溪县",
          },
        ],
      },
      {
        value: "DFACB795-B410-4C1F-98FB-6195B0D39E9E",
        text: "漳州市",
        children: [
          {
            value: "0DB67E86-691B-4652-AFEA-CE0E62C5D9E7",
            text: "长泰县",
          },
          {
            value: "24F9353A-32D7-4B58-BAAC-2F0204832EAE",
            text: "平和县",
          },
          {
            value: "31E0341C-62B9-46BA-8A8B-B985048459A1",
            text: "芗城区",
          },
          {
            value: "8336B738-51C8-4ACE-83ED-C09FF2CECB95",
            text: "龙海市",
          },
          {
            value: "8589F09F-1725-49F2-A5E5-0789B41F2A76",
            text: "漳浦县",
          },
          {
            value: "A859A2C2-7A19-4B9E-BEFF-FCE2A4204C9B",
            text: "诏安县",
          },
          {
            value: "C6ACD205-A766-4210-BDC1-56055AAE7B50",
            text: "东山县",
          },
          {
            value: "C7B09DC3-F474-4387-9403-AD151B21A216",
            text: "南靖县",
          },
          {
            value: "F5B45A83-EE14-49D1-9BDC-1FBFE497802C",
            text: "华安县",
          },
          {
            value: "F741CA5F-B9F5-4061-85FD-516E86252051",
            text: "云霄县",
          },
          {
            value: "F831178F-4D0A-4AAE-86E5-5FCF640242A9",
            text: "龙文区",
          },
        ],
      },
      {
        value: "E02D17E7-1371-4775-9AEC-DE7328EDE672",
        text: "龙岩市",
        children: [
          {
            value: "33A198F7-84D2-47FB-B99D-1EF3CFF516C4",
            text: "漳平市",
          },
          {
            value: "3F358C88-7363-4A13-9F16-2127B85F4A1F",
            text: "永定县",
          },
          {
            value: "48A3FF1A-D333-43FB-AD24-F4264DF97D3C",
            text: "连城县",
          },
          {
            value: "5B53FA81-E585-44DE-ACE4-CED58E1FC6D8",
            text: "长汀县",
          },
          {
            value: "779EE598-6818-47F1-B333-A246059CE3DC",
            text: "上杭县",
          },
          {
            value: "89464FFF-87A1-48DC-B464-01438913EC0F",
            text: "新罗区",
          },
          {
            value: "917F01B4-CB51-474A-A59C-362D52CEA610",
            text: "武平县",
          },
        ],
      },
      {
        value: "E4DBD4A3-AFCC-430E-8E61-FE8A2B30A9D6",
        text: "厦门市",
        children: [
          {
            value: "0900822E-EC3B-4541-B354-6019009CC96C",
            text: "翔安区",
          },
          {
            value: "274613CE-00FD-4F90-8D32-898863E255E2",
            text: "湖里区",
          },
          {
            value: "36E260C4-0D5A-4E1D-8B26-44785265935E",
            text: "海沧区",
          },
          {
            value: "39B04D21-59C7-4EFD-B8BE-54A6422F43EE",
            text: "思明区",
          },
          {
            value: "B6D4115B-88FF-471E-9D5E-EDF75139E6F0",
            text: "同安区",
          },
          {
            value: "C3128975-8466-4D34-B6BA-A5897CB63F39",
            text: "集美区",
          },
        ],
      },
    ],
  },
  {
    text: "江西省",
    value: "108A4699-0D71-4628-B12E-8D19C8E653B5",
    children: [
      {
        value: "28484E0A-D3C8-47DB-ADA5-D8F1BD56F141",
        text: "吉安市",
        children: [
          {
            value: "18AD763E-4178-4498-9CA8-4DF67888211F",
            text: "永新县",
          },
          {
            value: "40812779-9406-4D2E-9B1E-7A247BEE9EA4",
            text: "泰和县",
          },
          {
            value: "4620376F-2696-4B2B-9D3A-273CFB2FB292",
            text: "永丰县",
          },
          {
            value: "4CB50757-807F-4871-947B-ED41F3E386F6",
            text: "吉州区",
          },
          {
            value: "60B71DE2-44B4-4C06-B958-6CE246D9F188",
            text: "吉水县",
          },
          {
            value: "63A4841F-D97B-4AC0-9297-7E25EB5BB908",
            text: "井冈山市",
          },
          {
            value: "7004EA45-A2CE-47D5-B549-E96B8EA2EB54",
            text: "峡江县",
          },
          {
            value: "8A312535-2EF2-4987-93C7-FB0A28750D6C",
            text: "遂川县",
          },
          {
            value: "AF1C7D9E-6485-496C-BD20-3E402198F07C",
            text: "万安县",
          },
          {
            value: "B70AD6EE-1DC1-42C9-8B49-7DE7BA50FEFD",
            text: "安福县",
          },
          {
            value: "CC235157-1653-438A-A090-3512D241BE19",
            text: "新干县",
          },
          {
            value: "D61707BD-645C-4658-B8CB-D3691EAB93A3",
            text: "青原区",
          },
          {
            value: "E436D850-363F-4F7F-85BC-6E990A0F9FA6",
            text: "吉安县",
          },
        ],
      },
      {
        value: "59F3C70B-5334-4074-8D67-F7006D58660A",
        text: "鹰潭市",
        children: [
          {
            value: "03B8F486-1D22-4B21-B06F-5A1C90AA047F",
            text: "余江县",
          },
          {
            value: "0A8A7390-8746-4617-A442-2A99966A4BD6",
            text: "月湖区",
          },
          {
            value: "580E9D3F-CD07-456F-95B6-5F1D080EC342",
            text: "贵溪市",
          },
        ],
      },
      {
        value: "5A279CFF-2B0A-4ECB-83F5-B8AC572ECC82",
        text: "上饶市",
        children: [
          {
            value: "3160DFCE-2D2C-4359-86C6-516121855FDA",
            text: "余干县",
          },
          {
            value: "38F617E7-0764-412C-AB9E-CFD9555B2F22",
            text: "万年县",
          },
          {
            value: "41C92311-8CE5-46A4-9426-C16C5B152F28",
            text: "信州区",
          },
          {
            value: "4F4ED2B9-67E1-4857-A062-32F202D2D130",
            text: "鄱阳县",
          },
          {
            value: "54F4FA16-3FA8-4178-9183-AB30BA98233B",
            text: "铅山县",
          },
          {
            value: "638B74EC-1CA8-4A0E-AC8F-AD77B005799B",
            text: "广丰县",
          },
          {
            value: "6691EDA5-20A5-4B33-BD30-259D272DAAE5",
            text: "婺源县",
          },
          {
            value: "99F50DA8-5F23-493C-AE9E-B17DE208CB01",
            text: "玉山县",
          },
          {
            value: "B7E15421-1ABE-4A58-B890-C3A02DD69B49",
            text: "德兴市",
          },
          {
            value: "C7F4753C-BD38-4D6B-9946-B279D6B47C84",
            text: "横峰县",
          },
          {
            value: "D159D215-9E90-48C6-9AD2-B3835AD31DB6",
            text: "上饶县",
          },
          {
            value: "DFF05491-AF39-49D3-954A-BA13B59BECF7",
            text: "弋阳县",
          },
        ],
      },
      {
        value: "6214AE96-69BD-4FDE-9E7B-10C7D6EF6573",
        text: "萍乡市",
        children: [
          {
            value: "013CBB85-3FE2-4915-81C7-105447326715",
            text: "莲花县",
          },
          {
            value: "56A25CAE-1CE5-454E-9782-F1560D54BD88",
            text: "安源区",
          },
          {
            value: "64C4AD9A-B082-4CC6-90A9-032EC455C609",
            text: "上栗县",
          },
          {
            value: "D1E3435B-49CA-47AB-8184-E593AC90FA9A",
            text: "芦溪县",
          },
          {
            value: "FA279058-E84E-41A6-8779-E1ABBC231747",
            text: "湘东区",
          },
        ],
      },
      {
        value: "6D3A347E-2A24-4CA9-9B8D-5CD3A3A22E3F",
        text: "宜春市",
        children: [
          {
            value: "062862AF-FBE5-48E3-9B2F-619D8A0615B9",
            text: "樟树市",
          },
          {
            value: "2E495945-9799-46B8-9E51-FB7DCE19053F",
            text: "靖安县",
          },
          {
            value: "45B1BF0C-FCF8-401B-90FF-864E01E9099B",
            text: "袁州区",
          },
          {
            value: "56447994-E1DE-4D44-83E3-6A9CA97535D4",
            text: "上高县",
          },
          {
            value: "A77FA3F2-0566-4362-A154-CAC964E16CAD",
            text: "丰城市",
          },
          {
            value: "B038A3C8-28D6-428F-A599-D951AB2A889D",
            text: "宜丰县",
          },
          {
            value: "BC303029-31F2-4024-84B0-C85DFC889EF5",
            text: "高安市",
          },
          {
            value: "C8FFEE1E-DB40-41AF-894A-F13972CF6574",
            text: "铜鼓县",
          },
          {
            value: "CECBB1C2-F0DE-4E45-A2DB-3292B37B4167",
            text: "万载县",
          },
          {
            value: "E304F037-4007-45A6-B96B-A43E5DA17606",
            text: "奉新县",
          },
        ],
      },
      {
        value: "7398E15C-7AEF-4695-8EA7-87980D932C03",
        text: "抚州市",
        children: [
          {
            value: "059C07B2-F439-48D8-AF95-DBAD06253824",
            text: "东乡县",
          },
          {
            value: "16362278-5554-43D3-BBDF-90447C5528EF",
            text: "南丰县",
          },
          {
            value: "5D02789F-058B-48DE-A081-4E5C76B0A823",
            text: "乐安县",
          },
          {
            value: "72ABDB09-97B8-4728-9230-B5020390802D",
            text: "资溪县",
          },
          {
            value: "780F4412-7106-4EB7-A011-BE06235A828A",
            text: "南城县",
          },
          {
            value: "7F6ACF2A-B3DA-4CB9-8803-C74160384A9F",
            text: "黎川县",
          },
          {
            value: "7FAD122C-4A19-46D9-8FE3-B1BC4D972267",
            text: "金溪县",
          },
          {
            value: "B11C006A-E20A-48F5-9ED5-353C4E707C53",
            text: "崇仁县",
          },
          {
            value: "BEB39892-2ACD-493A-9FE0-33048A235B7F",
            text: "宜黄县",
          },
          {
            value: "C0E116C7-1388-4B45-8760-CA39B1B9CC18",
            text: "广昌县",
          },
          {
            value: "E5123E48-229C-40EA-9A22-2AADC1B46AB4",
            text: "临川区",
          },
        ],
      },
      {
        value: "B3F418CE-E4A1-4C36-9AE1-FA05E68F8781",
        text: "景德镇市",
        children: [
          {
            value: "4A579DC3-EA25-48EF-B5ED-EA0A20AB1AAF",
            text: "珠山区",
          },
          {
            value: "6E5E00B1-2F82-4AA6-8490-6F474F38C021",
            text: "乐平市",
          },
          {
            value: "7E308E7F-86D2-4E22-B2F7-D4DBEB3E0E17",
            text: "浮梁县",
          },
          {
            value: "D21B7A80-8D46-4F01-8CCE-5FA535920BCD",
            text: "昌江区",
          },
        ],
      },
      {
        value: "B7DA1652-9306-4AB1-82D3-D6AD032621F5",
        text: "赣州市",
        children: [
          {
            value: "28F7A944-CAAA-497A-800A-ECF977FC91D2",
            text: "章贡区",
          },
          {
            value: "2971219A-CD92-427F-8492-BB77D368EDF9",
            text: "兴国县",
          },
          {
            value: "4B7891D4-67AA-4CE4-8489-497980B16C3F",
            text: "会昌县",
          },
          {
            value: "6154104E-B415-4C77-B187-2DE664C913E0",
            text: "安远县",
          },
          {
            value: "643E9446-3ED9-4FF1-88EE-A9C3278FFAB3",
            text: "于都县",
          },
          {
            value: "79D0C2D1-BB6B-4F03-A3E7-571AB20BA4AE",
            text: "定南县",
          },
          {
            value: "7BF5C575-AE03-4C9B-81B3-E723AE9F19B1",
            text: "信丰县",
          },
          {
            value: "7C40EDA4-F29B-4162-A705-E42AEC61957C",
            text: "赣县",
          },
          {
            value: "7FD90EC4-91DF-4502-B5ED-7347CCFF992D",
            text: "宁都县",
          },
          {
            value: "8C7E874A-74B9-475A-9332-9FF3FCD97032",
            text: "瑞金市",
          },
          {
            value: "933E041F-DB0F-4FA9-B624-A41B288960BF",
            text: "龙南县",
          },
          {
            value: "A0C84D10-6977-47EC-9000-0DC03C7F6CED",
            text: "上犹县",
          },
          {
            value: "A9120A7C-39F5-4C5C-B8A7-ECFAA00FC245",
            text: "崇义县",
          },
          {
            value: "BA72C2E7-CB86-44C6-8274-97C9E201C178",
            text: "南康市",
          },
          {
            value: "C7CFA314-6092-4F01-843D-39767E4116FE",
            text: "石城县",
          },
          {
            value: "CB2CCB74-4653-477D-9269-59F5EFCEB62D",
            text: "大余县",
          },
          {
            value: "E224C9E5-E328-4ED7-AB2C-B20371B4D319",
            text: "寻乌县",
          },
          {
            value: "FBB6730D-5D76-42DA-BF64-D39C2C720C53",
            text: "全南县",
          },
        ],
      },
      {
        value: "C3328EA6-AFB8-4385-BB39-A86A57FDC5B9",
        text: "九江市",
        children: [
          {
            value: "3DABC634-74BB-438C-A5F9-D379983BEADB",
            text: "德安县",
          },
          {
            value: "40925448-8781-4DEE-BB5E-445D2FF35006",
            text: "修水县",
          },
          {
            value: "758F29F3-A8AA-4CF7-9B17-714A9F5450D3",
            text: "瑞昌市",
          },
          {
            value: "8425853A-2A13-4558-B834-8CFFA2199B4F",
            text: "彭泽县",
          },
          {
            value: "88B5E8BF-FB1B-4780-9653-3D461AE025EC",
            text: "湖口县",
          },
          {
            value: "8BA91DBD-7B8C-44BB-94E6-0CD8DACDD3CD",
            text: "星子县",
          },
          {
            value: "9ECEA741-E73D-4CDB-8875-557D5A83A3E7",
            text: "永修县",
          },
          {
            value: "B0E57FE3-A10F-49D3-ADF1-9AD1A5404B10",
            text: "九江县",
          },
          {
            value: "CB41F4B8-44DB-474E-90A3-A1E203F0573F",
            text: "浔阳区",
          },
          {
            value: "CDC84213-C713-4F15-AEEB-682B922BAD71",
            text: "共青城",
          },
          {
            value: "F213BF66-CC94-4F46-992F-EEFD4E72E891",
            text: "庐山区",
          },
          {
            value: "F22FF89B-01FF-4D9F-818A-2B4BA9F42ABF",
            text: "都昌县",
          },
          {
            value: "FA418F26-F013-49DB-B502-9ADA0585BF4D",
            text: "武宁县",
          },
        ],
      },
      {
        value: "F4F0D1D4-6348-4E6A-9CAA-9AAF4991912E",
        text: "新余市",
        children: [
          {
            value: "C1CABB97-7569-49D8-A714-D0936685C183",
            text: "渝水区",
          },
          {
            value: "E6E90F9C-8B67-4AE6-87EA-E23B46556E67",
            text: "分宜县",
          },
        ],
      },
      {
        value: "FC12FD12-8A36-4DB7-A679-154FBD4846FF",
        text: "南昌市",
        children: [
          {
            value: "0352B6D7-E277-46C8-B238-542F01312ED2",
            text: "新建县",
          },
          {
            value: "0F3E06D7-A963-4EC2-B175-55FE2FC69BA4",
            text: "青云谱区",
          },
          {
            value: "6A0E360E-45B4-44F6-834C-2A7854423A12",
            text: "安义县",
          },
          {
            value: "6F8F611F-691E-48D7-9658-B91CBF1380B8",
            text: "青山湖区",
          },
          {
            value: "9179D395-E90A-4676-9501-26063DBAB0B6",
            text: "湾里区",
          },
          {
            value: "B50D34B5-7563-4846-9613-3F72D9F27368",
            text: "西湖区",
          },
          {
            value: "D0B2269B-806C-4447-8118-43776A526702",
            text: "进贤县",
          },
          {
            value: "ECA5B2F5-F3A1-4801-B80A-65D68E588176",
            text: "南昌县",
          },
          {
            value: "F689A405-FF1A-49B6-A4A8-E1FB66AA7AD8",
            text: "东湖区",
          },
        ],
      },
    ],
  },
  {
    text: "山东省",
    value: "BC657530-A1C5-4387-9015-8083273931D1",
    children: [
      {
        value: "1A63866B-3049-46F5-9943-B7CD64B92B2D",
        text: "枣庄市",
        children: [
          {
            value: "1076C620-56FF-43AE-A073-F5F787C3EB76",
            text: "薛城区",
          },
          {
            value: "3AE3A166-8462-4FBA-B66B-C1845FD889D0",
            text: "峄城区",
          },
          {
            value: "889A3565-01A7-4D3D-B3BA-56DCD38E6C07",
            text: "台儿庄区",
          },
          {
            value: "88B5BA35-1BB3-4896-9DE1-F9039792502C",
            text: "滕州市",
          },
          {
            value: "D91871DF-3C1E-4608-8BC4-6092A554E427",
            text: "市中区",
          },
          {
            value: "E4F16739-FF44-424C-A569-5C9E90F84B38",
            text: "山亭区",
          },
        ],
      },
      {
        value: "2E5245F3-EEF6-4457-B266-419BF939D868",
        text: "德州市",
        children: [
          {
            value: "1FA33DD1-FD37-4DD9-9DCB-C031E0ABBC7D",
            text: "乐陵市",
          },
          {
            value: "3679F809-58E3-441A-B4F5-AEB0231E00AC",
            text: "平原县",
          },
          {
            value: "378C84BC-9457-4B55-9436-7237105BDAA6",
            text: "庆云县",
          },
          {
            value: "3ADA2982-5D32-4EE5-BE3C-D5B51000F4F9",
            text: "临邑县",
          },
          {
            value: "3E1E5F25-D1F7-4044-A574-78A1AEE5A3F1",
            text: "夏津县",
          },
          {
            value: "812F8268-934A-469F-9694-CD039C6D0B5F",
            text: "武城县",
          },
          {
            value: "81BF9E6F-F1AE-4C7B-8465-F9102EACA560",
            text: "德城区",
          },
          {
            value: "9428522D-5E4E-405D-BFED-88C0943DD3A6",
            text: "陵县",
          },
          {
            value: "A2B66C1C-0034-4316-BACE-ECA619573052",
            text: "齐河县",
          },
          {
            value: "C51A19FE-7D49-426B-98A2-F3704300BD7E",
            text: "宁津县",
          },
          {
            value: "E51BB583-4911-4DF6-9F50-B6E0234DA0F8",
            text: "禹城市",
          },
        ],
      },
      {
        value: "2F1587B9-934D-44FE-818F-B992A2EC1E02",
        text: "莱芜市",
        children: [
          {
            value: "B4E29B63-0030-40AA-ABFB-4A524A5FE310",
            text: "莱城区",
          },
          {
            value: "F70C9BF8-F3F3-4006-974C-E86AECFC6E3E",
            text: "钢城区",
          },
        ],
      },
      {
        value: "308E3149-A4B8-4017-9183-FEC6780537B3",
        text: "菏泽市",
        children: [
          {
            value: "193225F2-C2A5-49FB-B468-9628098390E6",
            text: "单县",
          },
          {
            value: "311118BD-9ACC-4506-8FBC-9DC6D42FB389",
            text: "郓城县",
          },
          {
            value: "5300B972-F00D-49BD-9776-3F843C9019D7",
            text: "巨野县",
          },
          {
            value: "5A2042DF-B804-496A-9B41-7782E3454D9F",
            text: "曹县",
          },
          {
            value: "67FC7AAC-4F62-4FFE-A849-EFC08B9E1251",
            text: "牡丹区",
          },
          {
            value: "7C44D56B-E4AF-4CAF-AEC8-977D2B3A5A53",
            text: "成武县",
          },
          {
            value: "D6B7E49B-CEDB-459E-B10C-D68FB140E3EA",
            text: "定陶县",
          },
          {
            value: "F5AA2EBE-DF7A-41EA-9B0D-E5E7FF21C5D1",
            text: "东明县",
          },
          {
            value: "FE47FA63-44D3-4465-95EE-1B6A83F556CB",
            text: "鄄城县",
          },
        ],
      },
      {
        value: "3687391A-64D5-49B2-AAE4-42465A5CDB7D",
        text: "淄博市",
        children: [
          {
            value: "1F6A9CD4-EEFE-46BF-916E-4990AA3A3660",
            text: "博山区",
          },
          {
            value: "33622224-3511-4122-9385-DCA4BB688D90",
            text: "张店区",
          },
          {
            value: "7EF7353A-98A1-4DFF-976F-09656C6BF611",
            text: "周村区",
          },
          {
            value: "A0D9A8C5-B3F6-4AAB-8FC9-52B7212C137C",
            text: "高青县",
          },
          {
            value: "B4A0D1D6-63E1-474C-A847-B6C52B1B41E3",
            text: "临淄区",
          },
          {
            value: "C1F25ACE-F987-4C2C-B1E5-2A526B1DA804",
            text: "桓台县",
          },
          {
            value: "CDAEDBBA-6806-4571-8AE5-D0BCAC20B610",
            text: "沂源县",
          },
          {
            value: "D3E1D256-0DFB-4F3C-8132-1022BED9FD99",
            text: "淄川区",
          },
        ],
      },
      {
        value: "47BCF20C-57CE-448A-A824-7C39C7D96E95",
        text: "烟台市",
        children: [
          {
            value: "0F8D7D49-EA0E-49C9-B352-66355698CE74",
            text: "开发区",
          },
          {
            value: "2F334C02-15ED-43D4-96AD-0A74DB3140C5",
            text: "龙口市",
          },
          {
            value: "4A57DB8A-5E15-46E1-BCDF-C89A5F0894CE",
            text: "福山区",
          },
          {
            value: "59F538D7-32EE-4DAC-ABFB-52A579E1AD2F",
            text: "栖霞市",
          },
          {
            value: "5DAB5F86-5F0B-40C6-B892-5D335417EA17",
            text: "莱阳市",
          },
          {
            value: "630AE3D2-1E32-44F4-8473-234ABF1AF0A5",
            text: "招远市",
          },
          {
            value: "701E43A8-32B8-47B8-B10E-F2A221BE1C78",
            text: "芝罘区",
          },
          {
            value: "A6C8FFCD-2083-4EA6-B56F-D8EB6EA15EBE",
            text: "牟平区",
          },
          {
            value: "A9B29E85-27A4-4347-86D2-2398F1BE9DDB",
            text: "莱山区",
          },
          {
            value: "ADC79427-7DAF-4002-B0EF-44D7AA34720C",
            text: "蓬莱市",
          },
          {
            value: "B73E6689-C487-4D66-BF82-C5301F8A6CF3",
            text: "长岛县",
          },
          {
            value: "C3C7A4FF-9337-4BC7-BD06-B9E1DCE8BB3D",
            text: "海阳市",
          },
          {
            value: "E809A3F3-0F88-4206-8CFB-FF235741B73F",
            text: "莱州市",
          },
        ],
      },
      {
        value: "54A0C5DE-C650-4EF7-8FCF-BCBDA87D8E6E",
        text: "青岛市",
        children: [
          {
            value: "1F5E7E44-9F6B-4917-B982-67D8DD99346A",
            text: "城阳区",
          },
          {
            value: "27BA7802-63A3-43AF-87B8-B33042E65B12",
            text: "即墨市",
          },
          {
            value: "4A7D4A79-58A7-41BC-AEE7-036732C0438B",
            text: "市南区",
          },
          {
            value: "5124ED00-7C59-4C57-AE2A-8F7114BD89EA",
            text: "黄岛区",
          },
          {
            value: "565EDD48-3E67-461B-9B5F-60C226BDEE6E",
            text: "胶南市",
          },
          {
            value: "66ACCA31-85CC-4556-849E-E11E31406B09",
            text: "平度市",
          },
          {
            value: "8E23FD24-B04B-4B04-B9B1-7CA8E3D288D1",
            text: "市北区",
          },
          {
            value: "8E2A9A3C-908E-4F6B-B752-854D0C93C0D8",
            text: "四方区",
          },
          {
            value: "9131D115-771D-4B08-8E90-005081CF83C7",
            text: "李沧区",
          },
          {
            value: "D1618B5E-16BF-4FEB-83BB-77E54600C3F1",
            text: "胶州市",
          },
          {
            value: "D8390626-C236-49B7-B4FC-42A558AEE760",
            text: "莱西市",
          },
          {
            value: "DC8C859E-38A6-4697-AE83-710B67B16269",
            text: "崂山区",
          },
        ],
      },
      {
        value: "5D91EC11-8218-45E7-993D-C3E960CC9ED5",
        text: "泰安市",
        children: [
          {
            value: "34158991-59D0-40DA-A32E-685AE4A4BDD2",
            text: "岱岳区",
          },
          {
            value: "55D5814C-5595-4CFE-B6A6-19AFFFD45F47",
            text: "宁阳县",
          },
          {
            value: "6F59FC63-4432-4BD8-8F57-F51204FB071D",
            text: "东平县",
          },
          {
            value: "A7DC76E6-9636-4286-9D6B-681D4D5855C1",
            text: "新泰市",
          },
          {
            value: "B106EC2F-D5EE-4B4E-83BF-12E2651B9ED1",
            text: "泰山区",
          },
          {
            value: "B7CC1AC1-51CA-4970-98BB-4F7A0FD349DE",
            text: "肥城市",
          },
        ],
      },
      {
        value: "642D3C95-4BFE-4188-9FC4-BCC797DDBEDC",
        text: "东营市",
        children: [
          {
            value: "032E4201-CEF7-483F-85FA-AE6320A64203",
            text: "东营区",
          },
          {
            value: "2DB89C77-9963-4358-9B04-515C63A355AC",
            text: "利津县",
          },
          {
            value: "4E9B2BB5-9CA2-4D0D-A2F7-EDD3503188E5",
            text: "广饶县",
          },
          {
            value: "898D90FD-DDCB-41FB-8451-31705487155E",
            text: "垦利县",
          },
          {
            value: "C9890BA8-34F6-410B-BA8C-ED640F1713D4",
            text: "河口区",
          },
        ],
      },
      {
        value: "70511865-4132-461B-AD6D-1360E5294119",
        text: "济南市",
        children: [
          {
            value: "0B9CB4E2-A943-4775-AD6B-89C4F55CD2F5",
            text: "槐荫区",
          },
          {
            value: "0F7BCE01-73A8-4163-8EA0-59CCFC0CC202",
            text: "章丘市",
          },
          {
            value: "17A60506-2EAF-4F97-A768-8E6F3E584BCE",
            text: "历下区",
          },
          {
            value: "2320B720-F9D9-4079-9025-29EE7992B3B4",
            text: "天桥区",
          },
          {
            value: "56503FC1-B006-42B5-A082-17ADEDD56E52",
            text: "历城区",
          },
          {
            value: "8B30E026-4D94-48EB-9E5D-C8F8EC19BBEA",
            text: "平阴县",
          },
          {
            value: "96B2A9D8-909A-45FB-BF25-301EE768382F",
            text: "长清区",
          },
          {
            value: "AF8CF700-A045-4490-8C5D-DFD3FEBAACFE",
            text: "济阳县",
          },
          {
            value: "C7A14CFC-85F2-4208-AA81-DB722BAFCE5E",
            text: "市中区",
          },
          {
            value: "DC9DFA62-85B8-431D-B2C9-D72414AB3CEC",
            text: "商河县",
          },
        ],
      },
      {
        value: "72178F0A-DFFC-45B3-92D3-029D20C23DAE",
        text: "日照市",
        children: [
          {
            value: "1C23FDEA-4B6B-4581-AA8F-AD74B2CC5F1C",
            text: "东港区",
          },
          {
            value: "C7F4DB00-C18B-4004-8D4E-68C087CC0AD5",
            text: "莒县",
          },
          {
            value: "E02D361F-3E51-41F1-A929-6EF64DFC0316",
            text: "五莲县",
          },
          {
            value: "EE40AEFB-91C5-44A1-8011-CCA188A76EED",
            text: "岚山区",
          },
        ],
      },
      {
        value: "B02619E2-7683-4A0E-A60C-310C44927640",
        text: "临沂市",
        children: [
          {
            value: "068100F3-BA81-46E3-80AB-B0D9CCF6EE90",
            text: "费县",
          },
          {
            value: "1E25410A-0F59-4896-BC2D-F4E7F005D459",
            text: "蒙阴县",
          },
          {
            value: "246E6277-3EC9-4F69-BABC-0CBFFBEC71D4",
            text: "郯城县",
          },
          {
            value: "470D3F0F-114F-409A-9F57-B7CFABD50B87",
            text: "平邑县",
          },
          {
            value: "4EC0986A-2E56-4C11-86C7-2725BA46AD7A",
            text: "沂南县",
          },
          {
            value: "5EC634AC-86D9-46EB-94AB-C84A74035109",
            text: "河东区",
          },
          {
            value: "7A5F4C94-865F-445A-A96E-FB8E995EF1EF",
            text: "莒南县",
          },
          {
            value: "912EE5AD-919B-4F02-9971-A9E1718F3833",
            text: "罗庄区",
          },
          {
            value: "9D3D1471-CBC2-44B5-85BB-7D5DBA7224FD",
            text: "苍山县",
          },
          {
            value: "B32D81C3-C551-43BD-877B-77F6362CCC20",
            text: "兰山区",
          },
          {
            value: "DD799EA1-4B23-4B0E-BA31-C65496470A10",
            text: "沂水县",
          },
          {
            value: "E5C1F3A7-7BB1-4E1A-8243-19B87C6C8027",
            text: "临沭县",
          },
        ],
      },
      {
        value: "D8BCF3B3-FDB6-4E14-BFED-65E9994F141E",
        text: "滨州市",
        children: [
          {
            value: "05CD3C7A-5D75-4212-B290-9A2856FEFE82",
            text: "博兴县",
          },
          {
            value: "0A6B9553-0493-40F6-B766-4964ABCD5970",
            text: "沾化县",
          },
          {
            value: "2951F7C0-7670-4900-B861-D608440989BF",
            text: "无棣县",
          },
          {
            value: "9E0CABCF-967E-46A3-B6D8-D592F175914E",
            text: "惠民县",
          },
          {
            value: "B23629E6-C57C-478D-8525-DBC861931621",
            text: "阳信县",
          },
          {
            value: "BB588611-571B-4E78-AC39-C189D719FE7F",
            text: "滨城区",
          },
          {
            value: "F3839FA5-5CFC-4EB9-919E-B84617663B58",
            text: "邹平县",
          },
        ],
      },
      {
        value: "E54AF36A-994B-4CF4-BD39-95145C8444D4",
        text: "潍坊市",
        children: [
          {
            value: "0196DBD4-EF00-4EFA-AE93-9174F3913252",
            text: "昌邑市",
          },
          {
            value: "48FA1F6E-A06F-40C1-91D3-B145F3C4A2A3",
            text: "坊子区",
          },
          {
            value: "656A3A3B-1EDD-4909-80D8-D8117AF5A39B",
            text: "潍城区",
          },
          {
            value: "73939CDF-A884-4F3A-9AF6-C3CDE8159ADA",
            text: "青州市",
          },
          {
            value: "84CAF7F0-E273-4D04-9F05-30EB5622F67A",
            text: "安丘市",
          },
          {
            value: "88BA3425-69DE-4276-BD04-90A18900488C",
            text: "奎文区",
          },
          {
            value: "CCF8EA33-6AE0-4D10-A3DF-373BF0F5A002",
            text: "寿光市",
          },
          {
            value: "D06A8A86-AD79-4FC6-9455-368815CD4F28",
            text: "昌乐县",
          },
          {
            value: "D841FCC1-963C-4636-B816-50DAED6A6589",
            text: "高密市",
          },
          {
            value: "DB02EF18-673D-4881-911E-3597D1FC797B",
            text: "临朐县",
          },
          {
            value: "DF76F1C8-D582-4E5A-9ACA-602AB3782CFA",
            text: "诸城市",
          },
          {
            value: "FFD086F1-ACDE-4656-989C-B3BB38CE08FB",
            text: "寒亭区",
          },
        ],
      },
      {
        value: "F36DBDBD-1503-4E71-925D-4866BC705670",
        text: "威海市",
        children: [
          {
            value: "2B565996-F955-4AFE-A442-32B9B09B19B4",
            text: "环翠区",
          },
          {
            value: "60AFDFC5-E367-4374-BD00-072912C02978",
            text: "文登市",
          },
          {
            value: "B463726C-A0AC-4186-A2F9-D158710F934F",
            text: "乳山市",
          },
          {
            value: "BF4D5B33-817D-44C7-9462-60152CBEB98E",
            text: "荣成市",
          },
        ],
      },
      {
        value: "FAC79BD1-772C-4A49-B144-3AB3CEF8AE07",
        text: "济宁市",
        children: [
          {
            value: "015CF794-23F5-4275-B808-3CB25BCAC1F7",
            text: "金乡县",
          },
          {
            value: "1451A961-DA15-4259-BD27-7EE8F783A200",
            text: "邹城市",
          },
          {
            value: "1B3AB980-0554-4AD3-A61C-76B524B3E0B4",
            text: "任城区",
          },
          {
            value: "43F3F8AA-88CE-4B91-91DC-B3BBB27F2762",
            text: "嘉祥县",
          },
          {
            value: "4C0648EF-F7BA-4F44-9C45-DDF385D29210",
            text: "鱼台县",
          },
          {
            value: "51272B78-543D-4B5D-9C3A-1F32CE001D52",
            text: "兖州市",
          },
          {
            value: "920DE769-17D9-445F-A00F-432B89613163",
            text: "汶上县",
          },
          {
            value: "94B7B91A-65BE-438D-B044-CF7DEF086DFE",
            text: "微山县",
          },
          {
            value: "A71CEEE7-0D46-431B-9CFA-5A0FBDD94085",
            text: "泗水县",
          },
          {
            value: "D338E541-C182-44A5-B7A0-41A531321F30",
            text: "市中区",
          },
          {
            value: "F07C7E07-4453-4A67-9185-A8FE2FE47C87",
            text: "曲阜市",
          },
          {
            value: "FE40B957-83D6-4DE8-BB7F-D494264E2769",
            text: "梁山县",
          },
        ],
      },
      {
        value: "FD48A7AD-39C6-478F-972F-B7F84F1FA75E",
        text: "聊城市",
        children: [
          {
            value: "106B8D82-C33B-42BF-9AE9-51C08D5DC0FD",
            text: "阳谷县",
          },
          {
            value: "10F4E82F-F9A5-47AE-AF24-8A8A754D92E6",
            text: "莘县",
          },
          {
            value: "36400976-0C9E-4E9F-9A60-34BC5E437740",
            text: "茌平县",
          },
          {
            value: "52569279-5BFA-4542-95DE-7F0A548883A5",
            text: "高唐县",
          },
          {
            value: "6C362FC6-BD7C-4C05-8473-FC2EEDF05FD4",
            text: "东阿县",
          },
          {
            value: "71F4D89A-41A3-4F76-9A96-A74A993127AD",
            text: "冠县",
          },
          {
            value: "82315C27-7D5E-4E81-9B0F-29439955CD07",
            text: "东昌府区",
          },
          {
            value: "B87F6643-9309-4A16-8085-D374060E11F2",
            text: "临清市",
          },
        ],
      },
    ],
  },
  {
    text: "河南省",
    value: "35A013DF-F53F-433C-9A9C-AD1AA45B5B57",
    children: [
      {
        value: "1E43616C-5EB3-49DE-9C0E-7ACD24043D7E",
        text: "开封市",
        children: [
          {
            value: "0E37C206-71C1-4A95-A805-EFD137311018",
            text: "龙亭区",
          },
          {
            value: "5EDCDA66-C1CD-4DA0-A5D8-398D55286EBC",
            text: "开封县",
          },
          {
            value: "5FC5EB29-4750-48FF-AB47-B3397DA5B85F",
            text: "顺河回族区",
          },
          {
            value: "6447CCCC-4A9F-4FA6-A0FB-D4B8481E72D1",
            text: "通许县",
          },
          {
            value: "68193543-9A06-417B-941C-070D945DE21C",
            text: "金明区",
          },
          {
            value: "7B0FF909-86F8-4786-B7D8-B33AB04D9FF1",
            text: "尉氏县",
          },
          {
            value: "88032D0C-4390-4C60-9F87-E170758D91A1",
            text: "杞县",
          },
          {
            value: "8CECDAED-2025-4AAE-9A04-9539023988A3",
            text: "禹王台区",
          },
          {
            value: "CDCE4331-FFC4-4A29-A719-102940E2E646",
            text: "鼓楼区",
          },
          {
            value: "F52F35AC-8A9E-48CA-B179-FB3286247A6C",
            text: "兰考县",
          },
        ],
      },
      {
        value: "22937643-C150-431B-A995-C36F767DB28F",
        text: "洛阳市",
        children: [
          {
            value: "0204E2F7-4CBA-4B22-9A5D-F09C0AD59ECB",
            text: "西工区",
          },
          {
            value: "031EB671-D335-4040-8098-6EBBBF7738EA",
            text: "孟津县",
          },
          {
            value: "06D7815F-D762-433D-9043-8D755C5C2B05",
            text: "嵩县",
          },
          {
            value: "0A38B0B6-E0C9-4E48-936A-F4755C391BBD",
            text: "瀍河回族区",
          },
          {
            value: "220593F3-3B3D-4963-A86B-29E11B1F6797",
            text: "偃师市",
          },
          {
            value: "266FBBED-B33B-4D30-B227-6C97F7EEE274",
            text: "老城区",
          },
          {
            value: "26E10744-FDED-4D3A-9611-8BFDBAB855F4",
            text: "新安县",
          },
          {
            value: "2C362C3C-08FD-46D1-8714-06905DF411F9",
            text: "洛龙区",
          },
          {
            value: "3F486047-CC7B-4B18-B9E1-DA4A19EBA9D5",
            text: "宜阳县",
          },
          {
            value: "748C4491-66B6-46E0-8A73-DD5D5AF0619A",
            text: "洛宁县",
          },
          {
            value: "78313FA5-EB1E-4203-B3BD-C32845F4F627",
            text: "吉利区",
          },
          {
            value: "7FD48A01-3B35-4E68-B640-A48BAE5299A6",
            text: "涧西区",
          },
          {
            value: "AF51667B-5596-4BB7-ACAC-C34F6B8703F5",
            text: "栾川县",
          },
          {
            value: "BE5F7D3F-31EB-4628-AD1F-30279D3438B3",
            text: "伊川县",
          },
          {
            value: "F119421B-168D-4291-B3A8-C3401E365BCD",
            text: "汝阳县",
          },
        ],
      },
      {
        value: "22B14DFC-6080-4253-8DB7-E9ECBA91E59F",
        text: "漯河市",
        children: [
          {
            value: "10372E60-86C8-46D7-B544-DA33C923E0A5",
            text: "郾城区",
          },
          {
            value: "1B52A74E-D3A7-49EC-976F-B079562E7784",
            text: "源汇区",
          },
          {
            value: "D7D9BCD3-26D3-4788-9622-CD1E8DF1FAE9",
            text: "临颍县",
          },
          {
            value: "F184809E-AD81-4549-B167-D841CEBAFE2B",
            text: "召陵区",
          },
          {
            value: "F78A7A16-8E21-4DBF-AD98-C8AECFE06F09",
            text: "舞阳县",
          },
        ],
      },
      {
        value: "3F004DCF-3445-49DA-A45D-DD9D931D9E35",
        text: "信阳市",
        children: [
          {
            value: "04633DCA-2DE9-4C1D-980C-C99BE06132B7",
            text: "固始县",
          },
          {
            value: "2D473489-BDE5-4D52-844B-0FB384460176",
            text: "商城县",
          },
          {
            value: "3691E9BC-DFC3-4C32-8837-27257252FAA4",
            text: "光山县",
          },
          {
            value: "4BBE1117-45BD-4658-AA7A-8344D354547C",
            text: "淮滨县",
          },
          {
            value: "51953A34-4FB7-40BD-AE1A-936BD8824E2B",
            text: "罗山县",
          },
          {
            value: "66272FBE-CC49-4251-AD43-42415A767FFD",
            text: "潢川县",
          },
          {
            value: "911D71FF-EB28-4459-BC8C-CFC9215DF08D",
            text: "息县",
          },
          {
            value: "9BE6CFAE-EB31-4A61-957A-5C1F7C5B0303",
            text: "新县",
          },
          {
            value: "B80FCDA9-76C4-43EF-925F-7F6C6C890F01",
            text: "浉河区",
          },
          {
            value: "F34B9C6A-C47E-4487-914B-A57723E2BD2D",
            text: "平桥区",
          },
        ],
      },
      {
        value: "42B99C7E-9317-4B60-BBED-24A304416CC1",
        text: "驻马店市",
        children: [
          {
            value: "37EE6CBF-7CAF-4B57-A7A1-185CF12A52E5",
            text: "驿城区",
          },
          {
            value: "42FFE676-4B7A-4705-8476-CAC85A7D9F72",
            text: "新蔡县",
          },
          {
            value: "5263601E-70A5-4231-8DDE-B50FD7F50D8F",
            text: "确山县",
          },
          {
            value: "560DE074-43B9-40EA-8D7C-69A372248583",
            text: "上蔡县",
          },
          {
            value: "5ED327E4-8AB7-4CDE-AB34-71BEFB00523C",
            text: "泌阳县",
          },
          {
            value: "901F514E-0616-4EC6-964D-0681493D5420",
            text: "西平县",
          },
          {
            value: "A0DC101C-2404-4859-A092-273FFD00438E",
            text: "遂平县",
          },
          {
            value: "A9DBC59E-70DD-49A8-A6A2-45ACEC8814C7",
            text: "汝南县",
          },
          {
            value: "B55808C5-33B6-4857-81E3-EB09C9401D1E",
            text: "平舆县",
          },
          {
            value: "DF42E89A-D766-4D9C-9133-09678EC9B2B1",
            text: "正阳县",
          },
        ],
      },
      {
        value: "64C5F9E4-FC02-4B28-9286-B994030D3083",
        text: "周口市",
        children: [
          {
            value: "0C7A9209-34AE-4F73-9F1E-04C599941B8B",
            text: "川汇区",
          },
          {
            value: "32D79622-DF86-49DA-90AE-5E5BDE5E31B0",
            text: "鹿邑县",
          },
          {
            value: "35691120-A66F-46FF-A289-98DC324A17CA",
            text: "西华县",
          },
          {
            value: "7D356D45-3542-4ED5-885B-B38CA8E3DFF8",
            text: "太康县",
          },
          {
            value: "82F51FB3-A212-4682-8F66-72DBB272C69D",
            text: "沈丘县",
          },
          {
            value: "91E7AECA-BF3B-4C07-95A4-B7512A50BC1C",
            text: "郸城县",
          },
          {
            value: "980EA1CC-DAD4-4EE7-AAED-4105A2B7CC66",
            text: "淮阳县",
          },
          {
            value: "CA425FEF-05E7-490A-AE23-B5C6A473AFDD",
            text: "商水县",
          },
          {
            value: "CECEF7D1-1931-4CFD-A388-5E8D51FF8CC5",
            text: "扶沟县",
          },
          {
            value: "FC664F61-E1E2-4FE9-BEE5-34C49DB7F026",
            text: "项城市",
          },
        ],
      },
      {
        value: "698E09D5-4683-467B-8553-00DFBAFC1488",
        text: "焦作市",
        children: [
          {
            value: "0D377A48-BC38-4A15-949E-12DD60EC54B0",
            text: "温县",
          },
          {
            value: "167E4837-4F91-48F2-8165-DD255E71DF60",
            text: "修武县",
          },
          {
            value: "55061051-B75D-4716-9B34-B470CBCF3F73",
            text: "中站区",
          },
          {
            value: "80E31BEA-6EB1-4F27-8A6B-33A48E45282E",
            text: "山阳区",
          },
          {
            value: "94164640-29DE-40F0-BD46-E31C8BE91630",
            text: "博爱县",
          },
          {
            value: "A887D7B2-F731-407B-A8C9-E53E73524C9C",
            text: "沁阳市",
          },
          {
            value: "CD7B0115-66AA-4ED3-BCBF-EBD862C4FAB8",
            text: "武陟县",
          },
          {
            value: "D8570EE7-7654-4B6E-9B82-B7BF91668F18",
            text: "孟州市",
          },
          {
            value: "DECF0A27-A5FE-45E9-A6C7-119171641AA6",
            text: "解放区",
          },
        ],
      },
      {
        value: "69FF0D8A-F3CC-4BF9-9F33-DE59CA036CEB",
        text: "濮阳市",
        children: [
          {
            value: "107F96DD-6DC0-4DBD-9098-D5ABC3C18018",
            text: "范县",
          },
          {
            value: "2C84B2A0-4C0A-4A92-B0DE-9CA668B32D11",
            text: "华龙区",
          },
          {
            value: "41BAC54C-E833-426A-AC55-90FD1994766E",
            text: "濮阳县",
          },
          {
            value: "9F37EB1D-3718-460F-9C62-1B090D414D32",
            text: "南乐县",
          },
          {
            value: "CAABDB2E-B6E6-4209-A2E7-A31493331FF8",
            text: "台前县",
          },
          {
            value: "DB554377-9779-4285-8B4E-FB2937019C4E",
            text: "清丰县",
          },
        ],
      },
      {
        value: "6DD6277D-E9D5-4B1E-8774-1EB2C1FD624B",
        text: "郑州市",
        children: [
          {
            value: "12C80AF8-5102-4B2A-97B1-24648FFF1F65",
            text: "管城回族区",
          },
          {
            value: "5130B291-A3C6-425D-A23C-9522E371C8C1",
            text: "登封市",
          },
          {
            value: "60F7EDA5-3652-41AD-B43B-3476AC541E6B",
            text: "中牟县",
          },
          {
            value: "6870DDA4-17BD-4DB0-A127-11F03C3CAD15",
            text: "中原区",
          },
          {
            value: "74ACBD28-7E1C-46E5-B15D-C4C225B71047",
            text: "上街区",
          },
          {
            value: "789196D3-7BEB-4910-819B-CB7916473CD5",
            text: "荥阳市",
          },
          {
            value: "B51613DA-9D22-47E3-975B-B5196D23F370",
            text: "二七区",
          },
          {
            value: "BAA72F30-68D7-4336-9672-1C4372EDEDF9",
            text: "新密市",
          },
          {
            value: "C33FFE9F-40C8-4F76-AEE0-BB7815EF2E01",
            text: "新郑市",
          },
          {
            value: "CE4CAA1D-F8F8-4EBA-8EEE-2243C399732A",
            text: "巩义市",
          },
          {
            value: "E2512F88-2E5F-4B5A-91A2-5673BF0D7AC1",
            text: "惠济区",
          },
          {
            value: "F2BEF4BF-1832-451B-87D2-BB8311A173C6",
            text: "金水区",
          },
        ],
      },
      {
        value: "7D050D7D-3818-4FA4-A37B-AFFBA815E261",
        text: "许昌市",
        children: [
          {
            value: "3DD1B189-AAFB-4DAE-B00B-1EA48960F88D",
            text: "魏都区",
          },
          {
            value: "3ECCA047-12C3-4DE8-A141-E6224AF0BE1B",
            text: "长葛市",
          },
          {
            value: "4367C172-9440-4349-A46B-BFF50A0CE242",
            text: "襄城县",
          },
          {
            value: "6FF9ECEF-A4B7-459B-A542-8F095CC31CE0",
            text: "鄢陵县",
          },
          {
            value: "9FA0C23E-AE43-428D-AA0D-5FD7A32F21F5",
            text: "许昌县",
          },
          {
            value: "C8CE9399-A53D-498F-AF20-BAF08A62632E",
            text: "禹州市",
          },
        ],
      },
      {
        value: "AE556DED-27F4-4D39-B934-7CB6FF74C280",
        text: "新乡市",
        children: [
          {
            value: "01A02938-BE02-41D2-965D-C3B8D84DF4DC",
            text: "牧野区",
          },
          {
            value: "2CA33D55-5E27-4E81-B89E-EFAAD035DC8A",
            text: "封丘县",
          },
          {
            value: "3EEB1FBF-F6E3-4F47-9702-EEF00AE280CB",
            text: "长垣县",
          },
          {
            value: "46CE0E26-A4C1-4632-AE95-B49E4AC1DEF1",
            text: "新乡县",
          },
          {
            value: "60C22B27-BB3B-432D-928B-07324DF1C67D",
            text: "红旗区",
          },
          {
            value: "61208A7D-8A0C-42D2-9D8D-856E086090A4",
            text: "延津县",
          },
          {
            value: "7567F2E3-5881-4AB3-99F3-8D1964A2B9D3",
            text: "获嘉县",
          },
          {
            value: "86483596-11C2-49CA-BD5C-B846FB93A740",
            text: "卫辉市",
          },
          {
            value: "A793EC54-D022-4034-8AD9-B8D58B3E963D",
            text: "凤泉区",
          },
          {
            value: "D24A25EB-5AE3-45C9-A924-0D9024D2FD08",
            text: "辉县市",
          },
          {
            value: "E1B9A7D4-8493-4A06-B1A0-42A82BCA2365",
            text: "卫滨区",
          },
          {
            value: "F59B66C4-C167-49C9-9D41-4B0F414788D6",
            text: "原阳县",
          },
        ],
      },
      {
        value: "C98CD89A-1C5F-43C4-B03A-63D1D29C8725",
        text: "济源市",
        children: [],
      },
      {
        value: "CE40391F-F693-4832-AE80-23A96231DFDC",
        text: "平顶山市",
        children: [
          {
            value: "01AF7F23-C80F-436F-A798-8408DA0F7385",
            text: "汝州市",
          },
          {
            value: "19678379-46A8-4F1E-AF23-6085C7CE7C8A",
            text: "叶县",
          },
          {
            value: "4E4992AC-5DE2-4B86-999A-72A191A37D28",
            text: "湛河区",
          },
          {
            value: "7F98BFC5-E696-4159-811F-AB3FF51A7840",
            text: "舞钢市",
          },
          {
            value: "B868A44E-BF62-4CA8-96F4-170A867207FC",
            text: "宝丰县",
          },
          {
            value: "C029F4C4-4C9E-47AB-947B-B42D02BAA326",
            text: "鲁山县",
          },
          {
            value: "C6ECA223-3298-4B63-ADFE-4E33D1B180B4",
            text: "新华区",
          },
          {
            value: "D8226C64-961B-453B-8F6C-AB1A141096F4",
            text: "卫东区",
          },
          {
            value: "DDDA1A20-ED44-4333-B84D-C4B9726357CE",
            text: "石龙区",
          },
          {
            value: "E5118CFD-2C85-475B-8937-783BDBDBEAF0",
            text: "郏县",
          },
        ],
      },
      {
        value: "CED372B2-F0B7-436E-9B7D-4F57383DFC56",
        text: "南阳市",
        children: [
          {
            value: "188755D0-13ED-4305-842B-BA83AF505825",
            text: "内乡县",
          },
          {
            value: "18F9528D-1F2A-433C-96B3-6DC79E6D3D22",
            text: "卧龙区",
          },
          {
            value: "1FA87956-EABF-49DF-B582-42E7D3E3B0D2",
            text: "西峡县",
          },
          {
            value: "2B02DDF7-CFE3-41FE-BF99-9767275FA804",
            text: "方城县",
          },
          {
            value: "44B980C1-F900-4F7B-971D-A361E9CFC3BD",
            text: "新野县",
          },
          {
            value: "4CC24D0E-DD75-4BEC-960C-7269666E0552",
            text: "南召县",
          },
          {
            value: "56A428E6-BC4A-42D8-91BE-DA0097D0841F",
            text: "唐河县",
          },
          {
            value: "64691BD3-A232-4749-B1FD-AE4C48EB4C56",
            text: "宛城区",
          },
          {
            value: "826242FF-A8BD-46F6-BDC7-D2AA5C02148D",
            text: "社旗县",
          },
          {
            value: "9EA9C7E3-C5EA-444C-9A6F-16AA55F1668E",
            text: "淅川县",
          },
          {
            value: "AD180391-987C-47F1-8D6F-12C05B17EC9B",
            text: "桐柏县",
          },
          {
            value: "D2D8F8C5-79FC-4104-9F7D-65C68778983A",
            text: "邓州市",
          },
          {
            value: "D81C9B31-AF58-40DA-B9EB-043900B1CE01",
            text: "镇平县",
          },
        ],
      },
      {
        value: "D6A3F582-E3E1-438E-A3DC-E26CD388879D",
        text: "鹤壁市",
        children: [
          {
            value: "0129D54F-9E23-41BC-BA5B-7A8166C4C642",
            text: "淇县",
          },
          {
            value: "01E32C41-F18B-4EB9-950F-F57E5BFFD2AC",
            text: "淇滨区",
          },
          {
            value: "27C64C9E-875D-42F2-9102-29D656C8C33B",
            text: "浚县",
          },
          {
            value: "4B224E20-F415-4CA1-84BC-056F0DF29683",
            text: "山城区",
          },
          {
            value: "582F48F4-CC39-45D0-BC17-8D4413609612",
            text: "鹤山区",
          },
        ],
      },
      {
        value: "D7C9C62F-6464-461A-90F2-CADF1624AA4B",
        text: "三门峡市",
        children: [
          {
            value: "5B94661B-599A-4295-BE78-247D764F9F27",
            text: "陕县",
          },
          {
            value: "76703EB0-F446-41E2-BB3F-B236ED35DB34",
            text: "灵宝市",
          },
          {
            value: "B06F57E4-9C4B-4C9E-8792-EB19711A3D1E",
            text: "渑池县",
          },
          {
            value: "CFCA3869-51C3-4068-B18F-885786BF0C25",
            text: "义马市",
          },
          {
            value: "DD58FB4D-912C-4943-B9B1-472D43D92566",
            text: "湖滨区",
          },
          {
            value: "F6FD671E-3DB6-4FE1-915C-A7F788A72FBD",
            text: "卢氏县",
          },
        ],
      },
      {
        value: "E57C4C68-7BED-4933-8E3A-29947B70A297",
        text: "安阳市",
        children: [
          {
            value: "021FDCEF-D9E2-48AA-82D8-ABCA1E0FFE32",
            text: "滑县",
          },
          {
            value: "13ACC8F7-D30E-4A6B-8664-F1E70876F854",
            text: "龙安区",
          },
          {
            value: "18670DA1-995A-4C78-BB8C-8D268A96CA2E",
            text: "文峰区",
          },
          {
            value: "1C079F42-0A63-4648-9460-5FBFC84C3147",
            text: "安阳县",
          },
          {
            value: "1D7B8642-0260-4138-81F1-743521B6E87E",
            text: "北关区",
          },
          {
            value: "2DA6D75B-B586-46A5-A510-082161057AFB",
            text: "林州市",
          },
          {
            value: "41969FED-E586-4C7B-8CB6-60BCDE0A5299",
            text: "汤阴县",
          },
          {
            value: "6743B7CB-FCFA-4BB2-AB17-98483E3AF7CE",
            text: "殷都区",
          },
          {
            value: "BBEB8221-FAFF-4CED-90A4-6D7F0BA0990A",
            text: "内黄县",
          },
        ],
      },
      {
        value: "EAE6DB9A-F13B-4A9C-A62C-4719036EFA72",
        text: "商丘市",
        children: [
          {
            value: "0843C83D-0DE5-4AE8-8B8A-DA499044C63E",
            text: "虞城县",
          },
          {
            value: "09B442CA-157D-4A13-87E0-CABBAA977D07",
            text: "永城市",
          },
          {
            value: "26E1A4EF-4CA2-4358-AE95-DAF0DFF162A6",
            text: "睢县",
          },
          {
            value: "27301A7B-FD7A-495D-9F09-ED129F0E1E45",
            text: "夏邑县",
          },
          {
            value: "2B870795-DE84-41D0-A9C8-CBC19709B353",
            text: "宁陵县",
          },
          {
            value: "5C1B7522-781C-4E49-B666-983689676592",
            text: "柘城县",
          },
          {
            value: "92E50487-5F41-4EC0-912E-1407CF51CDD8",
            text: "民权县",
          },
          {
            value: "98025CA2-D30D-4742-8776-9EE717832B2E",
            text: "睢阳区",
          },
          {
            value: "BAFC7233-BC65-46FD-AAE6-489DE0304B65",
            text: "梁园区",
          },
        ],
      },
    ],
  },
  {
    text: "湖北省",
    value: "1C90A1EE-70FD-4A0A-A8D9-D2854289161B",
    children: [
      {
        value: "0DF882F2-6B74-4E44-9128-92851A2F3F7A",
        text: "恩施土家族苗族自治州",
        children: [
          {
            value: "165EAE6E-5866-4B68-A390-2C4EC1140E1B",
            text: "建始县",
          },
          {
            value: "6E8F92FD-34CC-417B-9B57-3207E890FF8B",
            text: "宣恩县",
          },
          {
            value: "77AC0535-F463-4550-8D84-D506046D9C00",
            text: "巴东县",
          },
          {
            value: "7CA6FBEE-A635-4E4F-8284-2956B526CC61",
            text: "利川市",
          },
          {
            value: "8C2F0077-8B02-4513-9B79-C796E02895AC",
            text: "来凤县",
          },
          {
            value: "9E51EADA-DF36-4DC9-81F3-844575375325",
            text: "鹤峰县",
          },
          {
            value: "DEF7CEA2-5132-4F7E-BF4C-7BB9F563D597",
            text: "恩施市",
          },
          {
            value: "F2C094F5-7354-43A5-8453-E37CD6181056",
            text: "咸丰县",
          },
        ],
      },
      {
        value: "25BB77F7-DBD1-4C72-B410-29D5D6C647D5",
        text: "襄樊市",
        children: [
          {
            value: "2FA997FC-3714-4B79-828A-180B67EADA1A",
            text: "襄阳区",
          },
          {
            value: "33E3D8F7-9E00-4544-80D0-4A5D37E2361F",
            text: "保康县",
          },
          {
            value: "5C4115D3-D23A-487B-A0D7-A8C369BCC33A",
            text: "宜城市",
          },
          {
            value: "68EEC833-FCB3-4AF7-8891-D7417B85F636",
            text: "谷城县",
          },
          {
            value: "923AF155-ECA5-404C-9189-7A0387A8CB54",
            text: "襄城区",
          },
          {
            value: "B25AEB79-3235-4753-8B0E-36195C456FC4",
            text: "南漳县",
          },
          {
            value: "D8AA19B3-D4D6-4603-A125-A2C131F87C34",
            text: "樊城区",
          },
          {
            value: "DAEAC392-8428-47A9-B721-F7BF10AEC1D5",
            text: "枣阳市",
          },
          {
            value: "F61CBFD3-4325-4F3C-B4D4-0E5F214AFEAD",
            text: "老河口市",
          },
        ],
      },
      {
        value: "3F03042F-E5F3-430A-BEA9-DEE9C01DEF4E",
        text: "宜昌市",
        children: [
          {
            value: "088856BE-6658-4A81-A395-7AAE7A99249A",
            text: "点军区",
          },
          {
            value: "0CDADF20-E5FF-4C64-A26B-DDCDCC07904A",
            text: "五峰土家族自治县",
          },
          {
            value: "0E3DC800-1AA5-4984-B1B2-51105914BC5B",
            text: "远安县",
          },
          {
            value: "11268C3E-A3F9-4428-A19B-97EAD39D26ED",
            text: "兴山县",
          },
          {
            value: "4060D2F7-E0EB-4A53-B36C-678ABCFC5CF3",
            text: "秭归县",
          },
          {
            value: "53B226B8-2B20-45C0-852F-D73F511F1C7B",
            text: "猇亭区",
          },
          {
            value: "8D54F792-BF3D-442D-9DAF-F477D105FE6A",
            text: "伍家岗区",
          },
          {
            value: "B50AFD65-084E-4CC5-A516-9F150772FE0D",
            text: "当阳市",
          },
          {
            value: "DA7188E1-17C2-4711-80FC-B10817ECEC8A",
            text: "宜都市",
          },
          {
            value: "DAAFDF37-9818-4881-91E9-EE440BEEB1DE",
            text: "夷陵区",
          },
          {
            value: "DE139D1C-A0BD-4843-B6D9-4B2048AA8852",
            text: "西陵区",
          },
          {
            value: "EAB2A3C0-10DD-48B8-9096-4E8553D5270B",
            text: "枝江市",
          },
          {
            value: "F0753477-ED2F-4D9A-9F13-829C0BAA7168",
            text: "长阳土家族自治县",
          },
        ],
      },
      {
        value: "518B2B0A-3CAD-4820-9594-791C5E291CFF",
        text: "咸宁市",
        children: [
          {
            value: "182F273B-8816-4628-A029-CCB657A29F52",
            text: "嘉鱼县",
          },
          {
            value: "4362CFB9-1C56-41BA-AEDC-85FDCEB14057",
            text: "通城县",
          },
          {
            value: "80674477-8450-4A80-BCF2-E5E17BAD41A7",
            text: "崇阳县",
          },
          {
            value: "A184034E-FBD6-442E-BA6B-C43F27E41E84",
            text: "赤壁市",
          },
          {
            value: "EF1BF042-D37B-4AC9-8CD7-1161BDDF0F46",
            text: "咸安区",
          },
          {
            value: "F4CBF49C-6411-4014-906E-20C18328576C",
            text: "通山县",
          },
        ],
      },
      {
        value: "57AA213B-3646-4807-83BF-844C132AF488",
        text: "随州市",
        children: [
          {
            value: "3AA1E79D-BDF9-4E0E-ADBB-BAF9A6E783FC",
            text: "广水市",
          },
          {
            value: "7F22E183-E81C-4FE9-8472-562719F6C3BF",
            text: "曾都区",
          },
        ],
      },
      {
        value: "7149C248-4BD5-413A-B77B-8D4413777A10",
        text: "神农架林区",
        children: [],
      },
      {
        value: "83CC05D9-6771-4347-8509-560C5735A303",
        text: "荆门市",
        children: [
          {
            value: "58BC36DB-8F73-4BBB-8C38-DE91C603C8F3",
            text: "掇刀区",
          },
          {
            value: "B17B12C0-FC2E-4F33-98AC-0BBA00990E71",
            text: "东宝区",
          },
          {
            value: "B5FBAFD1-49EF-4334-869E-5EAF563AA137",
            text: "沙洋县",
          },
          {
            value: "BADB23E3-C8EF-42A4-86B9-660982ACA0D4",
            text: "钟祥市",
          },
          {
            value: "CA133A8D-E6D9-4D41-8756-A6192CD8A7D8",
            text: "京山县",
          },
        ],
      },
      {
        value: "91DCE609-08A8-4B16-BDBE-E02E8CDEDF58",
        text: "天门市",
        children: [],
      },
      {
        value: "9B3CB9D1-3490-4260-A65F-771CA13D312B",
        text: "仙桃市",
        children: [],
      },
      {
        value: "9D44D0C3-DABF-4189-B49E-480DC89161F3",
        text: "孝感市",
        children: [
          {
            value: "415BD59C-C4B7-4065-BD3A-AAA7E4E32CF5",
            text: "孝南区",
          },
          {
            value: "41817661-D1D3-40CF-9CCB-990038531ED2",
            text: "孝昌县",
          },
          {
            value: "4C325B4B-2659-4ED1-94DF-CAAF1259AF00",
            text: "云梦县",
          },
          {
            value: "73EF5191-E12E-4760-BBE9-8631E62B5930",
            text: "汉川市",
          },
          {
            value: "7ABF645D-48F0-416F-B3D5-2E2DEC6642EC",
            text: "大悟县",
          },
          {
            value: "B3E840AC-5B9C-42C2-8172-9F1B83884A1F",
            text: "应城市",
          },
          {
            value: "DD48157F-F2EB-400D-9E2B-D9BD72326266",
            text: "安陆市",
          },
        ],
      },
      {
        value: "A6084C03-A8F0-4299-9A90-180EA8DEEFF7",
        text: "潜江市",
        children: [],
      },
      {
        value: "B26512CE-3701-4A5C-93D5-97F40B943BCB",
        text: "十堰市",
        children: [
          {
            value: "640B4E74-2E5E-4F60-A5B2-1F4EC43A0858",
            text: "丹江口市",
          },
          {
            value: "6A546433-61FC-4F8E-B80D-BA0A6BC541FB",
            text: "郧县",
          },
          {
            value: "822711FC-17F7-47AA-AB5B-9432E8495312",
            text: "竹溪县",
          },
          {
            value: "98FF7FD6-582C-4606-AE6B-C26B06B2C3FC",
            text: "竹山县",
          },
          {
            value: "B084FA01-10F9-49BC-AD14-506111722A0B",
            text: "张湾区",
          },
          {
            value: "B858ADA2-E5D5-474E-918E-EFA407382E42",
            text: "茅箭区",
          },
          {
            value: "BFE7610D-BB9B-4277-BDA2-D11A73387053",
            text: "郧西县",
          },
          {
            value: "FFB3DCF8-E87E-4FF9-90D6-A9F16E6EFF50",
            text: "房县",
          },
        ],
      },
      {
        value: "BF18435E-0FB2-4837-8053-E305816E1930",
        text: "黄冈市",
        children: [
          {
            value: "16E4DCD2-E104-49F0-B3E8-324D0EF0194F",
            text: "罗田县",
          },
          {
            value: "1A38C19F-67C0-491F-9DB1-75506B49B80B",
            text: "红安县",
          },
          {
            value: "63B3A61A-3CB7-4815-9A2F-3681C7192562",
            text: "武穴市",
          },
          {
            value: "68A6491D-B7B0-48F4-8A2E-E3807983BE1C",
            text: "黄梅县",
          },
          {
            value: "9D70E7AD-10AC-442C-940D-7C179F54D71F",
            text: "麻城市",
          },
          {
            value: "9EC3BE5B-64BC-4883-8D34-F87B5FCE5492",
            text: "团风县",
          },
          {
            value: "BAB13D06-5BCB-4135-A6F5-89BAA30E7FA5",
            text: "蕲春县",
          },
          {
            value: "E221A272-61D4-4D1C-85FB-B6579353AD0E",
            text: "黄州区",
          },
          {
            value: "E4535EB6-F7F0-4034-9ECE-1B2330C05A85",
            text: "英山县",
          },
          {
            value: "F2BF3928-AA7B-462B-BB54-20F14EC3FE20",
            text: "浠水县",
          },
        ],
      },
      {
        value: "CEC37872-2579-4717-83AF-913C3151B5D7",
        text: "武汉市",
        children: [
          {
            value: "036086C1-01E2-4F15-8D2E-F3FB0B409F79",
            text: "黄陂区",
          },
          {
            value: "0D9A95C0-3B2E-4780-9944-209229783455",
            text: "汉阳区",
          },
          {
            value: "1816182E-2467-45F0-87C5-7F0E194F33BB",
            text: "江夏区",
          },
          {
            value: "1C968168-68D0-4038-94D4-1585AB544ED6",
            text: "江汉区",
          },
          {
            value: "5DC22876-D01B-4E7D-AD3F-64851F7B21C5",
            text: "武昌区",
          },
          {
            value: "6339797C-42D0-4267-8B77-0360CA66C98C",
            text: "新洲区",
          },
          {
            value: "634EDB33-FD81-49AC-B54F-FD78406986C6",
            text: "江岸区",
          },
          {
            value: "7C556826-69E5-4629-ADD2-A9B1A47E8D97",
            text: "青山区",
          },
          {
            value: "881601CE-0FEC-4B59-99E2-3D630FD69026",
            text: "蔡甸区",
          },
          {
            value: "A04C2EC2-C6C5-4758-92EE-33D524BFE644",
            text: "硚口区",
          },
          {
            value: "A5D33241-FCBC-4314-A26F-AB2C72823F2B",
            text: "东西湖区",
          },
          {
            value: "AADAE3C0-F04D-42A6-B5E6-46C330BF38AB",
            text: "汉南区",
          },
          {
            value: "B357DBAC-A1D4-47FB-8A5B-7D18CC9FFE9B",
            text: "洪山区",
          },
        ],
      },
      {
        value: "D8B3020E-8DB5-4438-880F-BF7A016E8C17",
        text: "鄂州市",
        children: [
          {
            value: "5C828031-B167-4C8E-9C8C-DF1FC69C364A",
            text: "华容区",
          },
          {
            value: "71202AAC-2DAD-48DB-A0F6-960D82E49DD5",
            text: "梁子湖区",
          },
          {
            value: "CC74E641-F5B0-4C88-91CE-DD01625E8342",
            text: "鄂城区",
          },
        ],
      },
      {
        value: "E3047B5D-0BF3-4058-B7DE-E0314C4D0392",
        text: "黄石市",
        children: [
          {
            value: "1AD4C4E1-ADA5-470A-8F01-780D0AE0B5B6",
            text: "大冶市",
          },
          {
            value: "38D8AF87-6009-4E09-B76D-0CFF1D668395",
            text: "铁山区",
          },
          {
            value: "4CEFD073-FBF2-4764-8E63-4B9E235DEF01",
            text: "黄石港区",
          },
          {
            value: "6BC7FD84-9C54-4CE6-B51D-6100CAABB739",
            text: "团城山开发区",
          },
          {
            value: "86E29C3C-018A-4D77-B1BC-042A3C06D74A",
            text: "西塞山区",
          },
          {
            value: "A64BD3BB-3FED-49A8-B415-1C59DBEE837B",
            text: "阳新县",
          },
          {
            value: "D7AA3138-FA92-4EEA-89FB-9B6D5718DD3C",
            text: "下陆区",
          },
        ],
      },
      {
        value: "FC99CCEF-CBC0-4976-9502-6059B2041F5C",
        text: "荆州市",
        children: [
          {
            value: "20F22EC5-D259-4BF6-B7F0-E4A7CE187DAF",
            text: "洪湖市",
          },
          {
            value: "51D9AF3D-1497-49B7-97C2-568B4070926C",
            text: "公安县",
          },
          {
            value: "AE9F7448-3E53-4951-A9CC-07A351D16A67",
            text: "松滋市",
          },
          {
            value: "D7AE1C27-9655-40DB-B4AA-2DC51036A02F",
            text: "石首市",
          },
          {
            value: "DC84397E-370F-4C86-B36E-721B9AF6E6B9",
            text: "荆州区",
          },
          {
            value: "E7B97143-D807-4B8E-8066-A3A41E8FAE9F",
            text: "江陵县",
          },
          {
            value: "F0247D61-7462-4A41-86C9-4A59526BDD62",
            text: "沙市区",
          },
          {
            value: "F3F4ED36-3027-4AA5-9AEB-2C07FDF6B0B6",
            text: "监利县",
          },
        ],
      },
    ],
  },
  {
    text: "湖南省",
    value: "ED754A5E-AC71-4FEF-9A29-337E4C4819B8",
    children: [
      {
        value: "0C2276EE-87FB-47DE-92B8-8C0E688906A7",
        text: "岳阳市",
        children: [
          {
            value: "1CE740AF-5DDD-4A8B-AA20-C9EA7A4665B5",
            text: "汨罗市",
          },
          {
            value: "2DBD96EE-7AED-4A12-94C0-2E1C8FA05516",
            text: "湘阴县",
          },
          {
            value: "4F1FAE5F-740A-42D8-9AC3-4E3C1EF64A2F",
            text: "云溪区",
          },
          {
            value: "5BA41029-B3A8-4E13-837B-C4E7DAE51B6B",
            text: "岳阳县",
          },
          {
            value: "71ABAB4A-96F2-4831-9D96-9CBA3F3AB3E5",
            text: "君山区",
          },
          {
            value: "917CE435-B0FC-4B1D-81AC-27F6A8E19DA9",
            text: "岳阳楼区",
          },
          {
            value: "A589040F-3DF1-4826-84D5-437E5D6230E8",
            text: "华容县",
          },
          {
            value: "BDA5C777-72B4-4F27-9CDF-A815007C8A82",
            text: "临湘市",
          },
          {
            value: "C1214EA6-A259-4888-9180-F1BC8DF6201E",
            text: "平江县",
          },
        ],
      },
      {
        value: "260B8FEB-98CB-47A3-8CC6-43EC1C3E1825",
        text: "益阳市",
        children: [
          {
            value: "01EE06E1-A216-4935-AC21-021363E3DAB7",
            text: "沅江市",
          },
          {
            value: "21B2B574-9814-44DD-9442-D541CD66CDCD",
            text: "资阳区",
          },
          {
            value: "402F8B50-6BA3-48B6-9A33-8F562C3E6541",
            text: "赫山区",
          },
          {
            value: "68AB7F67-B77F-4ED6-97B0-8E416C2C7AA9",
            text: "桃江县",
          },
          {
            value: "710373BE-EE67-42C2-A2BC-13A12BA3A80A",
            text: "安化县",
          },
          {
            value: "727EA608-510D-47B4-A9B0-05347B5F3354",
            text: "南县",
          },
        ],
      },
      {
        value: "60418DCD-CD06-4504-B77A-3090E44DF1BD",
        text: "永州市",
        children: [
          {
            value: "0EC80F85-70A9-4A93-AB20-6CD65937C8E6",
            text: "江华瑶族自治县",
          },
          {
            value: "0F2CAA57-8921-4C02-8B87-F6430406E72A",
            text: "东安县",
          },
          {
            value: "2A22AF97-B973-4521-862B-662056169F0C",
            text: "零陵区",
          },
          {
            value: "5DD28034-2020-43BF-8883-F8D663676E13",
            text: "冷水滩区",
          },
          {
            value: "919D0B2C-6718-4BC9-A640-9031685F1969",
            text: "道县",
          },
          {
            value: "CB1A0DCD-1B76-45B3-BDA8-FD896C31AACD",
            text: "祁阳县",
          },
          {
            value: "D97EB461-5C87-454B-A271-D46FFB1B48DC",
            text: "宁远县",
          },
          {
            value: "DDDD25C5-5AF1-446F-AD70-947460FCEFF7",
            text: "江永县",
          },
          {
            value: "E9F07029-1D70-4BB0-9118-0F23749B7856",
            text: "双牌县",
          },
          {
            value: "EC5B636E-6F41-450B-8466-F77589906393",
            text: "蓝山县",
          },
          {
            value: "FCF6956E-ED0A-4A11-87F1-F7506671AD51",
            text: "新田县",
          },
        ],
      },
      {
        value: "6F56A4D4-F2CE-4E59-9819-746E01A86728",
        text: "株洲市",
        children: [
          {
            value: "06074715-3C28-4995-BD8C-65D1C43E1708",
            text: "株洲县",
          },
          {
            value: "0FD00F41-2ED8-4D8C-BBBE-3DD106F3DE27",
            text: "攸县",
          },
          {
            value: "2B583611-48BC-44D7-9AF6-C13A8FA42491",
            text: "芦淞区",
          },
          {
            value: "4DE5F17A-89D6-4A5C-AA30-9E545F492360",
            text: "茶陵县",
          },
          {
            value: "5117501B-B441-4E1B-BA64-7E5CC4A2C461",
            text: "荷塘区",
          },
          {
            value: "75994758-98F1-40F1-BBDA-63E2962DA6E3",
            text: "醴陵市",
          },
          {
            value: "78C7160F-9573-4700-B1C6-8F1381D134BE",
            text: "石峰区",
          },
          {
            value: "8DB64209-F0E2-4C58-A6DB-710E81899B10",
            text: "炎陵县",
          },
          {
            value: "A9E4D6BC-0B31-49B5-92C3-AA253C880A8B",
            text: "天元区",
          },
        ],
      },
      {
        value: "7875BCFB-253D-45F7-9690-5AEDAC5FE1F4",
        text: "长沙市",
        children: [
          {
            value: "051C04F1-3E51-4225-BC5C-AC84CE19C1EA",
            text: "望城县",
          },
          {
            value: "08D4B8A1-5AEC-4443-8F3D-8B6CE356E357",
            text: "开福区",
          },
          {
            value: "2682EBF2-DCC7-43B3-9743-E30F46FDEFD7",
            text: "芙蓉区",
          },
          {
            value: "33CF9760-E6F3-4412-85E5-EB5CBE9F60B7",
            text: "雨花区",
          },
          {
            value: "65E1D474-5551-44DE-A9B5-09210AEEF42C",
            text: "浏阳市",
          },
          {
            value: "78DAAF09-9449-4BB2-9681-E6432CB99F49",
            text: "宁乡县",
          },
          {
            value: "851339BE-BDC2-41C9-8FCB-8340A12AA949",
            text: "长沙县",
          },
          {
            value: "A08E1066-B502-4211-A0B7-6801CF1B756F",
            text: "岳麓区",
          },
          {
            value: "E0480AF6-AA73-4D0C-9A8B-AD04846A7235",
            text: "天心区",
          },
        ],
      },
      {
        value: "7D48419B-2304-4175-B032-B7544EBF4B78",
        text: "怀化市",
        children: [
          {
            value: "353F219B-FA7F-4369-8C5B-26F42538E116",
            text: "溆浦县",
          },
          {
            value: "3AF4284C-14FE-4B49-B032-5431CC056F06",
            text: "中方县",
          },
          {
            value: "4A32F9E6-B1C9-4ED3-A60B-31D05F1D64AE",
            text: "芷江侗族自治县",
          },
          {
            value: "534FAE80-BE00-4B9E-ABC4-4ED78AB89DA4",
            text: "鹤城区",
          },
          {
            value: "569A9183-E7DC-4DBA-AB10-5A7C3AC0336C",
            text: "洪江市",
          },
          {
            value: "585B2271-313A-4C58-A68F-A274448125B0",
            text: "麻阳苗族自治县",
          },
          {
            value: "758FB9E4-578C-4C59-BF7E-41A7ED1E036C",
            text: "通道侗族自治县",
          },
          {
            value: "B40951DC-0654-492B-94E8-EAA8FF8D878D",
            text: "新晃侗族自治县",
          },
          {
            value: "D117009C-854F-4D29-A21B-F816D44A4BCA",
            text: "靖州苗族侗族自治县",
          },
          {
            value: "D98CA7EC-76CC-4A25-AF07-D1EA4DB69DBE",
            text: "沅陵县",
          },
          {
            value: "E8F15CC2-4112-4394-8C93-17C454006CE6",
            text: "辰溪县",
          },
          {
            value: "FF5B3E86-0A54-4CB3-9AC8-0C459B5B2531",
            text: "会同县",
          },
        ],
      },
      {
        value: "99ED789E-690A-4597-9AE6-C78F59D0B66A",
        text: "衡阳市",
        children: [
          {
            value: "00ACB845-4C8A-4971-8325-AD8414AB3D59",
            text: "衡东县",
          },
          {
            value: "0D43F8CF-19FD-44A0-B40E-50DA55DCB9CF",
            text: "衡阳县",
          },
          {
            value: "1E10DFFC-C188-43AC-B822-455A9705C4FA",
            text: "蒸湘区",
          },
          {
            value: "342F1D8E-24B0-4702-A1A9-882B4CF5A08F",
            text: "常宁市",
          },
          {
            value: "5D914D43-FF07-481B-80F6-D5E7E3B3E6A5",
            text: "南岳区",
          },
          {
            value: "685337B6-7D7D-43F4-A7CD-E8406F24F1DC",
            text: "衡山县",
          },
          {
            value: "6962DCB7-3093-40FA-82BC-31D588CB33FA",
            text: "祁东县",
          },
          {
            value: "AB281843-019D-433A-BCD9-314B57F21C24",
            text: "衡南县",
          },
          {
            value: "B460D1FD-2FAD-4377-AA8F-F0F74F0BC45D",
            text: "耒阳市",
          },
          {
            value: "CBD892B8-A975-48D7-8EB5-A7E87311409F",
            text: "珠晖区",
          },
          {
            value: "E101D7F5-9971-4A2A-8BAA-98918E4D41D2",
            text: "雁峰区",
          },
          {
            value: "EC76A8C4-0DA9-4D96-BF47-9CCECA8E4FB8",
            text: "石鼓区",
          },
        ],
      },
      {
        value: "A45B1F10-622E-4730-8209-0729AC9A7DB8",
        text: "娄底市",
        children: [
          {
            value: "50CB9438-C28E-4B53-87F4-C3988A130AD9",
            text: "冷水江市",
          },
          {
            value: "9F49A10C-83E1-46E6-B4B4-CF3DAB388F1A",
            text: "新化县",
          },
          {
            value: "CFBD2169-9C15-4CA7-960F-91B54809FAD1",
            text: "涟源市",
          },
          {
            value: "F832DB41-1F25-4D69-BD30-C97B4F3AC920",
            text: "娄星区",
          },
          {
            value: "FF06498E-29AD-45F6-A4B4-7ADCFAFADA26",
            text: "双峰县",
          },
        ],
      },
      {
        value: "AB051C21-A99A-4C3A-8EC1-160C1FE30F31",
        text: "湘西土家族苗族自治州",
        children: [
          {
            value: "17F62329-AB27-4FDB-8A57-3BF273BEEE53",
            text: "凤凰县",
          },
          {
            value: "1BBF7F79-E888-4DFB-92D9-D0307E6FE07F",
            text: "永顺县",
          },
          {
            value: "6C3FCE9E-AF88-43C0-8FA8-D99A22608ED6",
            text: "龙山县",
          },
          {
            value: "7599E59F-231E-4A5A-909D-26AA9FB956A4",
            text: "吉首市",
          },
          {
            value: "8A17B6E1-44BC-4DB8-A97F-AB2B6467FE16",
            text: "古丈县",
          },
          {
            value: "A3CA3500-FD85-4127-9B9B-93B3AB5E28C6",
            text: "花垣县",
          },
          {
            value: "D0936BA1-4EFE-4BF9-97D1-E05544D9C741",
            text: "保靖县",
          },
          {
            value: "F9F3C08B-092B-446F-B7B9-B63C3CE43772",
            text: "泸溪县",
          },
        ],
      },
      {
        value: "BAE2A4C2-032F-415E-9760-12FC14C941A5",
        text: "常德市",
        children: [
          {
            value: "042CFC06-F6D7-4A8F-85F1-409BA2145EA9",
            text: "鼎城区",
          },
          {
            value: "04928700-6F9D-4FFB-A757-8E0BE6139264",
            text: "临澧县",
          },
          {
            value: "40093AC2-ABB0-4870-ACAB-B75C9F71AA18",
            text: "津市市",
          },
          {
            value: "69544AFE-48E6-4BC1-83B8-1D3DBD7A4D6E",
            text: "澧县",
          },
          {
            value: "790ED4A0-6B89-4DB5-A432-D4428F620132",
            text: "安乡县",
          },
          {
            value: "7F18F2E4-0702-4CBB-B50F-58B13BC9A3F7",
            text: "武陵区",
          },
          {
            value: "90F60B65-14B3-452D-B02E-41B744141D99",
            text: "汉寿县",
          },
          {
            value: "B52B4B6C-7331-4D63-A306-2180F8F54ABE",
            text: "石门县",
          },
          {
            value: "E4020BA8-1BC3-482D-8356-20601324D3E5",
            text: "桃源县",
          },
        ],
      },
      {
        value: "EB87E9AE-C38F-4C67-B7A4-103B1E9E1A47",
        text: "湘潭市",
        children: [
          {
            value: "078462E0-EBF5-415E-A54A-82C315A4049D",
            text: "雨湖区",
          },
          {
            value: "444D9AA9-4B2B-4A4F-8EB1-D42D007505A4",
            text: "岳塘区",
          },
          {
            value: "575E34AD-BAAA-47F7-A9DF-0C0650CD42AC",
            text: "湘乡市",
          },
          {
            value: "8DF2D301-CC5D-4106-9D28-027D33600465",
            text: "湘潭县",
          },
          {
            value: "D32FD5CA-5A36-47F4-BB71-A2B834116AC2",
            text: "韶山市",
          },
        ],
      },
      {
        value: "F4B26823-3D4D-4269-9798-5421BF9416AC",
        text: "郴州市",
        children: [
          {
            value: "035E713F-505A-45F4-B839-113D6F471503",
            text: "资兴市",
          },
          {
            value: "178A4331-3F31-4261-89AD-51BCC1DCF3BA",
            text: "苏仙区",
          },
          {
            value: "3A5C684D-1F43-426A-A67A-8AC066AA1B6A",
            text: "嘉禾县",
          },
          {
            value: "54577CC1-ACE3-4841-B62E-E8AFC2BA7090",
            text: "汝城县",
          },
          {
            value: "7D6EEE1C-6609-444C-B312-4186F9774871",
            text: "安仁县",
          },
          {
            value: "A47D7770-93D1-42BB-B43A-BCCA2817C04D",
            text: "北湖区",
          },
          {
            value: "A8013708-04E2-41C6-A106-F5592AAADB7F",
            text: "桂东县",
          },
          {
            value: "BBEC05ED-39E0-4C00-A8A1-179DE8162E43",
            text: "桂阳县",
          },
          {
            value: "C924D3CC-A69F-446A-A3B5-F5704A5A2BA9",
            text: "宜章县",
          },
          {
            value: "F68A3C98-50D8-47C8-8D2F-C6AEB3BB4166",
            text: "临武县",
          },
          {
            value: "F9B7C2A9-8F20-41C6-B815-DCD2DBED757A",
            text: "永兴县",
          },
        ],
      },
      {
        value: "F6CF05A1-7931-47CE-A2C2-FFC1B882450C",
        text: "张家界市",
        children: [
          {
            value: "8015282A-FC0F-443F-AB8D-9FE25D8F2069",
            text: "桑植县",
          },
          {
            value: "E40AF26E-8C88-4FF5-B822-7C853EB148CA",
            text: "武陵源区",
          },
          {
            value: "F73DCDD6-C213-4263-88A9-DB7F4F9F32CD",
            text: "永定区",
          },
          {
            value: "F989D5BE-B100-4FC9-8549-F30B2BAD8491",
            text: "慈利县",
          },
        ],
      },
      {
        value: "FF64CCAB-161C-4332-B1E7-69CCB2980F67",
        text: "邵阳市",
        children: [
          {
            value: "0030F0AA-6EAD-4AF0-8593-95BAB52B18D2",
            text: "隆回县",
          },
          {
            value: "0F637F67-9F55-4EB8-BEEB-BF311CDECD69",
            text: "大祥区",
          },
          {
            value: "3AB819B6-E479-423A-BBFE-727C5F229738",
            text: "城步苗族自治县",
          },
          {
            value: "547013FB-9266-4B90-9A91-899204C1A2B0",
            text: "绥宁县",
          },
          {
            value: "60D6D6FD-0391-491D-BF4A-F957301422BF",
            text: "新邵县",
          },
          {
            value: "87F3B3D1-09D9-4426-A122-49E03F029A94",
            text: "北塔区",
          },
          {
            value: "909DCD75-FF9E-44F6-A6AE-93028ED2ADB3",
            text: "双清区",
          },
          {
            value: "971F7D26-83AD-47C9-84F4-425A6DB211A6",
            text: "邵东县",
          },
          {
            value: "BE1A1ACC-DCCF-4D59-8C84-D7AF10D412D8",
            text: "洞口县",
          },
          {
            value: "C4F94924-6A9F-441D-B2E9-5D23E721B866",
            text: "邵阳县",
          },
          {
            value: "CB5F5113-363A-4B61-AC14-46967852EF13",
            text: "新宁县",
          },
          {
            value: "E347ED5E-65AC-438D-8E89-33EB270F70A7",
            text: "武冈市",
          },
        ],
      },
    ],
  },
  {
    text: "广东省",
    value: "7A3CAC07-082C-465E-BFAE-64193F86FE4A",
    children: [
      {
        value: "0E664E60-BD99-4F93-8595-CC8E655EBC10",
        text: "汕尾市",
        children: [
          {
            value: "5F6679F1-70F1-4830-A3A2-A32130E5A425",
            text: "城区",
          },
          {
            value: "98F208F7-3789-4EF6-A26A-F191721B689D",
            text: "海丰县",
          },
          {
            value: "B4F5D1DF-7FCC-4FF6-966B-BA958486E7DA",
            text: "陆丰市",
          },
          {
            value: "BF64130F-1A49-4353-9FF4-A36964495A3C",
            text: "红海湾经济开发试验区",
          },
          {
            value: "EFDE3096-E75F-4D6F-B85E-ED5FF69A6C27",
            text: "陆河县",
          },
        ],
      },
      {
        value: "11C3CED1-4433-41D4-B4AF-461B9D9F2AAE",
        text: "佛山市",
        children: [
          {
            value: "54FA6134-B95F-47F0-8B75-B0CA5778CDBC",
            text: "高明区",
          },
          {
            value: "729BADBF-DBA8-470D-9747-556F3D33D53A",
            text: "南海区",
          },
          {
            value: "9AB31A90-8F43-486B-BF89-F02B0C9FB3AD",
            text: "禅城区",
          },
          {
            value: "9FEB61FB-D512-43D1-B4BA-3D5C61C727C8",
            text: "三水区",
          },
          {
            value: "E84417DF-77F6-4BC7-B869-4187E72A79F9",
            text: "顺德区",
          },
        ],
      },
      {
        value: "3A813423-4D8C-495F-A1D1-BA52260C0281",
        text: "清远市",
        children: [
          {
            value: "0AE2122E-E035-4D92-96CF-7D7215B13431",
            text: "佛冈县",
          },
          {
            value: "0D8EFF1C-A24B-4DF1-BC1A-9924D9424790",
            text: "英德市",
          },
          {
            value: "5B1F020B-D02D-4120-904F-D08F9CFB3892",
            text: "清新县",
          },
          {
            value: "71FC184C-361B-416B-AB61-552D5AB84DA4",
            text: "清城区",
          },
          {
            value: "B71EEB77-9354-4E1D-9F43-2BE46097E199",
            text: "连州市",
          },
          {
            value: "D0272DA8-56D6-444A-B0F7-AF77FA6E80DB",
            text: "连南瑶族自治县",
          },
          {
            value: "F3BADF07-DF69-4FE6-8799-455141AF9C56",
            text: "阳山县",
          },
          {
            value: "F4A94558-7204-4D0A-A564-F1C08B633CB7",
            text: "连山壮族瑶族自治县",
          },
        ],
      },
      {
        value: "47357102-3227-4845-BF20-10837C206E7D",
        text: "珠海市",
        children: [
          {
            value: "27ECB220-CDF0-4505-85FF-7FC42E134EEF",
            text: "香洲区",
          },
          {
            value: "84B02FC8-4133-4B8C-ADC6-792CA988C147",
            text: "金湾区",
          },
          {
            value: "9762F749-9074-4EC9-AC95-34765FCF0391",
            text: "斗门区",
          },
        ],
      },
      {
        value: "49B12498-B49E-4125-9F7C-E77D9BE86B5C",
        text: "湛江市",
        children: [
          {
            value: "10DBE749-6144-4821-B489-95C0FB4381C7",
            text: "吴川市",
          },
          {
            value: "3DC17549-5C5B-4EEF-B80C-5BDF053B171C",
            text: "廉江市",
          },
          {
            value: "3F64743A-880E-4260-94A7-4C62DF787255",
            text: "开发区",
          },
          {
            value: "6995457B-2D53-407B-9978-2F1667C4F077",
            text: "霞山区",
          },
          {
            value: "6E7B311F-B03D-4522-B0AF-C7C7E2CEB269",
            text: "雷州市",
          },
          {
            value: "755EBFA3-70A2-47C6-85B4-4D5AC2F2407D",
            text: "麻章区",
          },
          {
            value: "A3820AD8-4FB1-4085-8ED5-0E2DDF9FC203",
            text: "坡头区",
          },
          {
            value: "B81BC29A-B2A2-4D92-82E4-05ADB7E2C612",
            text: "徐闻县",
          },
          {
            value: "C3D80038-93FB-4F98-87DA-B6329C86D5ED",
            text: "赤坎区",
          },
          {
            value: "CFF48263-AEB2-410F-A763-CC591621FA59",
            text: "东海岛",
          },
          {
            value: "EB50757E-A441-48A3-A1B3-B2BC8B289300",
            text: "遂溪县",
          },
        ],
      },
      {
        value: "4D757A72-3600-45A5-A604-663E5845562F",
        text: "阳江市",
        children: [
          {
            value: "1648C2E5-7C4D-4DB8-98D9-7642546C900C",
            text: "江城区",
          },
          {
            value: "9FED1AD6-A991-4A0F-A527-9BB1350720DD",
            text: "阳东县",
          },
          {
            value: "A3F92523-8EF6-4FAF-8DFA-3E65A0D1E951",
            text: "阳西县",
          },
          {
            value: "B1DE00DE-3217-4840-BF95-D9B799C491B8",
            text: "阳春市",
          },
        ],
      },
      {
        value: "530AC809-538F-4BC2-8357-6490E0A3F2CA",
        text: "东莞市",
        children: [],
      },
      {
        value: "5B048BE4-AE27-4D81-B3B4-7DF1144F7C99",
        text: "汕头市",
        children: [
          {
            value: "3F3B3CC8-9886-4F3C-856B-47B6B475E5D5",
            text: "潮阳区",
          },
          {
            value: "4F019C84-AAAB-4672-9F51-6209FB271F59",
            text: "潮南区",
          },
          {
            value: "6DAECFBD-FF31-4D2A-A540-9C17BB1DA7D7",
            text: "龙湖区",
          },
          {
            value: "9FFBE9F1-F4F4-430C-BFA1-26664C8AD9FF",
            text: "澄海区",
          },
          {
            value: "A5499E85-CD90-4BFC-90CB-840014E2DBD1",
            text: "金平区",
          },
          {
            value: "C9EE71DD-809E-4100-8502-AD4D34CA71C8",
            text: "濠江区",
          },
          {
            value: "EDA8628E-F480-4C3A-B035-236DB74620BC",
            text: "南澳县",
          },
        ],
      },
      {
        value: "684FCC4A-7979-4B72-AD03-A7C12E9E99AC",
        text: "揭阳市",
        children: [
          {
            value: "189A272F-1482-4556-B582-3A2F6FC30BF3",
            text: "东山区",
          },
          {
            value: "2192C095-2743-45EF-8B4B-7B57C35BD2AE",
            text: "普宁市",
          },
          {
            value: "303A3DCE-4416-4945-9B1F-30E6603D2914",
            text: "揭东县",
          },
          {
            value: "397F4CC9-2C0D-4120-AAE9-FF1173141EA7",
            text: "揭西县",
          },
          {
            value: "9675D12F-5965-4FD8-AF4F-DE29157C7648",
            text: "榕城区",
          },
          {
            value: "AD300DAA-C0B6-4980-80E3-5B34F4483E3F",
            text: "经济开发试验区",
          },
          {
            value: "EDE72BA5-FE45-41B2-98E8-E789DDEE66C0",
            text: "惠来县",
          },
        ],
      },
      {
        value: "73F3297B-1A2D-43CD-8AE9-C8A9F77B5A22",
        text: "广州市",
        children: [
          {
            value: "2D9605C6-E0C7-402C-93B9-C154C7123EDD",
            text: "番禺区",
          },
          {
            value: "395EDF9C-8EFC-4C40-8C12-645DFD97BA79",
            text: "芳村区",
          },
          {
            value: "4AC1697A-ACD3-4AEE-9156-CBF19B423A96",
            text: "增城市",
          },
          {
            value: "5C7F8E3E-7C85-43E3-BF7B-E608998505CB",
            text: "白云区",
          },
          {
            value: "63299614-1758-4A39-BE5C-9D48CFF57985",
            text: "东山区",
          },
          {
            value: "699321C1-5E86-4B65-896D-0734BC815EE5",
            text: "越秀区",
          },
          {
            value: "758E51D8-414E-4823-8D12-549DE00912AC",
            text: "花都区",
          },
          {
            value: "8F080C6D-C85B-41ED-8E9D-C10200FD91FE",
            text: "海珠区",
          },
          {
            value: "CB473345-8119-4C78-9F96-DC795EA2D3F0",
            text: "荔湾区",
          },
          {
            value: "CFE1E2E1-C0C5-4467-AB1D-A3CEA9B197C7",
            text: "萝岗区",
          },
          {
            value: "D2DF1C66-2A3C-4F16-A7AA-2EA32506E9C8",
            text: "天河区",
          },
          {
            value: "F637CA08-B8E4-426B-9139-24559096EC26",
            text: "从化市",
          },
          {
            value: "FDEC6E93-4C0D-45DE-A7F7-42C251C18865",
            text: "黄埔区",
          },
        ],
      },
      {
        value: "748FC6A0-BED5-48FC-B3FC-D6918223FD5F",
        text: "梅州市",
        children: [
          {
            value: "41174E0C-EE54-4D23-A12C-2945E0B7D1C7",
            text: "平远县",
          },
          {
            value: "551CF540-DD6E-4C3B-BE2F-B1F5F4D46736",
            text: "五华县",
          },
          {
            value: "6A20F330-667B-485F-9C0A-9A3FFD133747",
            text: "丰顺县",
          },
          {
            value: "6B8D273A-E1B8-4B55-BFBA-5B9B49F5C101",
            text: "蕉岭县",
          },
          {
            value: "9023701A-5E5A-4890-AF32-7C032CFFED61",
            text: "梅县",
          },
          {
            value: "9C3C8154-E158-443B-B29D-A6C9CA83E7E2",
            text: "大埔县",
          },
          {
            value: "C59FB716-F1AB-4425-B005-E39FFC2F9C66",
            text: "梅江区",
          },
          {
            value: "F4898AC4-6701-463A-AF7B-1CDE5DA95697",
            text: "兴宁市",
          },
        ],
      },
      {
        value: "7EE1BC86-8405-4C2C-8CD1-59821618FDAE",
        text: "韶关市",
        children: [
          {
            value: "0C41CF3E-72AB-4E9B-B640-B102A435BDEC",
            text: "仁化县",
          },
          {
            value: "12F73EA1-FC7A-4A05-9FF2-59B85B1FE31A",
            text: "乳源瑶族自治县",
          },
          {
            value: "13138788-1B35-496D-8822-5803F4C47BDC",
            text: "乐昌市",
          },
          {
            value: "3F4E9D10-5E3A-46A8-8EFD-362A9B8F0F6A",
            text: "南雄市",
          },
          {
            value: "3FA4F5F7-7001-4213-AB84-4199FCAD4130",
            text: "新丰县",
          },
          {
            value: "43243202-18E0-4D7E-BB04-ACB3DEDE0F8B",
            text: "浈江区",
          },
          {
            value: "4A436D14-BDC0-4CAB-AEDC-29C4E587EE57",
            text: "翁源县",
          },
          {
            value: "4F67D2DA-F453-4ED0-B684-D5EFA345C90D",
            text: "曲江区",
          },
          {
            value: "5371EC7B-A6B4-455B-8C4A-BBB06C1A6D0A",
            text: "武江区",
          },
          {
            value: "7A093C5F-C094-4016-AF63-7C00397DB968",
            text: "始兴县",
          },
        ],
      },
      {
        value: "8209C2F2-4C0E-4A87-A16F-40BDC85BC9A4",
        text: "中山市",
        children: [],
      },
      {
        value: "857E2FFF-D774-45E3-8191-9374CE1DAB67",
        text: "河源市",
        children: [
          {
            value: "0D1C73AF-2ECC-414D-A44A-EFD6C8393D94",
            text: "龙川县",
          },
          {
            value: "15A40F71-7204-46F0-9D09-F73ADCFCB1AA",
            text: "源城区",
          },
          {
            value: "211B0341-8264-4F67-92C2-52F1F9FB59CB",
            text: "连平县",
          },
          {
            value: "74B9C3F0-3F73-4FFE-BD9D-BEBA7BA37770",
            text: "紫金县",
          },
          {
            value: "A27C9B7F-2CED-4CAF-A86B-F42B9A985587",
            text: "东源县",
          },
          {
            value: "B9B260C8-52EB-4F03-8786-30061533AE7B",
            text: "和平县",
          },
        ],
      },
      {
        value: "982015B5-CA21-49A1-BFDE-2E57FEE190CA",
        text: "江门市",
        children: [
          {
            value: "20C903D1-A489-4199-86A1-7C6E0A57F08E",
            text: "江海区",
          },
          {
            value: "337D76A8-A6C8-4CA9-A9F2-21108EAA2551",
            text: "恩平市",
          },
          {
            value: "49D8B2B1-9253-47EF-BF1B-66E46CAAFC1A",
            text: "鹤山市",
          },
          {
            value: "51C1027C-5AD7-407E-8839-8AEA6EC4F952",
            text: "蓬江区",
          },
          {
            value: "9863885E-921B-4768-A2E8-C451E4F19C09",
            text: "开平市",
          },
          {
            value: "D1AA5EE3-49D1-4FDE-86DE-DCDF48FB073C",
            text: "新会区",
          },
          {
            value: "E0364D89-6F78-402D-8331-F0CE07198E7C",
            text: "台山市",
          },
        ],
      },
      {
        value: "9EDBB01D-343B-444F-A07F-75A228F218BC",
        text: "潮州市",
        children: [
          {
            value: "07A4C47A-AC2A-410F-9671-88BFEC84FF61",
            text: "枫溪区",
          },
          {
            value: "08C3D9FC-7563-436B-8C9B-015F9D41F996",
            text: "湘桥区",
          },
          {
            value: "8648CED1-3851-4E40-8CC2-80E126570EC1",
            text: "饶平县",
          },
          {
            value: "B87AB819-8625-47F2-8AD2-AACA2115A986",
            text: "潮安县",
          },
        ],
      },
      {
        value: "A93E8B33-EEF0-4E8C-8795-6AF541BB48DE",
        text: "云浮市",
        children: [
          {
            value: "29339791-725B-414B-B63E-1F9265FBCA8D",
            text: "新兴县",
          },
          {
            value: "6215E992-108A-4EAA-9295-E94CD31B0BAA",
            text: "云城区",
          },
          {
            value: "9177EF34-7572-40D0-BCDB-E1D8B4DF3C2B",
            text: "云安县",
          },
          {
            value: "92D4891D-D090-4472-A3E0-0E5E32C06DB2",
            text: "郁南县",
          },
          {
            value: "AC2DB463-5587-4311-9EB7-A16CEB718D7B",
            text: "罗定市",
          },
        ],
      },
      {
        value: "CE270EA0-EDE7-4771-BDD4-538B07792272",
        text: "茂名市",
        children: [
          {
            value: "056E7138-2B7A-4FF4-ABAA-F963FBECD956",
            text: "高州市",
          },
          {
            value: "1380DFB1-93F5-4837-B177-CBFA1F3F4EDC",
            text: "茂港区",
          },
          {
            value: "19849A40-CB04-491E-948F-EF5818FDC0D6",
            text: "茂南区",
          },
          {
            value: "420B9FFF-7B7C-4C9F-825A-5B1AAD8EBF94",
            text: "信宜市",
          },
          {
            value: "D49DFBC8-EBE8-4560-B2E6-9A4E4713565B",
            text: "化州市",
          },
          {
            value: "F2BDC52C-784E-4FBE-856A-C2048573BDD6",
            text: "电白县",
          },
        ],
      },
      {
        value: "E9D22E2F-8987-47E9-92FD-73FCFEA67BCB",
        text: "深圳市",
        children: [
          {
            value: "1773B479-29D0-4B0F-97CC-09800ACAE261",
            text: "宝安区",
          },
          {
            value: "244D9D68-2C12-47BD-9AB0-32700A54E7A3",
            text: "龙岗区",
          },
          {
            value: "24B2DB66-12DA-4512-8096-DB116EF5341A",
            text: "盐田区",
          },
          {
            value: "632EDEFF-E7AC-4CD2-9FAE-456669282977",
            text: "福田区",
          },
          {
            value: "D4FB7EAA-5EDA-4D6A-9184-430C09E98988",
            text: "南山区",
          },
          {
            value: "DAEAD7D4-862A-4ECA-97B5-F3BBF0397912",
            text: "罗湖区",
          },
        ],
      },
      {
        value: "ED272ACF-9A9C-41D2-91D5-8E1B981CEEB9",
        text: "肇庆市",
        children: [
          {
            value: "06462CEB-B711-438B-845E-686EAE4984F3",
            text: "广宁县",
          },
          {
            value: "25223380-2CDB-4A79-8BF6-DD5F63B8F1CA",
            text: "封开县",
          },
          {
            value: "33AA9521-0BF9-40A6-9FD0-8B7FB5A7D2DA",
            text: "端州区",
          },
          {
            value: "4FBBBEA4-10D3-4351-A85D-24A0236FAD67",
            text: "鼎湖区",
          },
          {
            value: "7FA41054-744C-40C7-BD31-07F6BEC473C5",
            text: "高要市",
          },
          {
            value: "C15DA711-ECFB-4426-8450-CD5AD5D7F90B",
            text: "四会市",
          },
          {
            value: "C5B76311-269C-428D-A956-0CEE3A99F2BF",
            text: "德庆县",
          },
          {
            value: "D59E2A8F-02DF-454E-BB96-1EA0967CCB9B",
            text: "怀集县",
          },
        ],
      },
      {
        value: "FE139C87-81AA-4497-8BC2-BF1CA19DAD95",
        text: "惠州市",
        children: [
          {
            value: "07A4A9F1-0A1F-4DDC-8BD4-54D1F45B11C7",
            text: "惠城区",
          },
          {
            value: "139DE598-F6B2-40A6-AC52-5B3B84C1902B",
            text: "龙门县",
          },
          {
            value: "2F62D65C-D71A-4568-931C-6638B06ABE23",
            text: "博罗县",
          },
          {
            value: "83DEB15D-DE1F-4E0D-B441-62E3399DBE27",
            text: "惠阳区",
          },
          {
            value: "E5FA4257-9CB5-491D-8017-C877694EF9B7",
            text: "惠东县",
          },
        ],
      },
    ],
  },
  {
    text: "广西壮族自治区",
    value: "9BB5F21E-101D-47B8-BB6A-30B8CDCF3ADF",
    children: [
      {
        value: "0635108B-A473-4F09-943D-8C2F0E197EE7",
        text: "玉林市",
        children: [
          {
            value: "3B16F6E9-3CD8-4E5E-91FE-8EEEBBE0F18E",
            text: "博白县",
          },
          {
            value: "3BB904FF-CCCD-45FB-AC8A-A0ACB1DB912B",
            text: "玉州区",
          },
          {
            value: "7208E56D-1629-4892-A92F-B235FCE23DB0",
            text: "北流市",
          },
          {
            value: "D95A7614-0CFD-4F3C-99DE-C0A2C4662B8B",
            text: "容县",
          },
          {
            value: "DAE1B948-D402-4D9F-A0C5-2ED4BE5E6BDA",
            text: "兴业县",
          },
          {
            value: "F5CE5E9A-275D-482D-A634-3CC3613B07AA",
            text: "陆川县",
          },
        ],
      },
      {
        value: "1C619E37-EB7D-4104-A110-BC220D978081",
        text: "柳州市",
        children: [
          {
            value: "00CB8553-AE8D-4088-8B8C-B673DFC68A6E",
            text: "城中区",
          },
          {
            value: "1E89A842-CEF4-4A54-ADC8-9ECD40B42FC5",
            text: "柳江县",
          },
          {
            value: "2CEC891F-29FB-4F04-87A4-AFD0085A4AD6",
            text: "柳南区",
          },
          {
            value: "3E442EA9-1162-44BE-92AF-AF3246994F35",
            text: "融安县",
          },
          {
            value: "3EADBA7E-6AC3-412D-94D1-F27DBAE2C147",
            text: "三江侗族自治县",
          },
          {
            value: "66945877-4A20-4A73-A787-D01E2EB8ACA7",
            text: "柳北区",
          },
          {
            value: "71B543EE-7DDF-4565-9316-CE186058B759",
            text: "柳城县",
          },
          {
            value: "E45BE3FC-0529-4216-A6AD-2474A74FA72F",
            text: "鱼峰区",
          },
          {
            value: "EF03A77A-191B-4BA0-B677-8AC9DB407256",
            text: "鹿寨县",
          },
          {
            value: "F870C1B5-5A24-428E-ABB3-C6C2FA950747",
            text: "融水苗族自治县",
          },
        ],
      },
      {
        value: "2300EA6F-D897-46C3-93EB-6A4C4F8229DC",
        text: "南宁市",
        children: [
          {
            value: "02F9FAFC-9ED8-4249-BD93-9316705369F5",
            text: "江南区",
          },
          {
            value: "1DCDC03B-4C7C-4054-A32B-513EC72E1369",
            text: "西乡塘区",
          },
          {
            value: "1EA9887A-EE64-439C-A75E-8D13F8F9EB04",
            text: "邕宁区",
          },
          {
            value: "1F794D13-ABC6-46EE-A65B-6C081BDC6FC2",
            text: "宾阳县",
          },
          {
            value: "3029B76C-E861-41BE-85A0-F9E03882003F",
            text: "横县",
          },
          {
            value: "31374AD2-CCF9-45C3-8707-8751DFAB433E",
            text: "上林县",
          },
          {
            value: "3DB3D62F-3686-4D08-87FB-706F1675AE17",
            text: "青秀区",
          },
          {
            value: "9093FFBE-F859-4434-A732-716C6D78B4A6",
            text: "隆安县",
          },
          {
            value: "DE381796-6714-4F43-BE43-FB5511E1321D",
            text: "武鸣县",
          },
          {
            value: "DFDB1F51-529F-442F-954F-6D17132B3BCC",
            text: "良庆区",
          },
          {
            value: "E2D87714-D69D-45EA-B3AD-74604D14C700",
            text: "兴宁区",
          },
          {
            value: "F8971E6B-E315-495C-8B0C-1676D67CE0DC",
            text: "马山县",
          },
        ],
      },
      {
        value: "3A6131DA-F00A-4864-8997-1EDE38809453",
        text: "钦州市",
        children: [
          {
            value: "2112CDBD-97F3-4ADB-9D0E-63C94DA8E99D",
            text: "钦北区",
          },
          {
            value: "42B254AE-1B4E-4A48-990A-C991F0DDF6B9",
            text: "钦南区",
          },
          {
            value: "F1916CB4-2255-45C0-AD30-5867FAB0333C",
            text: "浦北县",
          },
          {
            value: "FD36EF34-D7B9-427C-BD59-8A16ABC2DB7E",
            text: "灵山县",
          },
        ],
      },
      {
        value: "5BD63EDF-ABDD-4D10-A80A-84B4EBCF6F96",
        text: "河池市",
        children: [
          {
            value: "0036C822-7EBA-4375-8497-FFA090AD946D",
            text: "东兰县",
          },
          {
            value: "25791BEB-D04C-4CF2-95AF-79EDDC7A2324",
            text: "罗城仫佬族自治县",
          },
          {
            value: "3954A006-8826-4D43-AD04-51C589E384EB",
            text: "都安瑶族自治县",
          },
          {
            value: "47B86588-C245-4DA8-BD25-12FA0A2E18A3",
            text: "环江毛南族自治县",
          },
          {
            value: "5BA14739-74D7-408A-947E-B56B163AE387",
            text: "凤山县",
          },
          {
            value: "86C2E35D-CCD8-47B0-99EE-C615BD2A6030",
            text: "大化瑶族自治县",
          },
          {
            value: "8D116161-5FED-4C13-A0C8-C315A3733BD4",
            text: "宜州市",
          },
          {
            value: "922839C4-415D-4A60-8A41-9BC3638271DE",
            text: "金城江区",
          },
          {
            value: "A52E0086-A720-4CD3-858E-09F1691124C4",
            text: "巴马瑶族自治县",
          },
          {
            value: "D043C183-2F46-40C6-AAA1-5F3E2628946F",
            text: "南丹县",
          },
          {
            value: "D9099934-1E8D-4790-AADE-D20B0417B7EE",
            text: "天峨县",
          },
        ],
      },
      {
        value: "84994961-2527-405E-B050-A4ACB6130EF4",
        text: "防城港市",
        children: [
          {
            value: "3A669E43-B8E1-43AC-8673-C27DC1533C74",
            text: "港口区",
          },
          {
            value: "4445524E-EBDD-4220-AD64-F597BD2F120B",
            text: "东兴市",
          },
          {
            value: "C1E57128-82FE-45DB-949D-F4811F49FBEC",
            text: "上思县",
          },
          {
            value: "C66BA1D4-E6F7-492D-9201-2624C0E2FB03",
            text: "防城区",
          },
        ],
      },
      {
        value: "85E787D6-1D92-4A7E-BBE5-6A6A4AF97795",
        text: "崇左市",
        children: [
          {
            value: "11517CDA-025E-470A-9483-F13390CEC446",
            text: "凭祥市",
          },
          {
            value: "29069D10-BCB4-4589-A14D-C7D667793396",
            text: "龙州县",
          },
          {
            value: "2D8ADFA1-DBFF-4BF1-915C-58152C33B3FA",
            text: "大新县",
          },
          {
            value: "60E6CD81-EB67-4FDD-8D8C-4866A30EBDCC",
            text: "天等县",
          },
          {
            value: "6182A6BE-8D70-43AD-BE4C-6C34647415BC",
            text: "江洲区",
          },
          {
            value: "B0809905-66DF-4AEC-9E17-97B6B4AD6D99",
            text: "扶绥县",
          },
          {
            value: "B1D2CEB7-36A0-4BE0-B33F-5015AEBA3A02",
            text: "宁明县",
          },
        ],
      },
      {
        value: "92297373-CB8F-4861-A556-BDEF8786D0AB",
        text: "贵港市",
        children: [
          {
            value: "3A7580D7-3493-4417-A5DE-12118C6A0E2A",
            text: "覃塘区",
          },
          {
            value: "5DA6D3C1-C08B-4F39-B722-AE23401BCB47",
            text: "平南县",
          },
          {
            value: "9D924A3A-1B0F-4C51-B488-DD0B6729ABF7",
            text: "港南区",
          },
          {
            value: "CD9A8518-9DF4-405A-BCFB-7DA8778A2764",
            text: "桂平市",
          },
          {
            value: "EB04BBE5-F1C7-4EA4-A156-46FA9241443E",
            text: "港北区",
          },
        ],
      },
      {
        value: "A1DB905C-8CEE-4E97-B15B-86807C3F0B4D",
        text: "来宾市",
        children: [
          {
            value: "04C87237-74FB-40A8-A73C-4B000A972237",
            text: "武宣县",
          },
          {
            value: "505A0A1C-98C5-4361-B0A1-BD5EE5324523",
            text: "合山市",
          },
          {
            value: "7CBD3945-620A-4013-B9A6-4437B9A8FB8F",
            text: "金秀瑶族自治县",
          },
          {
            value: "CCAC0C51-5CDC-40DA-BB5A-9EADE6671F26",
            text: "忻城县",
          },
          {
            value: "D90BB417-2287-4CC1-A3D5-1E7F99B638B9",
            text: "兴宾区",
          },
          {
            value: "EA280E1F-B102-4EE6-AC8E-890FCEC0D0FB",
            text: "象州县",
          },
        ],
      },
      {
        value: "B5738343-06F1-438C-82EA-22BC183CF35C",
        text: "贺州市",
        children: [
          {
            value: "3F37D36D-9105-4357-A027-07D8EEFAB31C",
            text: "昭平县",
          },
          {
            value: "B5A83932-1BD5-41B4-83D6-D099E9DC9532",
            text: "富川瑶族自治县",
          },
          {
            value: "C8DC3527-61D8-4B08-8325-6C387D6B147F",
            text: "钟山县",
          },
          {
            value: "EAC99E0B-D60C-4F08-9BF2-E627CDCC9B05",
            text: "八步区",
          },
        ],
      },
      {
        value: "B832A999-F136-45AD-B3B0-45DA1C43D583",
        text: "北海市",
        children: [
          {
            value: "0C0BC918-1133-4912-BDB8-1D369C2CAD15",
            text: "铁山港区",
          },
          {
            value: "14CA19A4-EFDA-4779-B715-6F888C6AC009",
            text: "海城区",
          },
          {
            value: "6DF113A0-1A7B-469D-ACCC-94DC8A3E99BE",
            text: "合浦县",
          },
          {
            value: "9CCEC71E-0A20-4590-8D1A-23D16D96C04E",
            text: "银海区",
          },
        ],
      },
      {
        value: "E0C76389-B683-46C6-91ED-5BA69506D749",
        text: "梧州市",
        children: [
          {
            value: "1DE3669C-E548-4DDC-BB04-DE467F787919",
            text: "苍梧县",
          },
          {
            value: "24A021CF-E3E3-4B75-B950-88536ED8376B",
            text: "蝶山区",
          },
          {
            value: "3EC8B02D-849B-44FA-810F-335DB4D137A2",
            text: "蒙山县",
          },
          {
            value: "4B00BE00-3F78-45DE-8C22-B63A78AB839A",
            text: "万秀区",
          },
          {
            value: "C06EBC39-8D59-4812-AA29-D5A950CD24F4",
            text: "藤县",
          },
          {
            value: "CC560F94-3E79-4A64-9726-2E0EE16DBC7C",
            text: "长洲区",
          },
          {
            value: "F82AD44D-AA02-43EA-9611-3DE4123BC2C7",
            text: "岑溪市",
          },
        ],
      },
      {
        value: "E8ACCD4B-0650-4F9E-BBC8-CA4628E75F13",
        text: "百色市",
        children: [
          {
            value: "0A3195E4-E526-4504-8963-91D281D13713",
            text: "田东县",
          },
          {
            value: "123C93BC-CBD8-4942-B10C-59ED1A6B3C6C",
            text: "靖西县",
          },
          {
            value: "4AE6D9A3-F0FF-417F-9465-3BCBF946C6EE",
            text: "田林县",
          },
          {
            value: "729E0BBE-EE9E-4F3A-948E-A7F696CB93F1",
            text: "乐业县",
          },
          {
            value: "844B16E1-8D70-4EA8-AEEA-A6D361CBF6D2",
            text: "隆林各族自治县",
          },
          {
            value: "84CBE920-113D-4511-B772-6CC28AB31B80",
            text: "那坡县",
          },
          {
            value: "AD12686D-2419-41EC-B93B-3E7A8AF7205F",
            text: "平果县",
          },
          {
            value: "B7671DDD-752A-4288-A6DB-CF08843FCC19",
            text: "田阳县",
          },
          {
            value: "D168D19B-30CA-4D36-B6B6-C2D271116B54",
            text: "德保县",
          },
          {
            value: "EC04D32F-5700-4641-8D83-A0BA315DA84A",
            text: "右江区",
          },
          {
            value: "EFF25978-6848-4524-BF0F-950A5E1DE2D4",
            text: "凌云县",
          },
          {
            value: "FD4F4D04-ED6B-4232-B142-36F222944BC9",
            text: "西林县",
          },
        ],
      },
      {
        value: "F776FF27-D3F8-4629-8D61-5741A38449CB",
        text: "桂林市",
        children: [
          {
            value: "0B249F3D-61CF-48A6-B666-1530CF6CAFE8",
            text: "资源县",
          },
          {
            value: "12281D71-A0CC-4B74-8713-6CB2F491D939",
            text: "象山区",
          },
          {
            value: "271BD461-3D5B-4E8A-BD39-333C42CC4367",
            text: "兴安县",
          },
          {
            value: "2A96CF87-5AAE-413A-8990-3ACA4AD7549C",
            text: "全州县",
          },
          {
            value: "2B6E9B35-8BDA-46F6-AF74-52AE035B8A63",
            text: "秀峰区",
          },
          {
            value: "2F76787A-498F-4FBA-96F8-5E240DEF9FA4",
            text: "平乐县",
          },
          {
            value: "341889FB-61ED-4C56-9AEC-E00D049F7F80",
            text: "灵川县",
          },
          {
            value: "495B24E0-A05A-4999-B7C5-6FF5FEE4CDE0",
            text: "荔蒲县",
          },
          {
            value: "559DE6F6-DEF4-43E3-99EF-1221B5F662F3",
            text: "灌阳县",
          },
          {
            value: "5D4FEAE1-C5BA-4220-8553-86A3A4B189AE",
            text: "永福县",
          },
          {
            value: "658EDB23-DB8F-4056-8DDF-8AB280B39AAE",
            text: "七星区",
          },
          {
            value: "A06E1A34-1EE0-4972-8544-BD1CE0386EE8",
            text: "恭城瑶族自治县",
          },
          {
            value: "A5B750F1-0554-426B-9F10-E7DBB2822D87",
            text: "雁山区",
          },
          {
            value: "D3CB58D2-0BF2-4678-A29A-6D8F12CB4689",
            text: "叠彩区",
          },
          {
            value: "DE7B06DB-834D-481C-9911-5E55CBE7835D",
            text: "临桂县",
          },
          {
            value: "E237B7B3-216C-49C1-96F0-D02F3A889A9E",
            text: "龙胜各族自治县",
          },
          {
            value: "FCD83391-11C5-4C35-8E00-50DDB9BAB35D",
            text: "阳朔县",
          },
        ],
      },
    ],
  },
  {
    text: "海南省",
    value: "A03C055F-9983-45D7-8D70-214E10731FBF",
    children: [
      {
        value: "09E15268-EF9B-4992-9E28-611E9CB4FCC9",
        text: "白沙黎族自治县",
        children: [],
      },
      {
        value: "0E63EBBB-1844-4C25-8939-EF98C89C7638",
        text: "琼海市",
        children: [],
      },
      {
        value: "1FBB5D50-3570-43B0-B27C-91C253DFDB66",
        text: "三亚市",
        children: [],
      },
      {
        value: "250FC0A6-D37D-4CCE-8902-49AEE8736F68",
        text: "澄迈县",
        children: [],
      },
      {
        value: "506552BD-A3CF-46E0-8661-9B93D9C1373B",
        text: "琼中黎族苗族自治县",
        children: [],
      },
      {
        value: "559261C4-1140-4A8C-A9F4-9BC7435E13AF",
        text: "万宁市",
        children: [],
      },
      {
        value: "7542F764-EEC1-48F7-9558-008B6AA1F92E",
        text: "陵水黎族自治县",
        children: [],
      },
      {
        value: "79AC2278-9473-4044-83A7-F9D284CF3EB6",
        text: "定安县",
        children: [],
      },
      {
        value: "84EA0DF3-DD4D-42D2-A3C1-0F7CBE473055",
        text: "屯昌县",
        children: [],
      },
      {
        value: "8C62B289-D5F1-45C8-926E-8A893455D108",
        text: "乐东黎族自治县",
        children: [],
      },
      {
        value: "96B82E1E-5F0B-4A0C-AE1B-75F961F5CC83",
        text: "文昌市",
        children: [],
      },
      {
        value: "A45BC7A1-0EF6-492F-B268-FCEC8E57124C",
        text: "临高县",
        children: [],
      },
      {
        value: "AE6AFBB3-8CA3-47DB-8189-9CED9F62024A",
        text: "五指山市",
        children: [],
      },
      {
        value: "D0DDEA77-3788-4E5A-8181-AF92EA673B2E",
        text: "东方市",
        children: [],
      },
      {
        value: "D2316152-BA58-4A8F-A887-5B2705CB6252",
        text: "海口市",
        children: [
          {
            value: "118F7FBD-6126-4A49-9F7D-634AD626F1D8",
            text: "美兰区",
          },
          {
            value: "40A3D416-E54D-4828-AABC-0C13782A9F02",
            text: "琼山区",
          },
          {
            value: "B13E2A9B-83F0-46A1-8E56-C382323FC448",
            text: "秀英区",
          },
          {
            value: "C05BA143-61D8-4DD2-AE72-12DCA37B6C02",
            text: "龙华区",
          },
        ],
      },
      {
        value: "D3D5AF6A-1248-4017-8ACF-C16C5FDCE341",
        text: "保亭黎族苗族自治县",
        children: [],
      },
      {
        value: "DA9755EC-B1CF-4582-99A3-7B5DFE092DD9",
        text: "昌江黎族自治县",
        children: [],
      },
      {
        value: "DE0F707E-8942-4E50-9D28-68075770B24E",
        text: "西沙群岛",
        children: [],
      },
      {
        value: "E6B52270-B553-47FB-8E10-D784332E2D63",
        text: "儋州市",
        children: [],
      },
    ],
  },
  {
    text: "重庆市",
    value: "CAF1EDAF-C8B1-48CF-B329-DDFD987C063C",
    children: [
      {
        value: "709EDA2F-470D-4915-AB12-0A694532C177",
        text: "重庆市",
        children: [
          {
            value: "00A46526-6A8B-43DA-9242-5E6997F11B2C",
            text: "渝中区",
          },
          {
            value: "0607BD2E-A364-4453-9F33-595ED68E363A",
            text: "渝北区",
          },
          {
            value: "0C0F19D6-1730-4066-8D36-93F2D96BF082",
            text: "奉节县",
          },
          {
            value: "11FEAD83-D0FB-4F8A-8465-41985B6A852E",
            text: "九龙坡区",
          },
          {
            value: "17BDC226-FA7C-4F29-8680-C33BAF728F04",
            text: "黔江区",
          },
          {
            value: "21D93DD8-09D7-4A71-9C08-25C8C6765862",
            text: "丰都县",
          },
          {
            value: "23E92346-D1A7-4DAB-8D3C-C986D88CA428",
            text: "城口县",
          },
          {
            value: "2A5B0463-C6B1-47A3-B457-CA05465815D0",
            text: "忠县",
          },
          {
            value: "35F6C7E5-681A-49B9-81A7-19C8D10F966D",
            text: "潼南县",
          },
          {
            value: "3E7AE112-6FE3-42D8-A362-C2ACE90CCE0C",
            text: "江津区",
          },
          {
            value: "6008ED82-BCF2-4CEA-A0D4-9EA3CA8B9D58",
            text: "开县",
          },
          {
            value: "63427CA3-AD50-43B7-B445-0D7099518E38",
            text: "涪陵区",
          },
          {
            value: "68502B40-4ED2-4E5E-8A5C-8066F21EA528",
            text: "北碚区",
          },
          {
            value: "6C93A405-195C-442E-B3C1-69CFA15F2844",
            text: "双桥区",
          },
          {
            value: "71B9B8F4-2474-4905-AAB0-AE676F5FC1E1",
            text: "万盛区",
          },
          {
            value: "7404C487-4A3A-48CB-A016-9FE98F85BB8C",
            text: "武隆县",
          },
          {
            value: "7416D58A-B10E-4D41-9363-ADF9150ABBAF",
            text: "巫山县",
          },
          {
            value: "7AB75630-101F-438D-9AC5-A2DF216BDE51",
            text: "綦江县",
          },
          {
            value: "8D1DB64F-7F7F-44A1-825A-D74454A3C365",
            text: "云阳县",
          },
          {
            value: "8D7B597D-51FF-40B9-A13C-7C7352D120DF",
            text: "长寿区",
          },
          {
            value: "8D833C5A-F29F-4D54-BD66-6E4D02CF5B61",
            text: "璧山县",
          },
          {
            value: "9699C732-B238-4ECE-A1F0-85666BB60C01",
            text: "秀山土家族苗族自治县",
          },
          {
            value: "9C1384AB-9080-45E5-B590-57E9F41DD824",
            text: "大渡口区",
          },
          {
            value: "9FEEF2DE-58C7-4542-8405-E1CD61E04A5A",
            text: "酉阳土家族苗族自治县",
          },
          {
            value: "B8DA29E7-7CE7-4711-A4B2-E40A87A211BB",
            text: "巫溪县",
          },
          {
            value: "C0AF4792-A8B0-449E-9BDC-E02D86F5D512",
            text: "沙坪坝区",
          },
          {
            value: "C380AB7E-4FF3-4344-8406-38E422706DA5",
            text: "彭水苗族土家族自治县",
          },
          {
            value: "C42B62AB-E211-4B12-B070-6F5CC5660DE8",
            text: "江北区",
          },
          {
            value: "CD00EDA3-4086-4772-BC86-EDF7ABB88708",
            text: "合川区",
          },
          {
            value: "D5390037-CB26-421B-A557-7F98F51E8803",
            text: "南岸区",
          },
          {
            value: "D950B2C2-A43F-40CE-A0AA-89220A9D98B6",
            text: "南川区",
          },
          {
            value: "DC65E82C-DA23-41BB-9528-2A71026ED4D7",
            text: "荣昌县",
          },
          {
            value: "DD21A6C4-A02A-4EE1-BD59-359753F0113B",
            text: "永川区",
          },
          {
            value: "E108685B-7BD5-43B8-BDA4-2191EE59E846",
            text: "大足县",
          },
          {
            value: "E5B1F3C4-0047-4805-BB48-206E91D856DC",
            text: "万州区",
          },
          {
            value: "E5DE591F-F94F-4A88-BF1D-F4F05DF94FF8",
            text: "巴南区",
          },
          {
            value: "E6D62B8A-5AB4-437E-A498-256AC008035D",
            text: "铜梁县",
          },
          {
            value: "E980D22E-C86A-4002-B42C-B044BEF662A7",
            text: "梁平县",
          },
          {
            value: "EB144A97-D787-4B6F-A9DB-2870268D5904",
            text: "垫江县",
          },
          {
            value: "FA224018-ED08-4517-82A6-6FF7A027A669",
            text: "石柱土家族自治县",
          },
        ],
      },
    ],
  },
  {
    text: "四川省",
    value: "8C21C7E4-3BF3-401C-B994-D42EB0F20BFC",
    children: [
      {
        value: "02CD6C16-86FB-4E17-A7FA-670F7686EF13",
        text: "德阳市",
        children: [
          {
            value: "2FAFC227-D446-49B2-AC64-D54F0820A39D",
            text: "绵竹市",
          },
          {
            value: "622F962C-29E4-4E8E-95D9-6A2D6ED45D52",
            text: "什邡市",
          },
          {
            value: "9CE374C3-A85E-4F40-B61B-E9F3EA98725F",
            text: "中江县",
          },
          {
            value: "DEE5B78B-9CBA-4516-A222-EA6D3D35E74F",
            text: "广汉市",
          },
          {
            value: "EEE03865-43AB-4E9F-8E08-D2DEC1842112",
            text: "罗江县",
          },
          {
            value: "F8FB30FB-643A-4396-A935-8B96A98D4ED9",
            text: "旌阳区",
          },
        ],
      },
      {
        value: "03CDDFB3-48CB-4F79-AE22-097C5094F785",
        text: "达州市",
        children: [
          {
            value: "3EDEB114-239A-438E-9A1B-D6352444645F",
            text: "大竹县",
          },
          {
            value: "99123CB2-1909-4A42-B4D0-2B474DFF21F5",
            text: "万源市",
          },
          {
            value: "9FC447CA-8E29-4F54-8256-B1CF386243B3",
            text: "开江县",
          },
          {
            value: "A1C51153-CB31-4C10-89F8-4E1148F2D571",
            text: "达县",
          },
          {
            value: "A7FFF96B-D52F-4177-97D1-7ECE379C8ECC",
            text: "渠县",
          },
          {
            value: "F8ADEF6A-207D-4181-9847-A38C5B793440",
            text: "通川区",
          },
          {
            value: "FBB86AD1-01FD-4AB5-9675-88E9F8E31D58",
            text: "宣汉县",
          },
        ],
      },
      {
        value: "09094310-E2F0-4CE1-B96A-561B6C6E311F",
        text: "自贡市",
        children: [
          {
            value: "1A6AD407-0EE9-4E90-BD98-9EBF09F4D920",
            text: "大安区",
          },
          {
            value: "71858B73-374C-400F-BE8C-72D0DEAF2939",
            text: "沿滩区",
          },
          {
            value: "D27F5A9E-A5D1-4C98-9246-4883D6E0777C",
            text: "富顺县",
          },
          {
            value: "DC4439DB-0AF2-448E-9455-B9CB6F5723FA",
            text: "自流井区",
          },
          {
            value: "FB892178-A164-4329-9E94-3FDAD32CFAF8",
            text: "荣县",
          },
          {
            value: "FF8EEE51-9C7C-4D91-ACA8-9D781D59B82F",
            text: "贡井区",
          },
        ],
      },
      {
        value: "108F70CE-39CB-4B2F-99B0-302F97402782",
        text: "眉山市",
        children: [
          {
            value: "1710B924-4038-44D4-8261-F440820EC21C",
            text: "仁寿县",
          },
          {
            value: "34E4B6B3-C050-4E94-8082-AD42E251807B",
            text: "彭山县",
          },
          {
            value: "6043F9C5-1153-466E-9280-DC5069D959EF",
            text: "东坡区",
          },
          {
            value: "9547FEE6-5E4B-4CB4-A021-66F0BE042A96",
            text: "青神县",
          },
          {
            value: "B418BEEE-30E0-4758-AF87-8EE2AB96BCD3",
            text: "洪雅县",
          },
          {
            value: "D4243E14-B0FC-418E-95E0-5CA463FF6AFA",
            text: "丹棱县",
          },
        ],
      },
      {
        value: "34CBEEB8-0130-4E0E-B00C-C971CFA208CB",
        text: "巴中市",
        children: [
          {
            value: "479A614F-8E1D-4891-8318-9EB9A50B0D9B",
            text: "南江县",
          },
          {
            value: "48BBD162-84F4-4B09-AE4F-67334EDB1735",
            text: "通江县",
          },
          {
            value: "5304C83B-D326-435B-B1BE-BE47F0434C92",
            text: "巴州区",
          },
          {
            value: "AFC435F1-7ABC-4CB8-96F9-C95B1262844D",
            text: "平昌县",
          },
        ],
      },
      {
        value: "35C8CF6B-1B0B-431D-97C9-12AFB31EE15D",
        text: "内江市",
        children: [
          {
            value: "5221AED7-0DDA-4AB0-89EA-8BC3743DAFEC",
            text: "市中区",
          },
          {
            value: "9302473E-9E4C-47E9-997F-0E9D11763E8C",
            text: "隆昌县",
          },
          {
            value: "9938A9EE-C536-406B-B925-900864A8D28E",
            text: "东兴区",
          },
          {
            value: "CBBD744A-70AC-4D58-9A36-1912557E4F47",
            text: "资中县",
          },
          {
            value: "E2C0FD63-4C7D-4111-8565-FF74CAAAED43",
            text: "威远县",
          },
        ],
      },
      {
        value: "3986AAA5-574A-4831-B103-427646843CC9",
        text: "宜宾市",
        children: [
          {
            value: "1E819DCD-C1C7-4582-B1BD-E9AFE701F892",
            text: "珙县",
          },
          {
            value: "2B7D890A-1032-4A8B-A1F2-CF4C27619515",
            text: "翠屏区",
          },
          {
            value: "4BE26B2C-B500-44EA-A1B4-19964B7CA77A",
            text: "兴文县",
          },
          {
            value: "85B2C25C-911A-48EF-8D20-3B48C941D0CB",
            text: "屏山县",
          },
          {
            value: "A883A244-DDEA-40AA-AA12-C47776F5F3C4",
            text: "筠连县",
          },
          {
            value: "AAC5B9CC-D7E0-4D06-AB02-E2F7E65B9130",
            text: "江安县",
          },
          {
            value: "B65A8D1D-2943-4331-BB43-89AE7C419CAF",
            text: "长宁县",
          },
          {
            value: "C2861869-F158-4AE9-84FD-60244F8D497F",
            text: "宜宾县",
          },
          {
            value: "DDE6EF29-5CCA-41D9-903B-3BEC95636E7E",
            text: "南溪县",
          },
          {
            value: "FBE4916D-6CBB-46AA-B8EF-DB791EBBBA80",
            text: "高县",
          },
        ],
      },
      {
        value: "3BC2446E-E09E-4252-94A7-F5058D419141",
        text: "泸州市",
        children: [
          {
            value: "2744F0E7-2ACA-40D9-902E-5C9B78EE6550",
            text: "泸县",
          },
          {
            value: "32B21EB8-75AC-4191-B658-BB12BCE23204",
            text: "江阳区",
          },
          {
            value: "545A4C93-2E2D-47FF-9956-6AE1491D1DFC",
            text: "龙马潭区",
          },
          {
            value: "58CEE1BB-2721-445F-96ED-750E70A0E53C",
            text: "合江县",
          },
          {
            value: "6BFC0C80-7D1A-4A48-8FF1-BCF052F2FF56",
            text: "纳溪区",
          },
          {
            value: "ABAE99FD-ECFB-4454-BF2D-052AB5A7BD73",
            text: "叙永县",
          },
          {
            value: "C6ABD7BE-4C46-4344-B152-5529BCDF5990",
            text: "古蔺县",
          },
        ],
      },
      {
        value: "50A3FB56-FB38-43DA-B90B-D0D4D92B7BEA",
        text: "乐山市",
        children: [
          {
            value: "11797C46-115A-4161-9FB2-4E3E16D16D9C",
            text: "夹江县",
          },
          {
            value: "3E053E8D-397D-4309-A981-7AAFB7400FC8",
            text: "峨眉山市",
          },
          {
            value: "63D72D0B-5AD5-412B-85B0-AA0C39DF4902",
            text: "犍为县",
          },
          {
            value: "7894ABDB-E920-411E-94F7-5A1E9CE7B2BB",
            text: "峨边彝族自治县",
          },
          {
            value: "911A9AAC-4388-4292-85C4-F02BD45E11FC",
            text: "井研县",
          },
          {
            value: "9C800AAA-C7EB-4C44-B4EA-C5A65EDA06E3",
            text: "金口河区",
          },
          {
            value: "A29FDBED-0C12-49CA-845D-85C85FAC173F",
            text: "马边彝族自治县",
          },
          {
            value: "ADED8999-77C2-421E-9CBE-E212CD37DF23",
            text: "五通桥区",
          },
          {
            value: "B1D4042F-FDA4-42C4-8986-896304443C8A",
            text: "沙湾区",
          },
          {
            value: "E12AF682-4EBA-40C9-8F51-6004758F7D45",
            text: "沐川县",
          },
          {
            value: "E28C8EFF-86AF-4133-8CB1-5E8F4A6A6019",
            text: "市中区",
          },
        ],
      },
      {
        value: "66D53A7B-AF45-40F2-A070-7BDC6CE49CBB",
        text: "阿坝藏族羌族自治州",
        children: [
          {
            value: "09B78A9D-D074-472F-AB20-816BD7AD1FDF",
            text: "阿坝县",
          },
          {
            value: "0A8177E1-ED77-4E51-9A9B-CEFB0AE1DE1C",
            text: "金川县",
          },
          {
            value: "1AC62F21-B177-44AC-B647-7C94FC080D38",
            text: "壤塘县",
          },
          {
            value: "22248709-F199-4711-843E-A26179651E12",
            text: "茂县",
          },
          {
            value: "2538D633-55F0-4BD9-89D6-AD2C61E562DE",
            text: "理县",
          },
          {
            value: "415FC43C-FD81-443F-950F-2C6BB70E8386",
            text: "九寨沟县",
          },
          {
            value: "417B80E4-537D-4D73-AA38-432774F9C24D",
            text: "汶川县",
          },
          {
            value: "611085CC-955A-410E-AFFA-858B588EC523",
            text: "马尔康县",
          },
          {
            value: "65840498-4212-4132-AB21-46ADEEF60E16",
            text: "红原县",
          },
          {
            value: "9947991B-4575-478F-A6AA-0FECF6ABD406",
            text: "松潘县",
          },
          {
            value: "C9E57063-15D7-4AD5-ABCE-267341651E3A",
            text: "黑水县",
          },
          {
            value: "E7272E38-7047-4C11-A029-66AEEB31C1E6",
            text: "若尔盖县",
          },
          {
            value: "F27A5140-16C9-49B8-A1F7-2B6A059724B6",
            text: "小金县",
          },
        ],
      },
      {
        value: "6D53F81E-8466-4FAE-9325-3CD992D4F740",
        text: "成都市",
        children: [
          {
            value: "0FA9C508-5438-4D3F-9114-87641A1F79A2",
            text: "新津县",
          },
          {
            value: "1DA8F63F-73ED-4201-AD9F-79F0D7FCFBB6",
            text: "郫县",
          },
          {
            value: "3AA8614A-9775-4C79-B05E-C81A23EEBE83",
            text: "彭州市",
          },
          {
            value: "3ACF59B9-4BC1-473E-B90B-B43B12F500C3",
            text: "双流县",
          },
          {
            value: "3C3E96DC-811B-44CB-8A29-7C40F19CF64F",
            text: "都江堰市",
          },
          {
            value: "4E1CBB53-B393-4550-B393-9FD020A8C384",
            text: "青羊区",
          },
          {
            value: "4F9D62F3-71EB-46BB-A9A8-C617C6149090",
            text: "崇州市",
          },
          {
            value: "7FC6D5DB-2C30-4830-8DBB-A1E3F37D214F",
            text: "锦江区",
          },
          {
            value: "9428D842-96A2-4865-8D00-2E912E4F0391",
            text: "新都区",
          },
          {
            value: "9BF7DA80-4974-4B42-8628-CDD4CAE42FC4",
            text: "龙泉驿区",
          },
          {
            value: "9DAA20DB-1274-40D1-9E94-DCEF09CB28F6",
            text: "成华区",
          },
          {
            value: "A25FE0F3-A4E8-49C0-BAB9-353E50B02C86",
            text: "温江区",
          },
          {
            value: "A6C17D13-FF3D-4144-95B4-44FE051283BB",
            text: "大邑县",
          },
          {
            value: "C7C74A40-5AF8-4305-AA96-6B404D4CE00E",
            text: "邛崃市",
          },
          {
            value: "D10870F6-28A1-4709-B31F-DFAAD3A3D23B",
            text: "青白江区",
          },
          {
            value: "D99DC2C7-B37F-480A-B9E2-E447C436AAD7",
            text: "金堂县",
          },
          {
            value: "F4F88303-411E-4F4D-B732-247C3CF0A679",
            text: "蒲江县",
          },
          {
            value: "F815F091-1EA1-4E12-B25A-5C4FEE784550",
            text: "武侯区",
          },
          {
            value: "FEC46AF4-CC03-4B00-9FCB-B6B84886F2C4",
            text: "金牛区",
          },
        ],
      },
      {
        value: "7F39FD43-F83F-46D1-858E-08D51B9C67AE",
        text: "雅安市",
        children: [
          {
            value: "25C36413-F52B-4C1B-BC03-2CCD4EA46AE5",
            text: "石棉县",
          },
          {
            value: "36C56328-A34C-467E-9A65-73E6E6E5C18E",
            text: "名山县",
          },
          {
            value: "38702812-66DD-48F9-B061-89B5A5140B3C",
            text: "雨城区",
          },
          {
            value: "3996B714-A703-4F23-855B-494F4808C1B3",
            text: "荥经县",
          },
          {
            value: "5C0CDBD2-6D26-46C7-90F6-746C6424EE01",
            text: "宝兴县",
          },
          {
            value: "6D72BF8D-AE63-4431-B979-C8E6FAD04D82",
            text: "芦山县",
          },
          {
            value: "7B7D11D5-6893-4E94-BF63-B4BB1C1CD97F",
            text: "天全县",
          },
          {
            value: "DAFC1CB2-F6EF-49A3-AEE3-0BC710902E6E",
            text: "汉源县",
          },
        ],
      },
      {
        value: "A3CEB098-AF85-4F5F-9F00-2BCC0B47A671",
        text: "凉山彝族自治州",
        children: [
          {
            value: "11B9B5ED-5067-416E-8776-CE416C5430E5",
            text: "布拖县",
          },
          {
            value: "3215AB36-C68E-4437-B229-78E77B8F9F81",
            text: "甘洛县",
          },
          {
            value: "44FD684D-23EE-4FDF-B2E5-2BB0223F81A7",
            text: "西昌市",
          },
          {
            value: "46DACA79-F281-485F-997E-7D1090BB82B5",
            text: "越西县",
          },
          {
            value: "47E61F92-1582-4A03-92E5-53E1223D19ED",
            text: "盐源县",
          },
          {
            value: "638F3B91-6ABF-4253-9AA1-75AE029D54CD",
            text: "宁南县",
          },
          {
            value: "790E472C-9E36-482A-ACA3-972A5C252122",
            text: "金阳县",
          },
          {
            value: "8C1A3794-BB68-467A-A927-BC0E9EB4E4C8",
            text: "会理县",
          },
          {
            value: "99719D57-2626-4B33-86E7-C3CC87E03B1F",
            text: "喜德县",
          },
          {
            value: "9FF3BAEE-4B84-4E85-91A5-79CF543EB209",
            text: "美姑县",
          },
          {
            value: "AB3346B7-E10F-496C-BEF3-D91975EBDEB7",
            text: "木里藏族自治县",
          },
          {
            value: "BF2AA65F-BC51-4E64-96B0-8F8D105962D3",
            text: "德昌县",
          },
          {
            value: "DB5D62B7-9DE8-4453-9CDA-347701A58F41",
            text: "昭觉县",
          },
          {
            value: "E73512E4-A52C-44B2-AABE-47B185E02F9F",
            text: "雷波县",
          },
          {
            value: "EBB4057A-968C-41D2-BFE6-4256C3398CD3",
            text: "普格县",
          },
          {
            value: "F1A7A780-6DEC-4450-8188-AA501578EA18",
            text: "冕宁县",
          },
          {
            value: "F6B0135C-8EA6-4D00-97C8-34E795490769",
            text: "会东县",
          },
        ],
      },
      {
        value: "A68FA5DD-254F-4326-B6CA-431C608AF017",
        text: "南充市",
        children: [
          {
            value: "204865B2-05B6-4805-B13C-6BDA2AA2A7D9",
            text: "仪陇县",
          },
          {
            value: "4A7B9FC7-1512-4726-86D5-F3A84DD7AA02",
            text: "蓬安县",
          },
          {
            value: "724706B8-45C5-4190-BBDA-220884B30420",
            text: "阆中市",
          },
          {
            value: "81407DBA-F88B-436B-B9AD-331B92333C1E",
            text: "高坪区",
          },
          {
            value: "AB9A11F2-20F3-42C4-88D8-93CC440E2431",
            text: "营山县",
          },
          {
            value: "C1DFB296-9732-4575-A8A7-0EB528D97884",
            text: "南部县",
          },
          {
            value: "CE3E0C83-ACB8-464F-AE0F-845E2F2085A7",
            text: "嘉陵区",
          },
          {
            value: "E04B1236-7CA0-4627-A7FA-0F9E6206C7D5",
            text: "顺庆区",
          },
          {
            value: "F968A006-5BC8-4D5B-BD0D-DD11DB6B1483",
            text: "西充县",
          },
        ],
      },
      {
        value: "A98E7E3C-2098-4262-AE7F-5FC2564270C3",
        text: "遂宁市",
        children: [
          {
            value: "15233353-8080-4CAF-9444-7D7466311043",
            text: "大英县",
          },
          {
            value: "6B0C6492-ECEB-44BD-8324-A4E2F1FB056F",
            text: "射洪县",
          },
          {
            value: "A3A9F765-6544-443F-8FF9-76B003C6110E",
            text: "船山区",
          },
          {
            value: "D56FBB3A-A2C8-4B17-A409-545CB13FDCF4",
            text: "蓬溪县",
          },
          {
            value: "DC3969F2-FC8A-4A82-8FC4-28FF54595935",
            text: "安居区",
          },
        ],
      },
      {
        value: "ABD6AAB1-A875-4EEF-BC83-B8267D66919B",
        text: "绵阳市",
        children: [
          {
            value: "23A71081-A8B5-4FE3-9F5B-BB1005930A85",
            text: "江油市",
          },
          {
            value: "3AEA1C0C-607A-4C5B-B035-E3ED9C6ADCB0",
            text: "北川羌族自治县",
          },
          {
            value: "56C4437D-3586-4633-A206-070FC69484A6",
            text: "平武县",
          },
          {
            value: "7CFD7CEC-C779-42B1-A4B8-691B39D6E3CD",
            text: "梓潼县",
          },
          {
            value: "913233DE-8514-4158-9536-2C35B6C45C76",
            text: "三台县",
          },
          {
            value: "9D3BEAF6-19F6-4BDD-BD02-C4AC74D4A833",
            text: "安县",
          },
          {
            value: "C4A32B0E-7E1F-4DF1-9FE9-1CF471477C42",
            text: "涪城区",
          },
          {
            value: "D8061329-D083-43E5-9197-0DB5FDA9E8F1",
            text: "盐亭县",
          },
          {
            value: "F349EDE6-FF52-4074-8C76-2E9F8FC69529",
            text: "游仙区",
          },
        ],
      },
      {
        value: "AEEEFA1D-7DEC-4028-ABA3-09578A3ABED5",
        text: "甘孜藏族自治州",
        children: [
          {
            value: "14206BF6-4CC3-42C0-A70D-611050476209",
            text: "泸定县",
          },
          {
            value: "1D9C0FD2-0295-4365-88BC-1C3C16E30C92",
            text: "巴塘县",
          },
          {
            value: "21FD3F6E-588C-4001-A7E6-230A7FF52DD8",
            text: "康定县",
          },
          {
            value: "2BFB5473-5174-4DA3-A68F-F319CFC1FEE4",
            text: "稻城县",
          },
          {
            value: "2D900929-03B6-4113-A8A6-E4D8103F83D5",
            text: "石渠县",
          },
          {
            value: "36C69336-A882-45E9-83E9-6A4627DA079B",
            text: "色达县",
          },
          {
            value: "4481BA97-C957-4351-A077-503F123BE18B",
            text: "白玉县",
          },
          {
            value: "5042CFC0-098A-4F23-BB91-68535388FF5E",
            text: "甘孜县",
          },
          {
            value: "56E7C90F-BCB1-4C7D-A61B-C5A90C704AF5",
            text: "新龙县",
          },
          {
            value: "7AA9E99B-10D6-4D0C-B891-5E600426836A",
            text: "九龙县",
          },
          {
            value: "7B7ADBB9-44B8-40E6-85E9-AB888B9F00FE",
            text: "乡城县",
          },
          {
            value: "7BD62FDC-8530-462D-8614-3226401D07B2",
            text: "得荣县",
          },
          {
            value: "BB3A98E2-B98C-4B33-AA16-DF2A8313D3E9",
            text: "德格县",
          },
          {
            value: "C6EA3D59-C6C8-4D85-A89E-E40542686CF9",
            text: "丹巴县",
          },
          {
            value: "CBCDE03F-E37D-4C7C-AA41-DBCA30D7EC6E",
            text: "雅江县",
          },
          {
            value: "F154BAF1-3BC4-4B71-925E-822907925661",
            text: "理塘县",
          },
          {
            value: "F32220F8-760A-44C7-BAC5-DDEB2627571D",
            text: "炉霍县",
          },
          {
            value: "FDB8C99A-2D1E-4F61-BC23-00D623CCB5A8",
            text: "道孚县",
          },
        ],
      },
      {
        value: "B43FC2AB-3D71-4AE0-907A-D885E12E1C15",
        text: "攀枝花市",
        children: [
          {
            value: "15EA1112-D171-4432-AF39-6CAA8DA74E34",
            text: "仁和区",
          },
          {
            value: "413DDCCF-52E5-490D-B185-E5168A2E1803",
            text: "米易县",
          },
          {
            value: "4CDFC799-5C00-4124-9644-944FB764EBC8",
            text: "东区",
          },
          {
            value: "87763BC5-BBB5-4DDF-9494-293AF3E7B155",
            text: "盐边县",
          },
          {
            value: "F3CB8254-336B-4D1F-8FE1-FF3564B7E19D",
            text: "西区",
          },
        ],
      },
      {
        value: "E9F1360A-6C2F-4F0D-B04D-58EC85C34703",
        text: "广元市",
        children: [
          {
            value: "0CE289B8-A945-4AC8-BCB2-BC51ECA46AA3",
            text: "剑阁县",
          },
          {
            value: "2C4C821E-FA3F-4E82-AFCA-A4BF826CBD09",
            text: "苍溪县",
          },
          {
            value: "6E7233BB-9BC0-470D-A669-D8F65A274BCD",
            text: "旺苍县",
          },
          {
            value: "AA38635D-48AB-4C28-91A0-AC3CFB2E931D",
            text: "青川县",
          },
          {
            value: "ABC7041D-BB22-4049-AFF4-B6D16FBB96F8",
            text: "利州区",
          },
          {
            value: "D188BE7F-79DB-4F6D-9A4A-777BF82CE973",
            text: "朝天区",
          },
          {
            value: "DBB1ACA1-72F1-4814-82B0-6006912F8C5F",
            text: "元坝区",
          },
        ],
      },
      {
        value: "EAAFBB2D-E9CD-4C16-BF39-F2C973A86888",
        text: "广安市",
        children: [
          {
            value: "78732064-7309-4E5C-B615-422E14F2746E",
            text: "武胜县",
          },
          {
            value: "89E06F37-BD60-4138-B151-A8E729EC8E92",
            text: "岳池县",
          },
          {
            value: "DE45C3F7-0447-4E6C-98A8-C11052DF6383",
            text: "邻水县",
          },
          {
            value: "EAA79988-8CFD-4280-AA27-BCD210AAD50A",
            text: "广安区",
          },
          {
            value: "F2D62F72-406A-4DC8-B982-BE4E26BE277B",
            text: "华蓥市",
          },
        ],
      },
      {
        value: "FA4CF7EE-CC68-43CF-BC91-9143B383395F",
        text: "资阳市",
        children: [
          {
            value: "1F1A3556-BB11-4202-8061-3F156662CA6F",
            text: "乐至县",
          },
          {
            value: "5E3B74C2-393F-42CB-A3A8-25DFA81EFE89",
            text: "简阳市",
          },
          {
            value: "8BBB7BF3-AA66-4A70-9937-7D5420576E5E",
            text: "安岳县",
          },
          {
            value: "C3AC69A3-882B-4101-A2C8-59CE7BAB519F",
            text: "雁江区",
          },
        ],
      },
    ],
  },
  {
    text: "贵州省",
    value: "B5DB5D71-89E7-4C92-8435-A9A5E5DB5BD5",
    children: [
      {
        value: "0D2C7422-5D2C-4647-BEB0-88A5B458E54E",
        text: "铜仁地区",
        children: [
          {
            value: "184E62F2-9C1C-4226-89B3-06FAA3BBB1C5",
            text: "江口县",
          },
          {
            value: "28114E62-ACFF-4D7C-866A-59950F7EB8C5",
            text: "万山特区",
          },
          {
            value: "5BBB430F-184A-473D-A5F3-33E105C01B3F",
            text: "铜仁市",
          },
          {
            value: "61A379CE-17E8-4E99-BFBE-1F1A210BD1E9",
            text: "思南县",
          },
          {
            value: "71018E53-1A25-408F-B8E1-ED623197B7A9",
            text: "德江县",
          },
          {
            value: "74C9450F-B049-4C0F-9DE2-0C442E0176D4",
            text: "松桃苗族自治县",
          },
          {
            value: "8B120476-A077-4471-B5DD-EF0A30614DA8",
            text: "沿河土家族自治县",
          },
          {
            value: "98AD919D-37D6-4516-9D7C-38E098F7F360",
            text: "玉屏侗族自治县",
          },
          {
            value: "D4B96C1E-0E33-4A0E-90D7-F398A8D55C0B",
            text: "石阡县",
          },
          {
            value: "DD75F2EA-3CFF-4A88-827B-596153122425",
            text: "印江土家族苗族自治县",
          },
        ],
      },
      {
        value: "36BEEEFB-4D3A-40E2-B591-453B6B4550A7",
        text: "遵义市",
        children: [
          {
            value: "004EAE27-1A7E-41B2-A9CC-93FDA27EBFEC",
            text: "凤冈县",
          },
          {
            value: "0D9B15DB-3F64-42A7-9C3B-6B9678D508D5",
            text: "余庆县",
          },
          {
            value: "15569A80-BF8B-492E-8E19-441F01552599",
            text: "湄潭县",
          },
          {
            value: "1CC36AB3-6D8D-46EC-8D09-3CC58917BBD9",
            text: "务川仡佬族苗族自治县",
          },
          {
            value: "1D9AA078-9203-491C-BFAE-46F14AB2F6E3",
            text: "遵义县",
          },
          {
            value: "35B7129B-2E7F-453B-869D-8FE2238BCE57",
            text: "红花岗区",
          },
          {
            value: "3671163B-AD4F-44D2-8C0B-3FF096094F3E",
            text: "赤水市",
          },
          {
            value: "5DC623EA-D3AA-431E-88FF-17CCCDB078D5",
            text: "桐梓县",
          },
          {
            value: "98081056-F2CB-4DA9-AF43-012351BB9CDF",
            text: "汇川区",
          },
          {
            value: "9B74B27C-5BC7-4090-AE43-7A5C44F322DB",
            text: "绥阳县",
          },
          {
            value: "AA1F9C8C-5EE2-4090-9FE9-F921F43FA989",
            text: "正安县",
          },
          {
            value: "B0767FBC-C99B-4E98-92BE-11075F4B142F",
            text: "道真仡佬族苗族自治县",
          },
          {
            value: "BD788C85-C482-4273-A20A-EAB568E40A30",
            text: "仁怀市",
          },
          {
            value: "C3688AB8-E38E-4648-939C-E93019ECD7F1",
            text: "习水县",
          },
        ],
      },
      {
        value: "4E65BD39-9C0C-43A2-B954-D206F703AC11",
        text: "贵阳市",
        children: [
          {
            value: "483A6EF2-E501-455C-A5A4-6A027F39543D",
            text: "花溪区",
          },
          {
            value: "514215EC-5764-4EAB-A48F-B5BAF8DC065A",
            text: "乌当区",
          },
          {
            value: "515D51BE-E217-4988-B0B8-BF033DEC36C4",
            text: "南明区",
          },
          {
            value: "60731F80-A244-4B9C-9F49-23C88C363BE9",
            text: "清镇市",
          },
          {
            value: "6D36D7E9-1CA7-4115-852A-3802D8DC59E7",
            text: "修文县",
          },
          {
            value: "987A3F48-9699-4B46-B976-A1B550B1117D",
            text: "息烽县",
          },
          {
            value: "B55F196A-0B2D-4799-8089-1EC7927E1A70",
            text: "云岩区",
          },
          {
            value: "B6CBA11C-78FD-441F-98F2-E886D53D6B6F",
            text: "白云区",
          },
          {
            value: "E3144387-9D4D-4545-9318-E619BE103BAA",
            text: "开阳县",
          },
          {
            value: "ED33B0EE-3449-44C8-A9ED-25977055DF47",
            text: "小河区",
          },
        ],
      },
      {
        value: "6172A48A-A608-420C-8426-18EDB6BB443E",
        text: "黔西南布依族苗族自治州",
        children: [
          {
            value: "068F788D-CF80-4EC6-8A23-04F7226AF77A",
            text: "兴仁县",
          },
          {
            value: "294027DF-E4C9-4F47-B33E-84B43E9830CA",
            text: "兴义市",
          },
          {
            value: "4AF3BC9E-6A6F-47F5-9592-65B88E9E21FE",
            text: "望谟县",
          },
          {
            value: "5659CFCE-CBB2-4771-9620-8665D3C9EC18",
            text: "册亨县",
          },
          {
            value: "A0AC7B15-71DD-420B-8D50-52D78FDF50B5",
            text: "安龙县",
          },
          {
            value: "BE7BE595-2417-4973-B485-15E727100755",
            text: "贞丰县",
          },
          {
            value: "C574E8E6-EA75-458C-A6E8-D350D20E96B8",
            text: "普安县",
          },
          {
            value: "C7DA32C1-349A-43E5-BEE3-8886267CB355",
            text: "晴隆县",
          },
        ],
      },
      {
        value: "7E6E1D40-2F9B-4FBA-B45D-9B6C02407064",
        text: "毕节地区",
        children: [
          {
            value: "45FE6261-F56F-4B63-AC39-43ED74E35636",
            text: "威宁彝族回族苗族自治县",
          },
          {
            value: "6DE28754-8A8E-4427-9ECA-B61EE59812A1",
            text: "毕节市",
          },
          {
            value: "747006C3-2975-42BB-8F1D-B78029774143",
            text: "纳雍县",
          },
          {
            value: "8ADA87FD-6888-41E9-AF5D-7EDE9383C51C",
            text: "黔西县",
          },
          {
            value: "AA265761-E007-42E0-91C0-B3F21A337491",
            text: "赫章县",
          },
          {
            value: "B7CF8125-A6E8-4697-8DAE-E662F01085D4",
            text: "织金县",
          },
          {
            value: "D00F821D-357B-4893-AECC-BD5C1BC6AD63",
            text: "大方县",
          },
          {
            value: "FAED2CC1-C699-4ED4-932C-4104BF078712",
            text: "金沙县",
          },
        ],
      },
      {
        value: "9AE4E8A6-8E20-41E5-AF97-6599E5F492B0",
        text: "安顺市",
        children: [
          {
            value: "13289EBE-AEB2-462A-9671-BAC41790BF89",
            text: "关岭布依族苗族自治县",
          },
          {
            value: "290BA1CC-4F21-4837-BC08-075FCC380796",
            text: "普定县",
          },
          {
            value: "7B5725F1-9D5B-4430-BB8F-604E0FD07C6F",
            text: "紫云苗族布依族自治县",
          },
          {
            value: "B4A6750A-E7CE-4D0D-8703-DF6AEFCA036F",
            text: "平坝县",
          },
          {
            value: "BD47B684-BA93-4E8C-9A82-EED3185BA008",
            text: "镇宁布依族苗族自治县",
          },
          {
            value: "F520EEFA-38CA-4149-91EB-FBF29912689E",
            text: "西秀区",
          },
        ],
      },
      {
        value: "A4972652-B8E7-4CD0-AAD4-196B2D60D8D8",
        text: "六盘水市",
        children: [
          {
            value: "1CBB4FFF-1A28-4E45-9796-3D991108BA52",
            text: "六枝特区",
          },
          {
            value: "381604F5-3BB3-43B0-AB6A-778DB99F6954",
            text: "水城县",
          },
          {
            value: "B31E8ED1-5391-451F-B402-50A795AD8212",
            text: "盘县",
          },
          {
            value: "FFE485A3-1610-422C-A4B6-F5D6AD6FE463",
            text: "钟山区",
          },
        ],
      },
      {
        value: "A98571E1-AF78-4A7E-A209-8F9427BA6296",
        text: "黔南布依族苗族自治州",
        children: [
          {
            value: "0832D1A2-F9E7-4050-9228-348781BF72E1",
            text: "惠水县",
          },
          {
            value: "0DEE96AC-51B7-4EC9-9284-EE0F2B20DCD1",
            text: "福泉市",
          },
          {
            value: "0F599E64-29BB-48DB-BBE1-5139EE1C2B93",
            text: "瓮安县",
          },
          {
            value: "26D120EF-1168-4935-9453-8EC657BB0986",
            text: "三都水族自治县",
          },
          {
            value: "280FBC09-6719-4FDA-9979-814545601874",
            text: "龙里县",
          },
          {
            value: "288AC565-6B58-4049-9D6E-F55F6FB44222",
            text: "独山县",
          },
          {
            value: "2FAFFC50-AD99-4E23-AFF4-8ABC5B6686E9",
            text: "罗甸县",
          },
          {
            value: "814450B3-CB0C-429E-9619-DF366CB474F2",
            text: "荔波县",
          },
          {
            value: "928581A5-3F7B-49BF-BC12-8FF72C2E9823",
            text: "平塘县",
          },
          {
            value: "990FA805-9F79-463A-A4B6-10C989B8176B",
            text: "贵定县",
          },
          {
            value: "DAA5F62D-5DA9-415D-B04F-3E138BB69DA1",
            text: "长顺县",
          },
          {
            value: "F26A327B-CB11-49FE-B65C-C75FF04F9EBE",
            text: "都匀市",
          },
        ],
      },
      {
        value: "CA092FE9-B7EF-4BCC-A520-9CB340C90467",
        text: "黔东南苗族侗族自治州",
        children: [
          {
            value: "07CF6A27-F15B-43F2-A07D-AF858726791B",
            text: "锦屏县",
          },
          {
            value: "08464F57-7C9C-449F-BAFF-070C93D7052C",
            text: "镇远县",
          },
          {
            value: "0E123B1C-CAB5-4F1B-BD40-A44CDAE94CC8",
            text: "从江县",
          },
          {
            value: "11FAF22F-A8DD-4CD0-9403-B5AD2C7B90F6",
            text: "台江县",
          },
          {
            value: "19981E0E-AE47-4996-B10D-C79F4C0B68AE",
            text: "雷山县",
          },
          {
            value: "4E31BB7A-D8CE-4973-B75A-C4CB22A1A79F",
            text: "丹寨县",
          },
          {
            value: "7399C4AE-08F6-4416-B3C0-BF85F9A0689B",
            text: "天柱县",
          },
          {
            value: "74C7C492-8E86-46E4-96E9-D1D2BBD8E319",
            text: "黎平县",
          },
          {
            value: "9A5F37BC-10E9-4617-BDA1-5468DA2B1E9F",
            text: "三穗县",
          },
          {
            value: "A076D205-6C5C-4A85-8F4F-90AAFD5030EF",
            text: "麻江县",
          },
          {
            value: "A46476EE-A4EA-4F3E-85BF-5790CB11580D",
            text: "剑河县",
          },
          {
            value: "B9843801-D82A-417D-8756-94E3BD8C7279",
            text: "榕江县",
          },
          {
            value: "CC9D7937-21D7-457D-AF5F-3100325BFC49",
            text: "岑巩县",
          },
          {
            value: "E08B37C2-0E91-48C1-97B2-285081A371D5",
            text: "凯里市",
          },
          {
            value: "F324D492-1C97-4DAA-AE56-1EC1580931DC",
            text: "黄平县",
          },
          {
            value: "F531F9CF-55C3-4B25-8975-438DFD18D401",
            text: "施秉县",
          },
        ],
      },
    ],
  },
  {
    text: "云南省",
    value: "201DF9D8-E046-4136-BFAF-30B66B419112",
    children: [
      {
        value: "04695960-3E10-4022-B88D-DF6CC0D49163",
        text: "怒江傈僳族自治州",
        children: [
          {
            value: "60F9411D-D597-44E4-B228-C1C925BA3359",
            text: "兰坪白族普米族自治县",
          },
          {
            value: "9E6A3BD7-E111-4C6D-AA98-CB6097E463A3",
            text: "贡山独龙族怒族自治县",
          },
          {
            value: "E6992F83-CC74-488E-BB08-3074CC3BE174",
            text: "泸水县",
          },
          {
            value: "F3CB4776-ED8C-43EE-B657-798320D76287",
            text: "福贡县",
          },
        ],
      },
      {
        value: "04E63198-40C9-4F85-B802-FA59438B28E6",
        text: "昆明市",
        children: [
          {
            value: "34D776D9-5E3B-4977-9A3A-5D010D236CBC",
            text: "官渡区",
          },
          {
            value: "43AA88CD-4ABD-426D-9C3B-AF9A15AD0A8E",
            text: "呈贡县",
          },
          {
            value: "4498907F-F62E-432D-9826-C116D1A27D67",
            text: "嵩明县",
          },
          {
            value: "5BE5712E-4777-4389-A176-EC6964656E78",
            text: "晋宁县",
          },
          {
            value: "5D446C5B-5CEF-40FE-9607-6F72FEB203DC",
            text: "东川区",
          },
          {
            value: "5F7AA1F3-D7B9-4D24-810B-513606E3C1BD",
            text: "禄劝彝族苗族自治县",
          },
          {
            value: "79E4B8B0-2F54-4EE5-AACF-6A93CEDC1CB5",
            text: "寻甸回族彝族自治县",
          },
          {
            value: "9AFC8BEE-42B2-49EF-8A4F-F147F4125EC8",
            text: "宜良县",
          },
          {
            value: "A62339CC-9576-442D-AF5B-B22A417909F3",
            text: "五华区",
          },
          {
            value: "AC7D791F-80CD-4E11-B7DC-1DC6CFB190BC",
            text: "西山区",
          },
          {
            value: "B4289E2B-B4C4-4EC4-ADFB-05AF7FE5628C",
            text: "盘龙区",
          },
          {
            value: "C66D41FE-D9C7-42EA-845F-8386E24D03B9",
            text: "安宁市",
          },
          {
            value: "CEB99D48-69C0-4ADF-A822-3FFB1F2CF7F6",
            text: "富民县",
          },
          {
            value: "DB84E513-2B9A-49C4-BC05-5C27A5903DFB",
            text: "石林彝族自治县",
          },
        ],
      },
      {
        value: "0E8FF283-6F0D-4969-A1FC-57F2573ADAFA",
        text: "玉溪市",
        children: [
          {
            value: "218623B4-1E68-465A-AD17-8EBFBBB8FF4A",
            text: "华宁县",
          },
          {
            value: "A87DA55B-FE12-4C81-B6C4-AE64AD0F8601",
            text: "红塔区",
          },
          {
            value: "AEAD1C6F-44F8-4F5E-825B-AF5BB195DD53",
            text: "易门县",
          },
          {
            value: "AEFDA815-D54B-4404-BDE3-9D2C0DC37995",
            text: "元江哈尼族彝族傣族自治县",
          },
          {
            value: "B92D05C5-3DF2-4955-9571-FC2AB4C0770B",
            text: "新平彝族傣族自治县",
          },
          {
            value: "C84323F7-5D8E-4BB9-9D61-1E368D53072B",
            text: "澄江县",
          },
          {
            value: "D8C8C8B1-1D25-4ACB-9581-06B26C098DE4",
            text: "峨山彝族自治县",
          },
          {
            value: "E3637BFF-3AD9-41CF-B362-9E25D26682E9",
            text: "通海县",
          },
          {
            value: "FB622EDC-4A01-436B-8D40-C6D387C901B2",
            text: "江川县",
          },
        ],
      },
      {
        value: "1C87490C-6009-47B6-8CE6-C6B31A3AF2B7",
        text: "楚雄彝族自治州",
        children: [
          {
            value: "060EC445-E906-4D6A-AB71-1FD595DCD532",
            text: "南华县",
          },
          {
            value: "156E22F1-E4CB-429D-8437-5BEF6F574781",
            text: "楚雄市",
          },
          {
            value: "187DF007-CF1B-4CC7-86A1-16AC0EA5A239",
            text: "双柏县",
          },
          {
            value: "1939938B-41DD-4670-BF42-2FE69C379691",
            text: "禄丰县",
          },
          {
            value: "47257B10-DB28-4D0A-AF0D-2F56806E1BD3",
            text: "姚安县",
          },
          {
            value: "715A12B8-EFDC-4451-9448-46CB4DCBCE56",
            text: "永仁县",
          },
          {
            value: "A3A9B851-DDAE-4805-AC4F-18E2A345C726",
            text: "牟定县",
          },
          {
            value: "BE136652-F447-485F-89F0-7D328CC2267D",
            text: "大姚县",
          },
          {
            value: "BEB06E4A-45AB-4C37-8240-C529102D8FCA",
            text: "武定县",
          },
          {
            value: "CF549DCE-1041-44F2-AF22-D05F56DC47E8",
            text: "元谋县",
          },
        ],
      },
      {
        value: "35776D9A-15C5-4334-AB56-5DC6581A9259",
        text: "曲靖市",
        children: [
          {
            value: "2A98FE5B-F8D7-40B3-9C9E-31E4F2D33302",
            text: "麒麟区",
          },
          {
            value: "65EB2554-EFA8-45EE-8BFB-0E3F48908037",
            text: "师宗县",
          },
          {
            value: "662FC7BA-5274-496F-8C54-BC5AD9BFB3F8",
            text: "马龙县",
          },
          {
            value: "6A1D0F14-BE37-41D2-90DB-ACD3953DC8BD",
            text: "沾益县",
          },
          {
            value: "730A9782-9D1A-46D8-9486-8B0835ECD3AC",
            text: "陆良县",
          },
          {
            value: "88784E2F-23F6-49C1-A034-3A8A2A7E6B8B",
            text: "宣威市",
          },
          {
            value: "8BA4A496-4693-4516-A544-382000BF39E7",
            text: "富源县",
          },
          {
            value: "9C29FEDA-BA24-4F2F-90B9-E46A55CACAED",
            text: "会泽县",
          },
          {
            value: "EEA88E7B-E227-428C-9A53-86BF47C1C4E1",
            text: "罗平县",
          },
        ],
      },
      {
        value: "3991F818-8E63-40F1-9280-5D57A63D96A2",
        text: "大理白族自治州",
        children: [
          {
            value: "05A7D6EF-6EFC-416D-A7C3-4D16EC50C4CF",
            text: "永平县",
          },
          {
            value: "36C8E5BC-CE63-4636-8EEF-65D94FFF2185",
            text: "弥渡县",
          },
          {
            value: "471BB137-D3A3-4F1E-AA74-457826D45E8C",
            text: "南涧彝族自治县",
          },
          {
            value: "4F0A5D4D-21AD-41C3-B65E-1FD0A4100805",
            text: "洱源县",
          },
          {
            value: "5013D4E5-5413-4D64-98BE-0F8CED94F5BD",
            text: "鹤庆县",
          },
          {
            value: "51F03EA2-DEE0-46F2-9BA9-88C5B21897CC",
            text: "大理市",
          },
          {
            value: "5781FABE-87EB-415E-9AB6-8DBBF0C38FDD",
            text: "云龙县",
          },
          {
            value: "5D5BEA5C-E626-406A-B4A8-FAD56C6774D4",
            text: "宾川县",
          },
          {
            value: "A0D5E509-1826-4692-B038-F55D909F3EA2",
            text: "漾濞彝族自治县",
          },
          {
            value: "A7755FAD-D940-4840-AC4D-847640156E11",
            text: "巍山彝族回族自治县",
          },
          {
            value: "E39CFA3F-49D2-4C3C-87A9-55CCE1CEE9CC",
            text: "剑川县",
          },
          {
            value: "EFB13A39-D218-4BAF-B041-DD97B7025747",
            text: "祥云县",
          },
        ],
      },
      {
        value: "47837059-D9AD-456B-AF1F-688FA22C4F08",
        text: "迪庆藏族自治州",
        children: [
          {
            value: "2515442A-6C66-4DB9-B89B-1BCDE3630EB4",
            text: "香格里拉县",
          },
          {
            value: "3FE7F903-369D-4C9A-B91F-AEA091149108",
            text: "维西傈僳族自治县",
          },
          {
            value: "B0EA821D-07F1-4D9A-95A7-3D8BDBF89D4E",
            text: "德钦县",
          },
        ],
      },
      {
        value: "4B077F7C-9C4E-4F51-84F4-FBA9D5DEDD30",
        text: "保山市",
        children: [
          {
            value: "28101ABB-A97F-4722-8021-68C533CF0889",
            text: "腾冲县",
          },
          {
            value: "369E4D0F-CD09-4422-B233-A6B40BD13EB2",
            text: "隆阳区",
          },
          {
            value: "4935E0A8-7610-4BD6-AEAC-E802437CCEBB",
            text: "昌宁县",
          },
          {
            value: "4B2CCABA-A325-4754-905F-B533376D7401",
            text: "施甸县",
          },
          {
            value: "EA88715B-17D8-4602-B842-65E398AEFA84",
            text: "龙陵县",
          },
        ],
      },
      {
        value: "74C99E88-20A5-455A-951E-5773E866F4A4",
        text: "德宏傣族景颇族自治州",
        children: [
          {
            value: "34209BBD-A3F5-4583-8B01-E682DDCDF099",
            text: "盈江县",
          },
          {
            value: "4D40E3E4-141C-4B7F-9E75-97AB402C19EA",
            text: "梁河县",
          },
          {
            value: "70A5B070-87A7-427E-A4A9-4A10C9CDFB59",
            text: "潞西市",
          },
          {
            value: "7B2F46EB-25AA-4DEE-B085-C22062B8B0A8",
            text: "陇川县",
          },
          {
            value: "886DF6F6-3830-4A07-B721-BA4607113BCD",
            text: "瑞丽市",
          },
        ],
      },
      {
        value: "7531F9A4-4475-414C-8ABD-C3FCAACE783A",
        text: "红河哈尼族彝族自治州",
        children: [
          {
            value: "00FDF36F-7052-4BF2-BA1A-F3EACFBC4FB0",
            text: "红河县",
          },
          {
            value: "0B4D0411-FFD5-44EF-A880-218A461DDC33",
            text: "建水县",
          },
          {
            value: "168604EE-F089-4C2B-BCA0-63CBBB988B4A",
            text: "泸西县",
          },
          {
            value: "2BD37F0F-D644-454B-8598-996CCB220409",
            text: "屏边苗族自治县",
          },
          {
            value: "3A011D4F-7374-4A96-83DD-7FDFCD3264AD",
            text: "绿春县",
          },
          {
            value: "42D909D9-2F53-4307-9496-5BA0172477A1",
            text: "弥勒县",
          },
          {
            value: "840A3674-2DBD-408E-8C99-8D58CB05D216",
            text: "石屏县",
          },
          {
            value: "8E96B738-17B7-4C6F-8B82-1F1B28FEADA8",
            text: "个旧市",
          },
          {
            value: "A9F705DB-566E-4161-9DE0-1DA74DA08445",
            text: "蒙自县",
          },
          {
            value: "D1186D6D-3CA9-47A5-AD3F-C13400FD3F45",
            text: "河口瑶族自治县",
          },
          {
            value: "D87A325B-5B87-4827-8F5B-3414041F5964",
            text: "金平苗族瑶族傣族自治县",
          },
          {
            value: "E98FA62C-B9A1-4AE8-B6DA-FD24ECD7D025",
            text: "元阳县",
          },
          {
            value: "F75E6ADA-1F94-4CF1-8006-3878648BCDFB",
            text: "开远市",
          },
        ],
      },
      {
        value: "9BDD3CBC-B9B0-4017-8EB1-1CA257BDF2BF",
        text: "西双版纳傣族自治州",
        children: [
          {
            value: "7640807D-26F4-4AA0-906E-FC74AC782A38",
            text: "景洪市",
          },
          {
            value: "AC017BEA-FD4A-48AD-BFAA-F8DBE41A1A73",
            text: "勐海县",
          },
          {
            value: "B4079144-12A2-43B0-ACF4-F54080A6B073",
            text: "勐腊县",
          },
        ],
      },
      {
        value: "B32BF259-98A6-434E-BCDB-DB5679E31892",
        text: "文山壮族苗族自治州",
        children: [
          {
            value: "13D56798-EF1C-41A5-9B07-78959BA19E22",
            text: "砚山县",
          },
          {
            value: "1B8243E8-CDE9-402E-8D26-48018425BC3A",
            text: "文山县",
          },
          {
            value: "2AD0C220-CA75-463F-953B-F3E7AF849442",
            text: "马关县",
          },
          {
            value: "3D5A8AE2-5F75-4125-B354-F9C118149ADF",
            text: "西畴县",
          },
          {
            value: "715A0DE3-4E8A-4F55-AA8D-4A1072729909",
            text: "广南县",
          },
          {
            value: "905C009D-E827-4E16-8AB1-F7C63DBC360E",
            text: "富宁县",
          },
          {
            value: "B6A0E14A-3A90-4C7C-8930-74DE3FB0E746",
            text: "麻栗坡县",
          },
          {
            value: "E59642AC-DB1D-4D3E-9F37-4A192F504A43",
            text: "丘北县",
          },
        ],
      },
      {
        value: "C3B71F6A-13EF-4B9D-8DE1-CEB2F31625E5",
        text: "普洱市",
        children: [
          {
            value: "17744689-FB62-4EDB-8266-FEB4BC527558",
            text: "宁洱哈尼族彝族自治县",
          },
          {
            value: "19BC1A75-9253-4355-AAC4-30C246991BA7",
            text: "墨江哈尼族自治县",
          },
          {
            value: "31865BD4-599A-4589-AE8C-090BBA921736",
            text: "景谷傣族彝族自治县",
          },
          {
            value: "46FFCC6F-8AC2-4756-8226-8F4E35C9CD77",
            text: "孟连傣族拉祜族佤族自治县",
          },
          {
            value: "48ECB6D5-9CC1-408A-B906-F4BFC5C1965E",
            text: "镇沅彝族哈尼族拉祜族自治县",
          },
          {
            value: "7D81F911-B58E-40BC-9339-AE96522224D3",
            text: "景东彝族自治县",
          },
          {
            value: "B0394416-D79A-4AF9-9D8A-89D0048C5DAC",
            text: "思茅区",
          },
          {
            value: "D1E8C612-ACC4-4045-9D94-F5B0E09642BE",
            text: "西盟佤族自治县",
          },
          {
            value: "DB5F39A9-53B6-4B24-892B-190FBDDAF3FC",
            text: "澜沧拉祜族自治县",
          },
          {
            value: "EFBA9747-9713-4B84-9693-C42DEA62B592",
            text: "江城哈尼族彝族自治县",
          },
        ],
      },
      {
        value: "C89B7D7E-8346-47B6-B16B-6CE600A49C99",
        text: "丽江市",
        children: [
          {
            value: "05CBCAAA-129A-4975-A4FD-292186C42463",
            text: "永胜县",
          },
          {
            value: "6C110B3E-1D62-4DC1-8C36-AB64CD695F04",
            text: "古城区",
          },
          {
            value: "7FA03BCD-893F-4024-A9E8-A887919758E6",
            text: "玉龙纳西族自治县",
          },
          {
            value: "C735C96A-EF6D-40AC-8C11-8DB04DA081AF",
            text: "宁蒗彝族自治县",
          },
          {
            value: "D5F3DB88-637E-4E17-9594-D7CA701343B1",
            text: "华坪县",
          },
        ],
      },
      {
        value: "CE4E861E-D600-4931-B48E-7FC42E6C0659",
        text: "昭通市",
        children: [
          {
            value: "2019C036-EB19-4EC2-808C-AA7EBBB62C2E",
            text: "绥江县",
          },
          {
            value: "2037B466-A002-41DA-9FA7-F8ADA109349B",
            text: "彝良县",
          },
          {
            value: "2ADA1866-30FA-4922-9654-AB41BB8B2A81",
            text: "大关县",
          },
          {
            value: "445566C0-F93E-4E6C-B18B-63CB098E829C",
            text: "盐津县",
          },
          {
            value: "59AA78B6-33DC-41CF-A048-768613E226C9",
            text: "昭阳区",
          },
          {
            value: "9FC22B45-B933-4368-B0B8-72B5D9E2B050",
            text: "水富县",
          },
          {
            value: "ABAFA9C3-78A2-44BC-B888-F62452DD46A3",
            text: "巧家县",
          },
          {
            value: "CD4411A7-0773-4493-B01C-DDF3A4A690D5",
            text: "鲁甸县",
          },
          {
            value: "D47A8AA6-0692-4D87-8B45-A4FE11655AE8",
            text: "镇雄县",
          },
          {
            value: "EF5DF3FA-884A-4E64-86A4-70871B0C795C",
            text: "永善县",
          },
          {
            value: "F591C871-22BD-48D5-B307-D50CA002F0A8",
            text: "威信县",
          },
        ],
      },
      {
        value: "DF698F87-D42B-4FD5-B112-DCBA2053CE9B",
        text: "临沧市",
        children: [
          {
            value: "1EC6BD6B-FFA6-48F4-B22B-93AC03F549F0",
            text: "镇康县",
          },
          {
            value: "2178448D-0C6C-4605-BB05-4A4BBB1A348B",
            text: "云县",
          },
          {
            value: "2EFCB847-76C3-403E-BC86-229F1096AE39",
            text: "永德县",
          },
          {
            value: "408DB307-36A5-410A-8A30-8C9DFF6459D7",
            text: "沧源佤族自治县",
          },
          {
            value: "A032A6B9-1F2A-4743-9C45-20D705D5E35C",
            text: "双江拉祜族佤族布朗族傣族自治县",
          },
          {
            value: "A13418F8-F9A7-4146-81EE-E26A644D75E8",
            text: "耿马傣族佤族自治县",
          },
          {
            value: "E50F5CFB-E88B-4452-85E6-427469B1B784",
            text: "临翔区",
          },
          {
            value: "FE36D93E-6396-47C0-BDAA-1BAD9AA39169",
            text: "凤庆县",
          },
        ],
      },
    ],
  },
  {
    text: "西藏自治区",
    value: "2A249F90-5596-494F-B27E-F85A4A5847EB",
    children: [
      {
        value: "13C883F8-6A5D-49DA-8B72-B47F20769316",
        text: "日喀则地区",
        children: [
          {
            value: "002A1DAC-3195-4BEA-A239-F600FDD27DCC",
            text: "吉隆县",
          },
          {
            value: "15B69122-FCC2-4C21-8D93-E92D74024702",
            text: "萨迦县",
          },
          {
            value: "1EE5CD55-B16C-4230-AD68-1F93753224E4",
            text: "岗巴县",
          },
          {
            value: "2E3D1104-0190-4B08-AF58-2A940BBB1445",
            text: "定日县",
          },
          {
            value: "38E390F3-A494-4B6A-AED9-A2209594FEB8",
            text: "聂拉木县",
          },
          {
            value: "56E8BDDA-E363-4180-B8A0-20EEB5DD9510",
            text: "定结县",
          },
          {
            value: "6D647C31-57F0-4831-AB7A-A9C5F1D68472",
            text: "南木林县",
          },
          {
            value: "70024226-6C40-4D74-A482-74ED0E078D09",
            text: "仁布县",
          },
          {
            value: "72922E22-9829-4E4C-976B-1636BF4C780C",
            text: "日喀则市",
          },
          {
            value: "762C0EFE-2F8F-4B32-A705-0F8A5B54330D",
            text: "仲巴县",
          },
          {
            value: "7CC81AA8-3C71-4D48-A3F6-883EDD07C5AE",
            text: "江孜县",
          },
          {
            value: "93C8C7E9-2419-4540-9A23-C50D2822CB8F",
            text: "萨嘎县",
          },
          {
            value: "95C658A9-727A-4CD7-8FAB-8831995B6571",
            text: "亚东县",
          },
          {
            value: "A6E14AAF-7937-4E1B-BBA8-33FB7438CFE4",
            text: "白朗县",
          },
          {
            value: "AD5AE5DB-159D-4289-BFBA-156BBE014870",
            text: "拉孜县",
          },
          {
            value: "B86B92D0-D613-4392-B409-146D639B52E1",
            text: "谢通门县",
          },
          {
            value: "BA9D168D-30AD-41C8-BAB0-EC07D817CABB",
            text: "康马县",
          },
          {
            value: "E4417FA0-BC36-4136-86C2-8BE05F5AE4FD",
            text: "昂仁县",
          },
        ],
      },
      {
        value: "7150ABBD-A9A9-4612-B98E-889C90836BAB",
        text: "那曲地区",
        children: [
          {
            value: "0BFA549E-4D88-4436-9191-8D1B9715D7CA",
            text: "比如县",
          },
          {
            value: "429B778F-5C29-4E48-9181-B424A116C7C6",
            text: "班戈县",
          },
          {
            value: "4CA12371-46C2-461B-8F84-E104685D3761",
            text: "那曲县",
          },
          {
            value: "54464C2F-BF8C-4B15-A12E-851D62C245C2",
            text: "申扎县",
          },
          {
            value: "565EFEE2-3A22-4753-A71C-2E664261880E",
            text: "聂荣县",
          },
          {
            value: "80DED0D2-CCDF-4304-8B31-7BFA8221BBB9",
            text: "安多县",
          },
          {
            value: "9AAB7BB2-7E44-42D0-AA83-346B8BA9E159",
            text: "巴青县",
          },
          {
            value: "B90B3498-0EB3-4104-9BFC-4D401D294C46",
            text: "索县",
          },
          {
            value: "C3E0F096-2D72-479F-A863-FFF646C08BFF",
            text: "尼玛县",
          },
          {
            value: "F6547202-0503-4871-A4A7-39BFA0E36318",
            text: "嘉黎县",
          },
        ],
      },
      {
        value: "74323235-DA94-4AE2-BDBB-4619EAA1F30C",
        text: "山南地区",
        children: [
          {
            value: "040C557A-3FCA-4EA8-9296-B710AE058ECB",
            text: "浪卡子县",
          },
          {
            value: "05624778-6021-4E8B-8398-FB12C928A171",
            text: "桑日县",
          },
          {
            value: "05E13226-941C-404C-8235-9AA1F4DA8D27",
            text: "贡嘎县",
          },
          {
            value: "2A74AA0E-5731-4D2D-BBC5-F6710D33617B",
            text: "措美县",
          },
          {
            value: "2B23A2BA-E42D-4D7C-8F99-BBF7DC5D90CC",
            text: "加查县",
          },
          {
            value: "343A67B9-58D6-4AE3-9667-22BD7699F462",
            text: "隆子县",
          },
          {
            value: "41CAEBC0-41F0-4AED-8655-F99F42A5E958",
            text: "琼结县",
          },
          {
            value: "A48C1DF7-C94A-4BAB-BF6C-C1B835D06C40",
            text: "扎囊县",
          },
          {
            value: "B039E2C4-1588-4B80-859F-06DB7B583C16",
            text: "曲松县",
          },
          {
            value: "C0F09AAE-BF3E-4F05-983A-ECB2F66857EF",
            text: "错那县",
          },
          {
            value: "D02E8E37-8BF9-4A8A-B3D0-A6447600F712",
            text: "洛扎县",
          },
          {
            value: "D3388CEF-8770-4781-88EA-B6808A1B3DBA",
            text: "乃东县",
          },
        ],
      },
      {
        value: "962848A5-511A-4300-A3F5-3B6FBD6AAA27",
        text: "昌都地区",
        children: [
          {
            value: "1FAB8A33-56AC-4E33-9C77-288380E28FFA",
            text: "洛隆县",
          },
          {
            value: "21D6BD92-95FF-41F1-BACA-3F427ECDF206",
            text: "边坝县",
          },
          {
            value: "38DC2162-7424-4600-ADEB-E542BBE0F01E",
            text: "贡觉县",
          },
          {
            value: "4B26787F-ADB4-4B42-A417-2A3A7F016DA9",
            text: "类乌齐县",
          },
          {
            value: "5B0778A8-ACF2-4BEB-A36B-3B1758E6AB29",
            text: "八宿县",
          },
          {
            value: "5CB9BC32-EDA1-47A1-8333-1F94E412A7C5",
            text: "察雅县",
          },
          {
            value: "7FC999C7-18E2-4807-AEA7-F5120CC472B3",
            text: "江达县",
          },
          {
            value: "9C573D3A-B710-419C-AAFF-B64E18C26C02",
            text: "芒康县",
          },
          {
            value: "CB6BC02E-C4DA-4CFE-8825-95F6F75FD353",
            text: "昌都县",
          },
          {
            value: "DA1A7B6B-A0FC-41E7-B716-F0D8481C88AD",
            text: "左贡县",
          },
          {
            value: "F667FBD1-EF8D-4C14-857E-DE9E5227936E",
            text: "丁青县",
          },
        ],
      },
      {
        value: "B6E924E3-336A-4E88-A279-290A989BE5AB",
        text: "林芝地区",
        children: [
          {
            value: "1AA668E4-050D-4539-B8B7-D66019A5E989",
            text: "墨脱县",
          },
          {
            value: "52075CE8-3968-427C-A5C0-CB2353A697BA",
            text: "工布江达县",
          },
          {
            value: "5E318EB8-0FDB-4CBA-89D0-FBC0DAF90A7B",
            text: "米林县",
          },
          {
            value: "80A1EC08-A42B-4AD8-865F-AF249810688F",
            text: "朗县",
          },
          {
            value: "83709C9A-7D73-4DD6-A252-A7422F16C72A",
            text: "林芝县",
          },
          {
            value: "BC6B8F00-26D2-4A06-9D65-EDC3358DE05D",
            text: "波密县",
          },
          {
            value: "E24AC576-D624-4BD1-BFD0-E278C17553F1",
            text: "察隅县",
          },
        ],
      },
      {
        value: "BA6B0056-C917-4396-86A7-335F18C6E0F0",
        text: "拉萨市",
        children: [
          {
            value: "1D02F4C0-472E-4E44-9EE9-BC494E3A4E25",
            text: "当雄县",
          },
          {
            value: "42158479-2AAB-47A0-B768-66F7CBFB9C51",
            text: "达孜县",
          },
          {
            value: "77A80B99-0940-4B27-8669-4FC71959CB68",
            text: "尼木县",
          },
          {
            value: "858F11A2-89F5-473F-AC58-AC99232ACE41",
            text: "曲水县",
          },
          {
            value: "C3B8A020-5196-4CAB-BF1D-7F767758766B",
            text: "林周县",
          },
          {
            value: "D558588D-6815-4C7E-834E-C12A5C2655D9",
            text: "墨竹工卡县",
          },
          {
            value: "DE8E991E-A6E7-44C8-A89F-A41521142A77",
            text: "堆龙德庆县",
          },
        ],
      },
      {
        value: "FAAD31FF-747C-44B3-B833-1D24D53A924D",
        text: "阿里地区",
        children: [
          {
            value: "0DC560D4-1B1A-4ED4-9591-0B07451537E3",
            text: "改则县",
          },
          {
            value: "1D2F5F3C-7E8E-4111-B7DD-7498F6F502C4",
            text: "普兰县",
          },
          {
            value: "2662F807-078C-4614-B036-8EBFF663C60F",
            text: "札达县",
          },
          {
            value: "4437BBDC-7246-49F8-8BDD-FFC07CB8E49B",
            text: "日土县",
          },
          {
            value: "5C2FA922-0335-45FB-9D7E-66116E529240",
            text: "噶尔县",
          },
          {
            value: "D9759FFB-8AEB-4C3B-BA83-51B4D3769A17",
            text: "措勤县",
          },
          {
            value: "E3387042-1CED-4B97-99EB-F2F554E02687",
            text: "革吉县",
          },
        ],
      },
    ],
  },
  {
    text: "陕西省",
    value: "B8811A09-BF46-47FA-8ACD-20F538DC4787",
    children: [
      {
        value: "00AEB252-9006-4643-80B5-0E1ED5AB82D4",
        text: "商洛市",
        children: [
          {
            value: "0EDA6756-A18F-461B-981A-2C3D367DDCCE",
            text: "柞水县",
          },
          {
            value: "177474D8-317A-4A8B-B2E7-15102029683C",
            text: "丹凤县",
          },
          {
            value: "20694249-EBDB-491F-AF81-911543EC5466",
            text: "洛南县",
          },
          {
            value: "6FC4CB59-A465-4F50-8D9A-F04B75B6ECB9",
            text: "山阳县",
          },
          {
            value: "E99713C4-5603-4ADF-A9B9-8CFAF87E066D",
            text: "商州区",
          },
          {
            value: "EB1D66D1-2784-45A2-B5FF-5EACA761E85A",
            text: "镇安县",
          },
          {
            value: "F809FD3B-9F85-46AF-9D86-BDC10AA7358B",
            text: "商南县",
          },
        ],
      },
      {
        value: "29702653-92F3-4472-9F90-E03EC75C1261",
        text: "延安市",
        children: [
          {
            value: "03CCA874-121B-41F2-B581-417E8870D6A7",
            text: "黄龙县",
          },
          {
            value: "2AE0BA4D-3679-42F2-88C7-77A7617CB331",
            text: "安塞县",
          },
          {
            value: "44D27885-DE29-4F02-80B8-801737AE866A",
            text: "延长县",
          },
          {
            value: "64815472-4324-405D-88BD-B63CF3A176CA",
            text: "洛川县",
          },
          {
            value: "7C1C862F-6114-49DC-9B26-0AE494B4E519",
            text: "甘泉县",
          },
          {
            value: "90843B65-2170-4BFE-9B2C-613105514263",
            text: "志丹县",
          },
          {
            value: "D32DD871-11CF-47CF-A863-2350DA2DE453",
            text: "宝塔区",
          },
          {
            value: "D46F4014-677A-4B40-9F2C-74FD86AA5943",
            text: "黄陵县",
          },
          {
            value: "D728EA24-2817-4CF0-9AFF-FF088BA10DC3",
            text: "延川县",
          },
          {
            value: "E16FFFE4-2C0A-4352-965F-6CE138F86655",
            text: "宜川县",
          },
          {
            value: "F9025074-A361-43C8-9A6F-72A9DCB9ECA9",
            text: "子长县",
          },
          {
            value: "FC1301C3-C119-49C1-8A14-47B0956EB921",
            text: "富县",
          },
        ],
      },
      {
        value: "3510E99F-74AB-4609-B0E1-FEE86F831421",
        text: "咸阳市",
        children: [
          {
            value: "13A4DD67-C943-4434-BE4E-EEB929599EC3",
            text: "礼泉县",
          },
          {
            value: "18852B13-6C56-4C88-BDA8-E305A35A3F56",
            text: "泾阳县",
          },
          {
            value: "1D7B4303-688A-4971-AEAC-72006E85B5AE",
            text: "长武县",
          },
          {
            value: "24856F3A-2F87-4F73-AE2C-A67D905A6898",
            text: "旬邑县",
          },
          {
            value: "4B75C05E-5611-49ED-9F0C-02C4D1F71EF3",
            text: "秦都区",
          },
          {
            value: "53065337-127A-453A-973F-D55F144756DD",
            text: "永寿县",
          },
          {
            value: "7B353070-CAF7-4017-98FD-715253BC9FB1",
            text: "武功县",
          },
          {
            value: "8163F69B-531D-4359-8312-F673884BE5BF",
            text: "兴平市",
          },
          {
            value: "953E6856-B72C-41C4-8E25-E0BFFB7D1310",
            text: "三原县",
          },
          {
            value: "B2A7287A-183C-4E64-8FF1-4E5512287390",
            text: "乾县",
          },
          {
            value: "D7CF4213-E76F-40E0-89B7-D0E30037053E",
            text: "淳化县",
          },
          {
            value: "E2E51077-CBA8-4AB8-B250-786FDB0C7C2A",
            text: "杨凌区",
          },
          {
            value: "E71A980F-943B-4AAE-8BF3-646E6B507639",
            text: "彬县",
          },
          {
            value: "F98B0328-729D-42C3-A998-017611C271E4",
            text: "渭城区",
          },
        ],
      },
      {
        value: "507E36DF-7A2C-427F-B625-8781A3087468",
        text: "宝鸡市",
        children: [
          {
            value: "45885440-2860-4697-95E3-8D9EF844F4A7",
            text: "渭滨区",
          },
          {
            value: "471888C1-C48A-4BF3-A6F4-1A20158E05F9",
            text: "凤县",
          },
          {
            value: "516C9F54-F992-4126-8890-3E7D4F01AA73",
            text: "凤翔县",
          },
          {
            value: "592EE334-048D-4383-A6C5-01BBA55697E7",
            text: "麟游县",
          },
          {
            value: "7BAF13E9-7376-4F52-82A4-1A6D9C939148",
            text: "陈仓区",
          },
          {
            value: "7E9F9A5D-B7CB-41BB-9040-A7E31B4B32D8",
            text: "陇县",
          },
          {
            value: "9AF32D16-B5C7-4D0D-A2E4-DC01EB459F0A",
            text: "岐山县",
          },
          {
            value: "9D3949E3-960E-4E2B-BE4E-85BE0EE0C1ED",
            text: "太白县",
          },
          {
            value: "BE02AD94-9093-4F88-8C09-A1755A1E9EA6",
            text: "眉县",
          },
          {
            value: "BE5F6A41-22E9-4A50-B8A1-5A0B104FCF27",
            text: "金台区",
          },
          {
            value: "ED5E0EF6-DCFD-415D-ACC2-CA8B77064BD4",
            text: "扶风县",
          },
          {
            value: "F6BE03A6-6F8A-4DE1-BF2A-BDE080E4E1B5",
            text: "千阳县",
          },
        ],
      },
      {
        value: "A666EE5A-32BD-4E20-981E-730040D9DBF3",
        text: "铜川市",
        children: [
          {
            value: "0EB030BF-C55A-43AF-80AF-B0760A5A8CEF",
            text: "王益区",
          },
          {
            value: "0F99F55D-5B61-4DB0-8256-60021D5E29CD",
            text: "宜君县",
          },
          {
            value: "26DDFE89-0B91-4A49-9A51-83B51ACE0726",
            text: "印台区",
          },
          {
            value: "9C78276E-2396-4403-8D41-A01E8042FDD6",
            text: "耀州区",
          },
        ],
      },
      {
        value: "C8977C3F-72DC-42F3-85F3-29C794140152",
        text: "榆林市",
        children: [
          {
            value: "186C1ABD-5B71-4842-87C3-0523A6890B70",
            text: "府谷县",
          },
          {
            value: "1DD74417-7E2B-48B9-98C9-9F08F9529426",
            text: "绥德县",
          },
          {
            value: "2F01A702-333C-4917-8C21-E8F191B49D5D",
            text: "子洲县",
          },
          {
            value: "44E1979A-FDA5-4F31-981A-E606D4F96A58",
            text: "榆阳区",
          },
          {
            value: "53FBFC3B-355A-4AAB-B11F-FF2901AAB25B",
            text: "米脂县",
          },
          {
            value: "604DA4BD-A0E8-466B-9009-7B7FEE0FA5C3",
            text: "横山县",
          },
          {
            value: "6FB6271A-BF37-46AC-85D6-B421DF9CA7DA",
            text: "清涧县",
          },
          {
            value: "9C89ACE2-34C5-46FA-830F-70E047C750E5",
            text: "佳县",
          },
          {
            value: "BF1E2664-8546-4AC5-A655-EE95EDF49FEB",
            text: "神木县",
          },
          {
            value: "E1B011D4-303C-45C0-ADE7-165C32E14DE7",
            text: "靖边县",
          },
          {
            value: "F055F0E6-0937-4F75-AC73-011A927BB1C8",
            text: "吴堡县",
          },
          {
            value: "F69A7C09-BB55-41F9-BF80-3C1C4F82AFEF",
            text: "定边县",
          },
        ],
      },
      {
        value: "D592A91D-1890-4D96-B150-DAA9B3B63B07",
        text: "汉中市",
        children: [
          {
            value: "0457CEA6-EAE0-4BC4-B645-89E84F7922C1",
            text: "镇巴县",
          },
          {
            value: "0BE9AC79-4D9B-41A8-9230-600A23B3E3EB",
            text: "勉县",
          },
          {
            value: "635B6A9E-4B8B-4AAD-8453-D93CC8097FEE",
            text: "城固县",
          },
          {
            value: "788E2841-075E-4F33-9AE9-543F1674CF12",
            text: "留坝县",
          },
          {
            value: "93AD1823-2487-4959-AEAD-F208250E22D2",
            text: "西乡县",
          },
          {
            value: "9A1B35D3-9B7F-4C40-9EBC-DF023D44B902",
            text: "宁强县",
          },
          {
            value: "9DA394A6-FDB9-4271-A5FF-7D81AF54E084",
            text: "略阳县",
          },
          {
            value: "ACCE4F59-33F9-4B2D-9C7E-F896C05DD132",
            text: "汉台区",
          },
          {
            value: "D04BE858-F79C-40AD-9AC5-D217F0B7CF17",
            text: "洋县",
          },
          {
            value: "DC9AB000-9306-4A5D-9938-C527559A222C",
            text: "南郑县",
          },
          {
            value: "EABF75DC-6B24-4361-AFA4-0490F7C821CC",
            text: "佛坪县",
          },
        ],
      },
      {
        value: "E26DF878-4410-470F-AD2C-70AA5A1D2888",
        text: "西安市",
        children: [
          {
            value: "090890BF-8C52-4621-AE58-01A99B735671",
            text: "灞桥区",
          },
          {
            value: "18E4C8B1-966F-46FA-A1A6-B1C4085BE82E",
            text: "新城区",
          },
          {
            value: "3973AA2A-0D7A-4FAC-A8B2-3856BEDFEDA8",
            text: "户县",
          },
          {
            value: "535007BF-81DA-45BE-BA6B-90F37F71FD2A",
            text: "长安区",
          },
          {
            value: "72A46D43-150B-4839-9774-71348472F42F",
            text: "蓝田县",
          },
          {
            value: "77479DE2-BAEE-469B-B91E-A73A1A627689",
            text: "阎良区",
          },
          {
            value: "8E5C86D0-E3FB-4A2C-A044-543EF16BF962",
            text: "未央区",
          },
          {
            value: "B4357140-A186-4A34-B509-3B3CF00C539A",
            text: "临潼区",
          },
          {
            value: "C72914A8-FB6E-45AD-A108-0E034243ED2D",
            text: "周至县",
          },
          {
            value: "DF6616E3-12AE-4BD3-9B67-D465583EC289",
            text: "碑林区",
          },
          {
            value: "E962666A-E6E1-4EF8-B216-6371DA82C446",
            text: "高陵县",
          },
          {
            value: "E976DC6A-7C76-4049-9A43-6D2028815185",
            text: "雁塔区",
          },
          {
            value: "F88B0546-0523-453C-8201-A097EB60729D",
            text: "莲湖区",
          },
        ],
      },
      {
        value: "E65F7BD4-771C-4259-A179-582F39846DAA",
        text: "渭南市",
        children: [
          {
            value: "022FAA2B-C2C1-4167-BC89-E711E02C83EA",
            text: "华阴市",
          },
          {
            value: "0F3C01C7-2669-4304-88FF-B2263D870BD2",
            text: "蒲城县",
          },
          {
            value: "315352E5-2EA9-4D63-84FE-DF598A065A5C",
            text: "潼关县",
          },
          {
            value: "3B46A0EE-C6B7-4A56-9AB6-15CFA9BC3DB2",
            text: "白水县",
          },
          {
            value: "3E2D4412-5C35-4C51-846E-0AD853069B24",
            text: "大荔县",
          },
          {
            value: "56BDA9E7-B3FF-41DE-A937-EF79C10CDE80",
            text: "韩城市",
          },
          {
            value: "753F8CE3-976B-4DBF-A8EC-C737B409516B",
            text: "临渭区",
          },
          {
            value: "7C6F7B1D-1BAA-4386-AA94-2651A7C3741B",
            text: "富平县",
          },
          {
            value: "88302546-3F57-4279-A5FC-07D8B997A876",
            text: "合阳县",
          },
          {
            value: "C098AB8B-9438-4FDC-BC86-C9C6EC7DDACC",
            text: "华县",
          },
          {
            value: "FBE33179-5596-4842-82DA-A5A08A0F4673",
            text: "澄城县",
          },
        ],
      },
      {
        value: "F963FD28-FE5A-49C1-AA1F-ACAEA95B0E1D",
        text: "安康市",
        children: [
          {
            value: "210E0A13-75B3-45F9-925C-E6EEE44AFE0C",
            text: "白河县",
          },
          {
            value: "2675FB4B-335F-40EC-9342-E18726D585B3",
            text: "汉阴县",
          },
          {
            value: "35C32B0D-7C37-4FA3-A0E4-BB3A5957860E",
            text: "宁陕县",
          },
          {
            value: "46EDC9A3-7DAE-4244-836F-952D6ACE0592",
            text: "旬阳县",
          },
          {
            value: "599F7AB5-B8E4-439C-8F97-A4918A426FDA",
            text: "镇坪县",
          },
          {
            value: "7035DA8E-696B-4C3E-A8EF-6CB24A327D0D",
            text: "紫阳县",
          },
          {
            value: "71E3057C-5B51-4832-A5B1-91B08BFADC82",
            text: "汉滨区",
          },
          {
            value: "BEA0E276-6B3C-4D8C-8927-7923275DF91A",
            text: "岚皋县",
          },
          {
            value: "DA36AE7C-8121-4C1E-9162-6C9B00FE5DBD",
            text: "平利县",
          },
          {
            value: "E2C0B339-2F5E-40FA-9294-9BDC1285FBA9",
            text: "石泉县",
          },
        ],
      },
    ],
  },
  {
    text: "甘肃省",
    value: "AACDD8D9-E778-4F93-9CAA-E8C94A95B1FF",
    children: [
      {
        value: "1C47C26E-F486-40CF-A93D-C15D15E107C4",
        text: "张掖市",
        children: [
          {
            value: "01B0F321-F862-4CBD-BE78-3B8CD356EDE7",
            text: "高台县",
          },
          {
            value: "1065A83A-5295-4C0F-BF5C-DC32A4C361A1",
            text: "甘州区",
          },
          {
            value: "667443D1-5E0C-43F3-A019-DD27D3A7A03F",
            text: "临泽县",
          },
          {
            value: "E3B793FC-5023-4F6B-AC7C-2FD9937EEF59",
            text: "肃南裕固族自治县",
          },
          {
            value: "E4BA4B04-D868-471E-AAE4-DD446948B217",
            text: "民乐县",
          },
          {
            value: "F38CDA12-7071-4EFD-B85C-FD33CA825362",
            text: "山丹县",
          },
        ],
      },
      {
        value: "30BCE62D-ABC6-4568-9579-E2F6344C6208",
        text: "金昌市",
        children: [
          {
            value: "CB7D64A9-0D39-48A3-A249-1DED7D74ED64",
            text: "金川区",
          },
          {
            value: "DDC8BE51-B57D-4510-96ED-4FC403086DA0",
            text: "永昌县",
          },
        ],
      },
      {
        value: "62C83B3E-E845-45BE-9919-F597AC0D7EB9",
        text: "武威市",
        children: [
          {
            value: "5C03FBF1-CC1D-4ABD-BF71-C4C69A48F51A",
            text: "民勤县",
          },
          {
            value: "A271D3D8-60F9-4CE6-B95C-BE0324235AB7",
            text: "古浪县",
          },
          {
            value: "D04E6E0A-8497-455D-A2A1-2BB33C0E93BE",
            text: "凉州区",
          },
          {
            value: "DD092378-842F-4A08-B224-981E84F95A3F",
            text: "天祝藏族自治县",
          },
        ],
      },
      {
        value: "72C66B04-BCD7-4A0A-912C-C0023009A4F4",
        text: "庆阳市",
        children: [
          {
            value: "18BDA795-B9E2-4C14-A830-374C5D83106B",
            text: "庆城县",
          },
          {
            value: "236A68D4-9F6F-4BDA-AEB4-324EE5100DC0",
            text: "华池县",
          },
          {
            value: "438E5715-D2FE-4066-9156-127A63765CAF",
            text: "正宁县",
          },
          {
            value: "5ED49303-9511-4FB8-BDF6-255FF658BAB6",
            text: "合水县",
          },
          {
            value: "8147E36B-B121-4F26-A56D-CDCE8D2B9EF4",
            text: "宁县",
          },
          {
            value: "96F73448-A414-4167-9141-4262E8B669E9",
            text: "环县",
          },
          {
            value: "F079A8B7-01DA-4A80-8A0A-363D683C173F",
            text: "西峰区",
          },
          {
            value: "FD8244A8-CCFD-4F89-B9AC-E77EA9F29D12",
            text: "镇原县",
          },
        ],
      },
      {
        value: "7C74F7BA-1B13-431F-B7E7-25E2F2638BF6",
        text: "陇南市",
        children: [
          {
            value: "116E103F-A360-4111-A600-C4C1226A8434",
            text: "武都区",
          },
          {
            value: "146A2225-0880-4BC9-B568-5FB37D842A5F",
            text: "文县",
          },
          {
            value: "2AC9B214-FA66-4F94-B7EC-4C2F1B585533",
            text: "两当县",
          },
          {
            value: "40BEAA1F-D03C-444E-ACC1-3008740F31E5",
            text: "康县",
          },
          {
            value: "6A12BFBF-D9C5-4FB6-A76D-FEE625B356D3",
            text: "徽县",
          },
          {
            value: "AACDE92B-A87E-41AB-95B4-3BD512590862",
            text: "成县",
          },
          {
            value: "AF63E7A0-681B-46CE-87F9-61A1EF2798D0",
            text: "宕昌县",
          },
          {
            value: "BBFCAA80-0C47-4498-B3DD-AAE1F4D83263",
            text: "西和县",
          },
          {
            value: "EE10E2DD-5D4C-4975-922F-4F2E7AA427AC",
            text: "礼县",
          },
        ],
      },
      {
        value: "889CB2B1-92AE-47BF-8D7A-55906498B340",
        text: "平凉市",
        children: [
          {
            value: "2CF5E966-B696-4FF0-A3B3-16C2770FFBAF",
            text: "灵台县",
          },
          {
            value: "61D80EBF-515C-45FB-8E3C-A65EEBF99655",
            text: "泾川县",
          },
          {
            value: "66378995-9DC5-4DC5-BA47-87D78B0A67DE",
            text: "崇信县",
          },
          {
            value: "7CCDBF3C-4CB9-44C4-9C9A-3C8F0ED6571C",
            text: "静宁县",
          },
          {
            value: "AB8F13CB-0662-4CBF-B475-FD7BE4608755",
            text: "华亭县",
          },
          {
            value: "CA248D32-E5B5-4F5E-B1FF-26CCF11B2B31",
            text: "庄浪县",
          },
          {
            value: "E556DC83-64FD-4B1A-AA41-7743D2F5B9F8",
            text: "崆峒区",
          },
        ],
      },
      {
        value: "99A35CA7-1FA0-413A-9D7B-FDFFE0D536BE",
        text: "兰州市",
        children: [
          {
            value: "28BFEB49-572A-41AC-A5A2-D7ADADFFC65F",
            text: "安宁区",
          },
          {
            value: "4984E16B-B79E-4053-8CD9-4423A7FB9AB5",
            text: "城关区",
          },
          {
            value: "6F580A4D-3456-41A0-9592-093EDFCB90C9",
            text: "西固区",
          },
          {
            value: "945CEDD4-50A6-4F23-ABBB-91FA0CD748A8",
            text: "皋兰县",
          },
          {
            value: "ADCB997F-31C8-4B0E-98EF-DA6F3DA7D31A",
            text: "榆中县",
          },
          {
            value: "B97A0EB6-E935-4CF2-A668-E05FBC706D30",
            text: "红古区",
          },
          {
            value: "CFDE6E00-E30F-45A3-A63E-FDAC67A1C77C",
            text: "七里河区",
          },
          {
            value: "DD558E16-ED06-457B-A748-E70541595207",
            text: "永登县",
          },
        ],
      },
      {
        value: "9E669CA6-BABD-42EA-953E-CD91586DA82D",
        text: "定西市",
        children: [
          {
            value: "15FBFAA3-B809-4DBB-9B14-2F841005A012",
            text: "渭源县",
          },
          {
            value: "42BA65DC-B3FE-470F-955A-E4AAB256F3B1",
            text: "陇西县",
          },
          {
            value: "59B207DF-726D-4810-8E99-563572D73F67",
            text: "安定区",
          },
          {
            value: "6BB6CD5A-0A97-4B9D-924F-8D559FC03C39",
            text: "临洮县",
          },
          {
            value: "B0AD8DBA-CB89-4F8F-A5D4-81A1C2F1884E",
            text: "漳县",
          },
          {
            value: "B734B0F3-C68E-44E5-98D6-3F0A7F1AE1EC",
            text: "通渭县",
          },
          {
            value: "F201CA74-367D-4E70-BA24-98C8BD965D7F",
            text: "岷县",
          },
        ],
      },
      {
        value: "A8514C2F-637F-4F3B-8279-845E4F2967F7",
        text: "嘉峪关市",
        children: [],
      },
      {
        value: "BD6CB824-7B94-4F8E-8BCE-1080B90EBBE4",
        text: "酒泉市",
        children: [
          {
            value: "6E3CBB21-FD31-4146-9B43-F69A907D9CE6",
            text: "玉门市",
          },
          {
            value: "87401FB7-CAE9-4A55-9EAB-E3D1D0230774",
            text: "肃北蒙古族自治县",
          },
          {
            value: "9CC2246B-1C39-48A2-930F-1907FB92BA76",
            text: "金塔县",
          },
          {
            value: "AC404F72-806F-4A8F-BAD2-52EB31DAF81E",
            text: "肃州区",
          },
          {
            value: "B344D533-5063-47B2-9AFD-5ECD4E7A493D",
            text: "阿克塞哈萨克族自治县",
          },
          {
            value: "B3E6C1A9-D0FB-4CED-98CA-93161835FD9A",
            text: "敦煌市",
          },
          {
            value: "D907A6F6-E5BC-42EA-90D8-288EEF22A68D",
            text: "瓜州县",
          },
        ],
      },
      {
        value: "C9AF2E17-1AAA-4540-98AA-F67F7868C74D",
        text: "天水市",
        children: [
          {
            value: "0420E924-B8DF-45C3-84F7-20F5646FBF13",
            text: "秦安县",
          },
          {
            value: "1DDD86D8-A156-4DC2-819F-4B0BE3AA781D",
            text: "清水县",
          },
          {
            value: "2B5B0238-E1FC-4FD6-8F36-495E4BFA1BA3",
            text: "甘谷县",
          },
          {
            value: "5F142CDD-5F55-4592-801E-A44BA387C6E8",
            text: "秦州区",
          },
          {
            value: "8F08B34F-5BEA-419B-855E-61CDB7BDF7D2",
            text: "张家川回族自治县",
          },
          {
            value: "CD4B5251-F8D0-469D-A1DA-C5F1EEDCA668",
            text: "武山县",
          },
          {
            value: "FD105291-BA89-428F-9DD0-AB093A250471",
            text: "麦积区",
          },
        ],
      },
      {
        value: "CAA42BBD-0FA6-4081-8100-0549C13097DA",
        text: "甘南藏族自治州",
        children: [
          {
            value: "019C968F-A634-46B6-99C1-1C51E6083D00",
            text: "夏河县",
          },
          {
            value: "18DAA3FD-9BC6-4B2D-8A72-8C5372B53C38",
            text: "迭部县",
          },
          {
            value: "2BDCB21A-32A7-4EB7-956D-7217B4E211DE",
            text: "合作市",
          },
          {
            value: "40E6C808-F713-4879-9B96-EE4FFCE67C58",
            text: "临潭县",
          },
          {
            value: "4824FFF3-1195-44EE-B99A-AB1BB161D6A1",
            text: "碌曲县",
          },
          {
            value: "759A9B9F-DC71-440A-9AE8-A3C58B862720",
            text: "卓尼县",
          },
          {
            value: "A2EFDF24-B64E-4D08-A2C4-4ACAC9E09F18",
            text: "玛曲县",
          },
          {
            value: "A6D7C39C-C11E-4380-9620-2D7A79DB5FDD",
            text: "舟曲县",
          },
        ],
      },
      {
        value: "CFDB9086-FBFD-472D-A384-CFBE2A2147DD",
        text: "临夏回族自治州",
        children: [
          {
            value: "18122766-4E89-4491-AA8E-B1CC73A36680",
            text: "积石山保安族东乡族撒拉族自治县",
          },
          {
            value: "186B10BC-2E7B-4AFE-B8D5-93998C7E29EF",
            text: "临夏市",
          },
          {
            value: "18F19C04-6EB0-4CF2-9D10-6E93136D1034",
            text: "永靖县",
          },
          {
            value: "3153CC6C-307A-4871-A92D-9F4EE0A39D8C",
            text: "东乡族自治县",
          },
          {
            value: "3788E16F-9867-4F81-8772-85E72AC66E93",
            text: "临夏县",
          },
          {
            value: "A6B550A2-575B-4E95-BBC2-A77B3FB035CD",
            text: "康乐县",
          },
          {
            value: "C97021C0-B150-45E9-90E2-43E5C7FC7EA6",
            text: "广河县",
          },
          {
            value: "E1E66D6E-E82F-4B37-904E-D8CA46956624",
            text: "和政县",
          },
        ],
      },
      {
        value: "D4E87F8E-C69E-4694-9B9D-E21CFA5648D0",
        text: "白银市",
        children: [
          {
            value: "02D61F07-6740-4684-A471-FAE715522ABD",
            text: "白银区",
          },
          {
            value: "7AF8A084-2B04-4A29-AABE-732DC87FCEA3",
            text: "景泰县",
          },
          {
            value: "9942B84E-62D7-412A-B901-25022D3016FB",
            text: "靖远县",
          },
          {
            value: "A69C14F7-05E3-442F-A039-B980D66EA203",
            text: "平川区",
          },
          {
            value: "B9267555-BBEA-4010-8BF4-C2A8D3DE8B17",
            text: "会宁县",
          },
        ],
      },
    ],
  },
  {
    text: "青海省",
    value: "9A95F7AC-BB7F-4020-92D7-71D37F40AAB8",
    children: [
      {
        value: "28A38F30-91A7-4F24-8DF7-6C61F2F7B15D",
        text: "海南藏族自治州",
        children: [
          {
            value: "1ED3E41C-D403-4A0A-AC63-5E04AF48E07C",
            text: "贵南县",
          },
          {
            value: "355974D8-2AB1-4F1D-B1B7-A3580B9658C7",
            text: "共和县",
          },
          {
            value: "368C85EB-3AE8-4962-90BE-6A17FAD3BD78",
            text: "兴海县",
          },
          {
            value: "B864EE2F-2D9E-4C6A-993E-F874F89C9381",
            text: "贵德县",
          },
          {
            value: "E4F0AA50-EC4C-4AB7-836C-937311934A60",
            text: "同德县",
          },
        ],
      },
      {
        value: "32834D83-E2CD-407A-AA0C-4E3614571526",
        text: "玉树藏族自治州",
        children: [
          {
            value: "4E2D918C-2CDA-4CEA-B627-0874481314E3",
            text: "杂多县",
          },
          {
            value: "4E7667B6-426B-4508-9603-A1EE1CBAECA3",
            text: "玉树县",
          },
          {
            value: "69984FC1-1DA9-4A77-B60D-9400106C8C72",
            text: "称多县",
          },
          {
            value: "A065CCE0-C74F-4D5A-B4A6-C8CD0DE71E95",
            text: "囊谦县",
          },
          {
            value: "A4919E32-86BB-4EA9-912B-FC7630C68A39",
            text: "治多县",
          },
          {
            value: "A6A3D19B-A6C5-46CC-AE35-CFB6117B7625",
            text: "曲麻莱县",
          },
        ],
      },
      {
        value: "3ABDFD6D-FA00-4A01-A8CD-11EE6FB7CA76",
        text: "西宁市",
        children: [
          {
            value: "1BB42791-2DA0-49F3-9343-251F14343FAB",
            text: "城东区",
          },
          {
            value: "55F4B66F-A54E-413C-A4EF-3D09FF336EFE",
            text: "大通回族土族自治县",
          },
          {
            value: "61404245-7408-4B31-803F-9CE9A4905596",
            text: "城西区",
          },
          {
            value: "97D1B948-EA35-42CF-BB0B-6F1B6874764C",
            text: "城北区",
          },
          {
            value: "ACCEC18A-40F3-4F9F-9A61-2925B7468B4C",
            text: "湟源县",
          },
          {
            value: "C33725E2-339A-4D9C-ACDC-60F6213238C1",
            text: "城中区",
          },
          {
            value: "F1AA2CFA-B1B5-4565-81DC-C6D4CC5ED571",
            text: "湟中县",
          },
        ],
      },
      {
        value: "5A32567B-3347-4529-95FE-47EB4FA4CA3B",
        text: "海东地区",
        children: [
          {
            value: "05633B27-D0E3-4ABB-A8B5-AC44B81D360B",
            text: "循化撒拉族自治县",
          },
          {
            value: "16129752-3107-4C6C-BEAA-ED58FC10DEEF",
            text: "民和回族土族自治县",
          },
          {
            value: "80DF2E66-B94D-42AD-9C22-DE88523634A7",
            text: "互助土族自治县",
          },
          {
            value: "A2E8C716-AB59-4BA7-954F-F8F5271AF602",
            text: "乐都县",
          },
          {
            value: "BDC44286-7459-407F-9CED-97D0C7DE2CB1",
            text: "化隆回族自治县",
          },
          {
            value: "DD3672E0-D133-4AB8-A819-BEAEB2ECC400",
            text: "平安县",
          },
        ],
      },
      {
        value: "62E1C2B0-4548-49D0-8D57-33F4DFFC2FBD",
        text: "海北藏族自治州",
        children: [
          {
            value: "04CE5410-A199-4573-8216-569F1E9111E7",
            text: "祁连县",
          },
          {
            value: "E53295AC-FE5E-4F96-8CF9-C70C7DF01BB2",
            text: "门源回族自治县",
          },
          {
            value: "FA1328A9-3E10-49E0-9B11-793681E97D9A",
            text: "刚察县",
          },
          {
            value: "FDBA4B4B-6916-4B28-92A8-FE3DFF0282AB",
            text: "海晏县",
          },
        ],
      },
      {
        value: "69263100-812B-497C-9106-5DEF09578599",
        text: "果洛藏族自治州",
        children: [
          {
            value: "24FE73D7-AE88-44C7-8608-2C318FEF2CB9",
            text: "甘德县",
          },
          {
            value: "3A3218B2-E223-4ED7-AE1E-3BDA7123C2C1",
            text: "久治县",
          },
          {
            value: "5B7B72B0-ED9A-4E27-B712-6BDBA471780D",
            text: "玛多县",
          },
          {
            value: "6E6EAC8E-85EF-4DB1-8477-566322BB9624",
            text: "达日县",
          },
          {
            value: "A6C7DB5E-0062-4B6A-92CD-C2114023C557",
            text: "玛沁县",
          },
          {
            value: "C12B30A2-C2D9-4CF2-9398-B7A9AE54643C",
            text: "班玛县",
          },
        ],
      },
      {
        value: "A7F6EC8E-FEDC-45F0-B9C6-ABA847B8A66F",
        text: "黄南藏族自治州",
        children: [
          {
            value: "23DCE36E-053A-46C7-BDBC-52A68B059C9D",
            text: "泽库县",
          },
          {
            value: "24164D03-6AD8-42F1-8BE4-A5379CE5830F",
            text: "尖扎县",
          },
          {
            value: "6CA5BDCE-9789-47C2-9738-589FE7494393",
            text: "同仁县",
          },
          {
            value: "FF38136A-130B-4EF8-A5E0-400FC631947F",
            text: "河南蒙古族自治县",
          },
        ],
      },
      {
        value: "B8581C58-FEE8-4BD4-8BE6-C0E0FFBFBC6F",
        text: "海西蒙古族藏族自治州",
        children: [
          {
            value: "315C2E1E-33B7-487E-90E4-69404B3DB71C",
            text: "茫崖",
          },
          {
            value: "5318B3AB-06B5-4232-A09C-562B9798BF77",
            text: "格尔木市",
          },
          {
            value: "6E7C9871-34C0-41D8-8D92-70B668422549",
            text: "德令哈市",
          },
          {
            value: "7C96BD97-C7C6-45B7-86FD-4EFF1FF0F9B8",
            text: "冷湖",
          },
          {
            value: "959CC98F-F173-4D43-83F6-A4D9F8D136BE",
            text: "大柴旦",
          },
          {
            value: "B0346816-7D53-42D1-B00C-C7FD5CDF05F7",
            text: "乌兰县",
          },
          {
            value: "CBB78A5E-88BA-47CC-902D-B5CAD2E18ED0",
            text: "都兰县",
          },
          {
            value: "FDAD9086-A3EF-4F48-9E83-CC78443BCE32",
            text: "天峻县",
          },
        ],
      },
    ],
  },
  {
    text: "宁夏回族自治区",
    value: "B1C5829D-F61C-46E1-8971-077140B901A3",
    children: [
      {
        value: "36A0F82F-2232-4394-8325-E94E6BB2BCAE",
        text: "石嘴山市",
        children: [
          {
            value: "253741A7-2F1F-4640-B8E4-401B11BD5CAF",
            text: "平罗县",
          },
          {
            value: "9CE36244-E058-47DE-84BE-A14C705714AB",
            text: "惠农区",
          },
          {
            value: "F347CC8F-E56B-48E4-9F28-A1A223756AE9",
            text: "大武口区",
          },
        ],
      },
      {
        value: "9960E4D9-6687-4343-880E-456ED423C3DB",
        text: "吴忠市",
        children: [
          {
            value: "06A149D2-63C4-4740-B6CC-E6092C5290D5",
            text: "青铜峡市",
          },
          {
            value: "20D8CFA3-E1CD-4B29-B163-2C1115EAF1FD",
            text: "同心县",
          },
          {
            value: "563890F8-DF8B-41F8-ADBF-88881525CE43",
            text: "盐池县",
          },
          {
            value: "87DC95A5-C370-4D8E-BE22-22B5B4B2818C",
            text: "利通区",
          },
        ],
      },
      {
        value: "B16E2631-63F0-4D23-B474-981BD38BC7EC",
        text: "中卫市",
        children: [
          {
            value: "895D6B03-1650-43FF-B8D0-A08BE15D3522",
            text: "沙坡头区",
          },
          {
            value: "910D6209-04BB-45F1-A9A7-0229D2C037B2",
            text: "海原县",
          },
          {
            value: "BD4D7E60-A2BF-437F-855B-12AA17AEC636",
            text: "中宁县",
          },
        ],
      },
      {
        value: "C7AFA765-EB52-42E9-9968-3722DE89B079",
        text: "固原市",
        children: [
          {
            value: "219B35F5-5994-4CAB-996C-2B514FBD07CD",
            text: "彭阳县",
          },
          {
            value: "4166B5D0-C5FE-4698-B6FB-EF8EB98B05C1",
            text: "原州区",
          },
          {
            value: "53E9AEF0-A3D4-43B3-8B1F-975BBD320AA5",
            text: "隆德县",
          },
          {
            value: "C479F306-E363-4946-8F7F-2EA2B92DD124",
            text: "泾源县",
          },
          {
            value: "CEE574C8-4FF0-4B70-BEA8-E02F4580A24A",
            text: "西吉县",
          },
        ],
      },
      {
        value: "F985F6F6-9D28-42B4-BE8C-618E15FB7178",
        text: "银川市",
        children: [
          {
            value: "255020A8-2166-4886-8A0D-C4A60C847FCB",
            text: "永宁县",
          },
          {
            value: "53E79448-1108-4F10-A84C-190A0F18A039",
            text: "金凤区",
          },
          {
            value: "9CCF0892-433E-482B-9B63-DF2974671C38",
            text: "西夏区",
          },
          {
            value: "A2E34EF2-6D26-43F9-89DB-B28601BE62F0",
            text: "兴庆区",
          },
          {
            value: "DE4CC8DA-D5E3-4367-AA5F-088F54E13E2D",
            text: "贺兰县",
          },
          {
            value: "F8C6D111-688B-428D-8C58-651F0A521486",
            text: "灵武市",
          },
        ],
      },
    ],
  },
  {
    text: "新疆维吾尔自治区",
    value: "F21B5645-E3A4-40D0-BCE6-18C678765C57",
    children: [
      {
        value: "05546B1E-D0C2-48D8-94D4-5C30FECE78F1",
        text: "阿克苏地区",
        children: [
          {
            value: "1039FB44-580A-4198-8F46-780926CF4BFC",
            text: "阿瓦提县",
          },
          {
            value: "337BFAE4-A5EF-40C7-9C0C-A200CFD5C47B",
            text: "沙雅县",
          },
          {
            value: "70FA7C5C-BA93-493B-8A95-AEFB5FC9570B",
            text: "拜城县",
          },
          {
            value: "71A8743D-4D23-40D9-AE1C-28C61612DB19",
            text: "温宿县",
          },
          {
            value: "9A2A5505-DD58-47F9-B116-7FB0149F6D98",
            text: "乌什县",
          },
          {
            value: "BD646137-34E9-40AA-BFE6-725931A81AA2",
            text: "柯坪县",
          },
          {
            value: "C051EC70-0F10-40B0-BC97-6C1E08297492",
            text: "阿克苏市",
          },
          {
            value: "D86D0181-832F-472F-BDA9-16CE567C31DE",
            text: "新和县",
          },
          {
            value: "DD6B6118-18B3-4C8F-B9BC-44A268C77A59",
            text: "库车县",
          },
        ],
      },
      {
        value: "161295C9-4B2B-4A5A-8CD4-51C2E83CB0B5",
        text: "昌吉回族自治州",
        children: [
          {
            value: "012483E2-1963-4EC0-B08F-2DB953A596B3",
            text: "五家渠市",
          },
          {
            value: "25DB6CB6-8538-4AB0-8BAE-DDB7A6F1DCEF",
            text: "昌吉市",
          },
          {
            value: "2B32357E-6BF3-4C8A-A4A7-F783298329C8",
            text: "呼图壁县",
          },
          {
            value: "2EFEB7EE-43E6-479A-AFD9-2E0917E16039",
            text: "奇台县",
          },
          {
            value: "4EE64C3A-74F1-4BA9-AD12-914C336614CE",
            text: "阜康市",
          },
          {
            value: "80474502-9A18-4DD9-A714-B46A5A3C5C13",
            text: "吉木萨尔县",
          },
          {
            value: "97CC98B8-AA78-4AF1-891C-721530791D26",
            text: "木垒哈萨克自治县",
          },
          {
            value: "EB31FF9B-EDE9-4D8F-B3E2-C631B1AAD45B",
            text: "玛纳斯县",
          },
        ],
      },
      {
        value: "1BCAA132-D2AC-40E1-8D35-47492771065F",
        text: "喀什地区",
        children: [
          {
            value: "0D2DC3AF-B453-410E-9D64-6FAC61917025",
            text: "巴楚县",
          },
          {
            value: "1041636C-2871-4837-A842-A95E20610F7E",
            text: "疏附县",
          },
          {
            value: "25934481-0154-4B6A-9194-5454E90D3AC3",
            text: "英吉沙县",
          },
          {
            value: "3A5BB6E2-EADA-4EAF-BF33-637665A1F031",
            text: "叶城县",
          },
          {
            value: "3D022DA4-CFD3-496B-A35C-F83BA134EF02",
            text: "喀什市",
          },
          {
            value: "4129B072-4D74-4125-AC11-9B1127ACC78C",
            text: "麦盖提县",
          },
          {
            value: "4576332C-B518-4CEE-97F1-FF626CE50A53",
            text: "莎车县",
          },
          {
            value: "5C1B431B-9E9F-4602-A3FA-04952678B002",
            text: "伽师县",
          },
          {
            value: "B605B12B-210B-4083-A206-9CF7DDB7A259",
            text: "疏勒县",
          },
          {
            value: "BDF4B8F2-2356-4F4F-89AA-EDD2767A2C21",
            text: "塔什库尔干塔吉克自治县",
          },
          {
            value: "DC5E5D8E-767E-4929-9CFC-352CF05684E9",
            text: "岳普湖县",
          },
          {
            value: "EC654A28-B809-4F6D-B858-9081D5DBAE97",
            text: "泽普县",
          },
        ],
      },
      {
        value: "39C32C17-77A8-4608-9950-354F6F5F6901",
        text: "伊犁哈萨克自治州",
        children: [
          {
            value: "2475C50A-3933-473A-80EF-2981493432F9",
            text: "尼勒克县",
          },
          {
            value: "39633A57-E0EE-42A6-BB36-8E9532AEFD2A",
            text: "巩留县",
          },
          {
            value: "4512534F-9F14-48FA-993F-74076F950D19",
            text: "特克斯县",
          },
          {
            value: "494ECC48-FE66-4747-A918-378469505129",
            text: "新源县",
          },
          {
            value: "5AE28B3B-0F21-4B24-812F-9CB99437313C",
            text: "霍城县",
          },
          {
            value: "7F772B48-B907-4F00-9515-6412205B57D5",
            text: "昭苏县",
          },
          {
            value: "8D14A79A-B41B-483E-A3B0-3870707FC274",
            text: "察布查尔锡伯自治县",
          },
          {
            value: "9062F47D-A873-4C82-91ED-DB2D657E55AD",
            text: "伊宁县",
          },
          {
            value: "B519C670-60E8-4AE8-863C-070402B4E0A5",
            text: "奎屯市",
          },
          {
            value: "C5AC31FF-F3D3-4EEF-80A3-0F5CE51475E1",
            text: "伊宁市",
          },
        ],
      },
      {
        value: "3FAD0DED-EDCE-4298-A95C-1F46F4348E93",
        text: "克拉玛依市",
        children: [
          {
            value: "0B8F3C64-B644-41C3-B42B-41FEBDF732B2",
            text: "独山子区",
          },
          {
            value: "201A1BA1-1F46-4DA9-A1D2-9502E0B075FA",
            text: "白碱滩区",
          },
          {
            value: "2D0D6B7C-630D-4654-BF4C-64F665B78313",
            text: "克拉玛依区",
          },
          {
            value: "698E5814-4F19-46D1-AD3C-077C119BBA60",
            text: "乌尔禾区",
          },
        ],
      },
      {
        value: "414E7EB6-AA64-452D-A9B1-F5EA55C7F738",
        text: "克孜勒苏柯尔克孜自治州",
        children: [
          {
            value: "178312A8-EF79-4202-A0D0-02B4E0BE6ACD",
            text: "阿克陶县",
          },
          {
            value: "21D69E24-8670-4654-8303-D02FFB595E68",
            text: "阿合奇县",
          },
          {
            value: "71665E5C-99B9-44C4-A9D3-3A14DBBB6C6B",
            text: "乌恰县",
          },
          {
            value: "F97457EA-8E34-47B2-A82A-BC8BF0B114A8",
            text: "阿图什市",
          },
        ],
      },
      {
        value: "5DEDAB00-C98B-40A5-8004-9436700A9F0A",
        text: "博尔塔拉蒙古自治州",
        children: [
          {
            value: "2D77CF16-DB7B-40A8-A846-6CFCCF2FEDF7",
            text: "精河县",
          },
          {
            value: "B23F6FE1-CE18-4FB9-8E5E-466F064AE858",
            text: "温泉县",
          },
          {
            value: "CEFCEC5E-A3A1-483B-A8F7-26A7270DD9D3",
            text: "博乐市",
          },
        ],
      },
      {
        value: "84368600-A6EF-4167-A95F-FCDDFAB915F0",
        text: "乌鲁木齐市",
        children: [
          {
            value: "02C7D7B5-0798-49C4-91F1-56D7047147FB",
            text: "沙依巴克区",
          },
          {
            value: "052A8736-9649-46F9-86B1-56C2CFADFE2A",
            text: "米东区",
          },
          {
            value: "1E6AF8C5-E9C7-4AD3-A112-F109E9A7AFDD",
            text: "达坂城区",
          },
          {
            value: "8851E6DF-E65B-4ED4-9870-CB4575909DF7",
            text: "乌鲁木齐县",
          },
          {
            value: "8BD545F1-AAB3-4F78-89D3-8DDB9FA5D660",
            text: "头屯河区",
          },
          {
            value: "AA7A2C32-30CF-427C-8BBD-2D409537AD75",
            text: "新市区",
          },
          {
            value: "B72C35FB-F0D6-478E-AE8F-B719DC107D10",
            text: "水磨沟区",
          },
          {
            value: "FB1F3933-285C-41A1-9C3D-A4448DAFD44D",
            text: "天山区",
          },
        ],
      },
      {
        value: "88426D32-454A-4986-AC2F-DFB227962794",
        text: "石河子市",
        children: [],
      },
      {
        value: "88BE69EB-476E-42EB-BACD-0AD07E2819DA",
        text: "图木舒克市",
        children: [],
      },
      {
        value: "96D08422-1132-43BC-94FA-09CB0988994A",
        text: "塔城地区",
        children: [
          {
            value: "0769B134-0678-4B08-8011-EBD0C04C9041",
            text: "托里县",
          },
          {
            value: "5E7A7FFE-E263-4DE4-B692-8CF68662E47B",
            text: "乌苏市",
          },
          {
            value: "9FB8156F-5A9D-49DB-B135-58D5272E0FD7",
            text: "额敏县",
          },
          {
            value: "AE2F3C30-F1F9-4B1A-9ABC-349DCF34C627",
            text: "塔城市",
          },
          {
            value: "BEE8485A-C62E-4140-AF2B-A6F3B0C20FA7",
            text: "和布克赛尔蒙古自治县",
          },
          {
            value: "F4B7BE00-3216-44FA-B31E-E1344BE5F554",
            text: "裕民县",
          },
          {
            value: "FC4E150F-33E3-4C4B-A591-57984C6317A3",
            text: "沙湾县",
          },
        ],
      },
      {
        value: "AA0B81EE-FCED-4C73-9A55-96C7934860D0",
        text: "哈密地区",
        children: [
          {
            value: "5B8BF6E7-E4CA-44BA-BF9F-FCA7D452F239",
            text: "哈密市",
          },
          {
            value: "7F2A9A29-6A26-4F58-9350-5DFCD1CA27E1",
            text: "巴里坤哈萨克自治县",
          },
          {
            value: "9CCF9D7E-C08C-46CA-9BDA-63E9F5D67E1F",
            text: "伊吾县",
          },
        ],
      },
      {
        value: "ACAC8A9C-7867-41B2-A95E-CFA8E909633B",
        text: "阿拉尔市",
        children: [],
      },
      {
        value: "C5229176-D14E-49EA-947E-2DA4761FF263",
        text: "巴音郭楞蒙古自治州",
        children: [
          {
            value: "0C824D19-D877-4B69-B8E9-978DE6BF698B",
            text: "若羌县",
          },
          {
            value: "0DB349B6-D9DA-4F50-BB38-437A77C03BC8",
            text: "尉犁县",
          },
          {
            value: "25697A06-5CE4-4F36-963D-3E058E317D43",
            text: "且末县",
          },
          {
            value: "285AE380-12FA-48E8-B4BB-B0A389BB5E98",
            text: "轮台县",
          },
          {
            value: "4CF5F690-E4D9-469C-A5BC-FA11DD0F7E83",
            text: "博湖县",
          },
          {
            value: "5BCAAA0A-739A-42AC-A7F6-A398E596546E",
            text: "和硕县",
          },
          {
            value: "C370BA6D-EEBB-45C5-86D8-F88DFD731FCE",
            text: "库尔勒市",
          },
          {
            value: "DA311997-F7DB-4D58-841B-C06C42B87C2D",
            text: "和静县",
          },
          {
            value: "F4DBA11A-ED59-47FE-87F7-E254F837A9B5",
            text: "焉耆回族自治县",
          },
        ],
      },
      {
        value: "D4ED44C3-6B99-424D-B2B5-922B6B15886E",
        text: "阿勒泰地区",
        children: [
          {
            value: "18DB7FD7-2C76-4CC2-84E3-AB563402970E",
            text: "富蕴县",
          },
          {
            value: "1FD2E194-E712-48ED-B6A2-3043E56A2AC1",
            text: "哈巴河县",
          },
          {
            value: "3EDB70B6-820B-4B11-808D-AC57F7881CD0",
            text: "福海县",
          },
          {
            value: "4738EAD0-A15E-48B9-A3C8-6979FCB46BA6",
            text: "青河县",
          },
          {
            value: "5A05025F-A8AC-4676-8B22-90815E29DF87",
            text: "吉木乃县",
          },
          {
            value: "87F6663A-867E-445C-B9C1-483B39E27BF1",
            text: "布尔津县",
          },
          {
            value: "CD45E6DD-6E8E-46CD-AC86-0AEDD8E49FCF",
            text: "阿勒泰市",
          },
          {
            value: "F0BBA43C-C0A3-4BE5-9301-A8B0F722B0E3",
            text: "北屯镇",
          },
        ],
      },
      {
        value: "D8D6B40F-A32C-467A-852A-A815D54C9FAD",
        text: "和田地区",
        children: [
          {
            value: "2B2AC816-3927-4038-ADB8-5A21F9D00B7A",
            text: "墨玉县",
          },
          {
            value: "41D66E5B-DA6A-45A8-9923-14282E590F9C",
            text: "于田县",
          },
          {
            value: "60674A96-883B-4774-8113-A1E28F325A7B",
            text: "民丰县",
          },
          {
            value: "63EED445-E352-4F86-AA24-5401E425A11B",
            text: "洛浦县",
          },
          {
            value: "7B1B7861-D834-43A0-9C42-E51788D6974D",
            text: "和田县",
          },
          {
            value: "8BEA134E-5A89-4A97-9CCA-B93030A6E95A",
            text: "皮山县",
          },
          {
            value: "C4041890-27C2-4A9B-B9C3-9608773EF746",
            text: "策勒县",
          },
          {
            value: "CD7112B0-1056-4750-9F1B-8A7CCA1D4405",
            text: "和田市",
          },
        ],
      },
      {
        value: "D9AA7184-11C1-446B-AEB9-77313A02498C",
        text: "吐鲁番地区",
        children: [
          {
            value: "317DD245-C625-4605-9DC7-F5F8C8F1173A",
            text: "托克逊县",
          },
          {
            value: "69EA81F2-B5D8-4216-BFB6-73D8FD2AB5E1",
            text: "鄯善县",
          },
          {
            value: "ADFDDF1D-291A-40A4-812B-B686723B4E72",
            text: "吐鲁番市",
          },
        ],
      },
    ],
  },
];

let wx = window.wx;

// 获取随机字符串
function randomString(len) {
  len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

// 初始化应用信息（目前只在新版会话组件使用）
export function getAgentConfig(token) {
  return new Promise((resolve, reject) => {
    // 获取企业相关数据
    getAgent(token).then((res) => {
      let noncestr = randomString(17);
      let timestamp = Date.parse(new Date()) / 1000;
      let url = window.location.href.split(":")[0] + ':' + window.location.href.split(":")[1];
      let signature = sha1(
        `jsapi_ticket=${res.data.ticket
        }&noncestr=${noncestr}&timestamp=${timestamp}&url=${url}`
      ); //签名串
      let agentConfigParams = {
        corpid: res.data.corpId,
        agentid: res.data.agentId,
        timestamp,
        nonceStr: noncestr,
        signature,
        jsApiList: ["selectExternalContact", "wwapp.invokeJsApiByCallInfo"], //必填，传入需要使用的接口名称
      };
      // agentConfigParams.signature = ,// 必填，签名，见附录-JS-SDK使用权限签名算法
      let enterpriseData = {
        corpid: res.data.corpId,
        agentid: res.data.agentId,
        ticket: res.data.ticket,
        nonceStr: noncestr,
        timestamp,
        url,
        signature,
      };
      console.log("enterpriseData++++1",enterpriseData);
      console.log("url++++1",url);
      window.localStorage.setItem("enterpriseData", JSON.stringify(enterpriseData));
      console.log("enterpriseData++++2",enterpriseData);
      console.log("url++++2",url);
      // wx.config({
      //   beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //   appId: res.data.corpId, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
      //   timestamp, // 必填，生成签名的时间戳
      //   nonceStr: noncestr, // 必填，生成签名的随机串
      //   signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
      //   jsApiList: ["selectExternalContact", "wwapp.invokeJsApiByCallInfo"], //必填，传入需要使用的接口名称
      // });
      // wx.ready(function(e){
      // // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      //   console.log("成功了没有",e);
      // })
      // wx.error(function(e){
      //   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      //   console.log("失败了吗",e);
      // })
      // 企业微信ios/mac 端如果出现 "wx.agentConfig undefined" 的报错，可将调用放在异步操作中进行，例如使用：setTimeout 包裹
      setTimeout(() => {
        console.log("enterpriseData++++3",enterpriseData);
        console.log("url++++3",url);
        console.log("agentConfigParams++++3",agentConfigParams);
        wx.agentConfig({
          // corpid:res.data.corpId,
          // agentid:res.data.agentId,
          // timestamp,
          // nonceStr:noncestr,
          // signature:sha1(
          //   `jsapi_ticket=${
          //     res.data.ticket
          //   }&noncestr=${noncestr}&timestamp=${timestamp}&url=${url}`
          // ),
          ...agentConfigParams,
          success: function (res) {
            // 回调
            resolve(res)
            console.log("成功", res);
          },
          fail: function (res) {
            reject(res)
            console.log("失败", res);
            if (res.errMsg.indexOf("function not exist") > -1) {
              alert("版本过低请升级");
            }
          },
        });
      });
    });
  });
}

// 获取今天时间
export function getToday() {
  let date = new Date();
  let y = date.getFullYear();
  let m =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  return y + "-" + m + "-" + d;
}

// 获取昨天的时间
export function getYesterday() {
  var date = new Date();
  date = new Date(date - 1000 * 60 * 60 * 24);
  var y = date.getFullYear();
  var m =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  return y + "-" + m + "-" + d;
}


/** 时间转换 （今天、昨天、周一至周日）*/
export function displayTimeStr(timeStr) {
  var day = new Date(timeStr).getDay();
  var time = new Date(timeStr).getTime();
  var timeNow = Date.parse(new Date());

  var timeDiffer = timeNow - time;
  if (timeDiffer <= 60000) {
    //一分钟内
    var returnTime = "刚刚";
  } else if (
    timeDiffer > 60000 &&
    timeDiffer < 86400000 &&
    this.isYesterday(time) === false
  ) {
    //今日
    var returnTime = "今天";
  } else if (timeDiffer > 60000 && this.isYesterday(time) === true) {
    //昨天
    var returnTime = "昨天";
  } else if (timeDiffer >= 86400000 && timeDiffer < 60000 * 60 * 24 * 7) {
    var returnTime = "星期" + "日一二三四五六".charAt(day);
  } else var returnTime = timeStr;

  return returnTime;
}


// 扁平化数组
export function handleFlat(list) {
  list.forEach((item) => {
    if (item.menus.length <= 0) {
      this.flatList.push({ menuName: item.menuName, menuId: item.menuId });
    } else {
      this.handleFlat(item.menus);
    }
  });
}

/**判断是否为空 */
export function checkEmpty(value) {
  switch (typeof value) {
    case 'undefined':
      return true
    case 'string':
      if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
      break
    case 'boolean':
      if (!value) return true
      break
    case 'number':
      if (value === 0 || isNaN(value)) return true
      break
    case 'object':
      if (value === null || value.length === 0) return true
      for (const i in value) {
        return false
      }
      return true
  }
  return false
}

  /**
 * 用于页面显示数据格式化，当数据为有误时候显示'--'
 * @param {number | string} val  需要处理的数据
 */
  export function pageValueShow(val) {
    if (Object.prototype.toString.call(val) === '[object String]' && val !== '') {
      return val
    } else if (
      Object.prototype.toString.call(val) === '[object Number]' &&
      !isNaN(val)
    ) {
      return val
    } else {
      return '--'
    }
  }


  /**
   * 时间格式化
   * @param {any}  dateTime 需要格式化的时间，不传默认当前时间，当接收的数据隐式转换为false时候，则会返回'--'
   * @param {string} fmt 需要进行格式化的格式，yyyy:mm:dd|yyyy:mm|yyyy年mm月dd日|yyyy年mm月dd日 hh时MM分等,可自定义组合
   */
  export function timeFormat(dateTime = Number(new Date()), fmt) {
    // 如果为null,则格式化当前时间
    // if (!dateTime) dateTime = isNullShowNowTime? Number(new Date()):'--'
    if (!dateTime) return '--'
    // 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
    if (dateTime.toString().length == 10) dateTime *= 1000
    if (dateTime.toString().length == 13) dateTime = Number(dateTime)
    let date = new Date(dateTime)
    let ret
    let opt = {
      'y+': date.getFullYear().toString(), // 年
      'm+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'h+': date.getHours().toString(), // 时
      'M+': date.getMinutes().toString(), // 分
      's+': date.getSeconds().toString(), // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (let k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
        ) 
      }
    }
    return fmt
  }


    /**两对象解构赋值 
     * @param options 被赋值的对象
     * @param assignObj 要赋值的对象
     * @param filterKeyArr 要过滤的key 数组结构
  */
    export function  objectAssignVal(options, assignObj, filterKeyArr) {
      if (typeof (options) == 'object' && typeof (assignObj) == 'object') {
        if (filterKeyArr && Object.prototype.toString.call(filterKeyArr) != '[object Array]') {
          console.warn('入参结构异常6，解构赋值失败');
          return
        }
        const CopyObj = JSON.parse(JSON.stringify(assignObj))
        for (const key in options) {
          if (Object.prototype.hasOwnProperty.call(options, key)) {
            if (filterKeyArr && filterKeyArr.some(v => { return v == key })) {
              // 过滤
            } else {
              key in CopyObj ? options[key] = CopyObj[key] : ''
  
            }
          }
        }
        return options
      } else {
        console.warn('入参结构异常，解构赋值失败');
      }
    }